/*
  created by jl - 2018/03/01
 */

var geo_location_cookie_name = '9k8KDFG23jIT5BNmwd83jflp28fj';
var geo_country = getCookie(geo_location_cookie_name);
var location_cookie_name = 'L923DF8dff830dfj2ft3f82mvhao4';
var current_location = getCookie(location_cookie_name);
var current_state = 'dom'; //TODO: use the "state" variable to decide if the UI needs to be updated or not.

var dom_int_component_open_button = $('.toggle_label, .toggle_icon');
var dom_int_toggle_component_container = $('.dom-int-toggle-component');
var clicked_dom_int_toggle;

$(document).ready(function(){
	var do_check_location = ($('#dom_int_toggle_show_input').val() == 'true');
	var is_international_directory_page = checkUrlForInternational();

	if(do_check_location) {
		if(!geo_country && !current_location) {
			if(is_international_directory_page) {
				updateDomIntContentUI('int');
				updateOrSetDomIntCookie('int');
                setToolTipValue('int');
			} else {
				//GeoLocation not set, so set it
				setTimeout(function(){ 
					setGeoLocation(geo_location_cookie_name, 90);
				}, 2000);
			}
	    }
	    else {
	    	if(current_location && current_location.indexOf('international') > -1) {
	    		updateDomIntContentUI('int');
                setToolTipValue('int');
	    	} else {
	    		updateDomIntContentUI('dom');
                setToolTipValue('dom');
	    	}
	    }
	}
	else {
		if(is_international_directory_page) {
			updateDomIntContentUI('int');
			updateOrSetDomIntCookie('int');
		} else {
			updateDomIntContentUI('dom');
		}
	}

	dom_int_component_open_button.on("click", function () { 
		clicked_dom_int_toggle = $(this).closest('.dom-int-toggle-component');
		openToggleComponentModal();
		
	    return false;
	});

	//Help with tab indexes
	//TODO(JD): Restructure the HTML and CSS to allow these to tab properly
	$(document).on('keyup', '.locationswitch_yellow_button',function(e){
	    if(e.which==13 || e.which==32) {
	    	$(this).closest('.dom_int_toggle').click();
	    }
	});
}); //End document.ready function

//Check the current location pathname to see if it is under the international directory, if it is, return true
function checkUrlForInternational() {
	var current_location_pathname = window.location.pathname;
	var international_pathname = "/international";
	var international_pathname_content_root = "/content/flinders/en/international"; //If, for some reason, someone uses the long-form url.
	
	if (current_location_pathname && (current_location_pathname.indexOf(international_pathname) == 0 || current_location_pathname.indexOf(international_pathname_content_root) == 0)) {
		return true;
	}
	return false;
}

$('.change_to_domestic').on('click', function() {
	updateDomIntContentUI('dom');
	updateOrSetDomIntCookie('dom');
});
$('.change_to_international').on('click', function() {
	updateDomIntContentUI('int');
	updateOrSetDomIntCookie('int');
});


$('body').on('click', '.domesticSwitch', function(e) {
	updateDomIntContentUI('dom');
	updateOrSetDomIntCookie('dom');
	updateSubMenusOrRedirect('dom');
	hideTooltip();
    closeToolTip();
});

$('body').on('click', '.internationalSwitch', function() {
	updateDomIntContentUI('int');
	updateOrSetDomIntCookie('int');
	updateSubMenusOrRedirect('int');
	hideTooltip();
    closeToolTip();
});

$('#intlNavMobile').on('click', function() {
	updateDomIntContentUI('int');
	updateOrSetDomIntCookie('int');
	updateSubMenusOrRedirect('int');
    $('.header_burger').click();
});
$('#domNavMobile').on('click', function() {
	updateDomIntContentUI('dom');
	updateOrSetDomIntCookie('dom');
	updateSubMenusOrRedirect('dom');
    $('.header_burger').click();
});

function updateOrSetDomIntCookie(action) {
	var result = false;
	if(action === 'int') {
		result = setCookie(location_cookie_name, 'international', 90, 'overwrite');
	}
	else {
		result = setCookie(location_cookie_name, 'domestic', 90, 'overwrite');
	}
	return result;
}

//Accepting an "action" as a string (either 'dom' or 'int') will update all UI elements relating to the toggles in the header menu
function updateDomIntHeaderMenuToggleUI(action) {
	//TODO this still requires cleanup!

	if(action === 'dom') {
		$('.domesticSwitch').addClass("active");
        $('.internationalSwitch').removeClass("active");
        $('.domIntIcons svg:first-child').show();
        $('.domIntIcons svg:nth-child(2)').hide();
		//desktop
        $("#dom_int_toggle_icon_domestic").show();
        $("#dom_int_toggle_icon_international").hide();
        //mobile
        $('#domStudent').css("background-color", "#ffd300");
        $('#intlStudent').attr("style", "");
        $('#intlNavMobile').removeClass("active");
        $('#domNavMobile').addClass("active");
    } else if (action === 'int') {
    	$('.internationalSwitch').addClass("active");
        $('.domesticSwitch').removeClass("active");
        $('.domIntIcons svg:nth-child(2)').show();
        $('.domIntIcons svg:first-child').hide();
    	//desktop
        $("#dom_int_toggle_icon_domestic").hide();
        $("#dom_int_toggle_icon_international").show();
        //mobile - Work in progress
        $('#intlStudent').css("background-color", "#ffd300");
        $('#domStudent').attr("style", "");
        $('#intlNavMobile').addClass("active");
        $('#domNavMobile').removeClass("active");
    } else {
    	console.log('something went wrong :(');
    }
            
	return false;
}


//MAIN DOMESTIC/INTERNATIONAL CONTENT AND UI UPDATER (***NOT USED FOR UPDATING COOKIES!***)
//Accepting an "action" as a string (either 'dom' or 'int') - updates the display of content relevant to domestic or international students
//Will control the update of...
//- All dom/int content within the page (i.e. things labelled with .domestic_content and/or .international_content)
//- The Fast Facts UI
//- The Header Menu Dom/Int toggle UI
//- The Mobile Menu Dom/Int toggle UI
function updateDomIntContentUI(action) {
	current_state = action;
	var all_domestic_content = $('.domestic_content');
	var all_international_content = $('.international_content');
	//TODO - JD: Maybe move selector for is_course_page into FF UI update function
	var is_course_page = $('.course_pages').length > 0;
	var is_authoring = $('.aem_author_mode').length > 0;
	
	var has_dom_int_toggle_component = dom_int_toggle_component_container.length > 0;
	
	var all_hideable_course_page_content = $('.course_page_content_section:not(.never_hide)');
	var course_is_domestic_available = $('.course_pages').hasClass('is_domestic');
	var course_is_international_available = $('.course_pages').hasClass('is_international');
	var hide_invalid_information = (!course_is_domestic_available && action === 'dom') || (!course_is_international_available && action === 'int')

	if(is_authoring) {
		//show all dom and int content when authoring...for better or worse.
		all_domestic_content.show();
		all_international_content.show();
		//And just show default domestic header menu stuff when authoring
		updateDomIntHeaderMenuToggleUI('dom');
		updateToggleComponentUI('dom');
		all_hideable_course_page_content.show();
	} 
	else {
		//Not authoring
		if(is_course_page) {
			updateFastFactsUI(action);
			if(hide_invalid_information) {
				all_hideable_course_page_content.hide();
			} else {
				all_hideable_course_page_content.show();
			}
		}
		updateDomIntHeaderMenuToggleUI(action);
		
		if(has_dom_int_toggle_component) {
			updateToggleComponentUI(action);
		}
		if(action === 'dom') {      
			all_international_content.hide();
			all_domestic_content.show();
	    } else if (action === 'int') {            	
			all_domestic_content.hide();
			all_international_content.show();
	    } else {
	    	console.log('something went wrong :(');
	    }
	}     
	return false;
}

//Relating to study areas domestic/international menus and dom/int menus on  course pages
//UI updates will check the response of this function before proceeding
function updateSubMenusOrRedirect(action) {
	//Will handle redirects based on location and also dom/int content menu changes
	var is_course_page = $('.course_pages').length > 0;

	if(is_course_page) {
		//It is a course page, so do the stuff for that!
	} 
	else {
		//Only check if it is not a course page
		var location_to_change_to = getRedirectPartnerUrl(action);
		if(location_to_change_to) {
			//Change the window location
			window.location = location_to_change_to;
		}
	}

	return false;
}

//returns the location to move to if it exists
function getRedirectPartnerUrl(action) {
	var dom_redirect_input = $('#dom_redirect_url');
	var int_redirect_input = $('#int_redirect_url');

	if(action === 'dom' && dom_redirect_input.length) {
		return dom_redirect_input.val();
	}
	if(action === 'int' && int_redirect_input.length) {
		return int_redirect_input.val();
	}
	
	return false;
}


//Code relating to the stand alone dom-int-toggle-component
function openToggleComponentModal() {
	
	clicked_dom_int_toggle.addClass('toggle_open');
	clicked_dom_int_toggle.find('.dom_int_modal_overlay , .dom_int_modal').fadeIn(function() {
    	//Focus the currently selected item
		clicked_dom_int_toggle.find('.option_container:not(.selected) .option_button').focus();	    	
    });
	
    //Bind the escape key when the modal is opened so it can close the modal
    //NOTE: REMEMBER TO UNBIND THIS "closeModalSwitchContent()" DOES THIS
    //NOTE: If this does not work in all browsers, extend it here
    $(document).on('keydown.dom_int_modal_escape',function(e){
        if(e.which==27)
        {
        	closeDomIntModalSwitchContent('close');
            
        }
    });
    //Bind the document click event and use it's target to decide what to do
    $(document).on('click.d_i_modal', function(e) {
        var click_target = $(e.target);
        var option_container_clicked = click_target.closest('.option_container');
        
        
        if (!click_target.closest('.dom_int_modal').length) {
        	closeDomIntModalSwitchContent('close');
        	
        } 
        else if (option_container_clicked.hasClass('domestic_option')){
        	if(!option_container_clicked.hasClass('selected')) {
        		closeDomIntModalSwitchContent('dom');
        	} else {
        		closeDomIntModalSwitchContent('close');
        	}
        	
        } 
        else if (option_container_clicked.hasClass('international_option')){
        	if(!option_container_clicked.hasClass('selected')) {
        		closeDomIntModalSwitchContent('int');
        	} else {
        		closeDomIntModalSwitchContent('close');
        	}
        	
        } else {
        	closeDomIntModalSwitchContent('close');
        }
    });
    //Because buttons are hard...
    $('.option_button').on("click.d_i_modal_button", function () { 
		var option_container_clicked = $(this).closest('.option_container');

		if (option_container_clicked.hasClass('domestic_option')){
        	if(!option_container_clicked.hasClass('selected')) {
        		closeDomIntModalSwitchContent('dom');
        	} else {
        		closeDomIntModalSwitchContent('close');
        	}
        } 
		else if (option_container_clicked.hasClass('international_option')){
        	if(!option_container_clicked.hasClass('selected')) {
        		closeDomIntModalSwitchContent('int');
        	} else {
        		closeDomIntModalSwitchContent('close');
        	}
        } 
		else {
        	closeDomIntModalSwitchContent('close');
        }
		return false;
	});

}

function closeDomIntModalSwitchContent(action) {
	var the_modal_to_close = $('.dom_int_modal_overlay , .dom_int_modal');
	
	dom_int_toggle_component_container.removeClass('toggle_open');
    if(action === 'dom') {  
		updateDomIntContentUI('dom');
		updateOrSetDomIntCookie('dom');
		the_modal_to_close.delay(before_fade_delay).fadeOut();
    } 
    else if (action === 'int') {    
		updateDomIntContentUI('int');
		updateOrSetDomIntCookie('int');
		the_modal_to_close.delay(before_fade_delay).fadeOut();
        
    } 
    else if (action === 'close') {            	
    	the_modal_to_close.fadeOut();
    } 
    else {
    	the_modal_to_close.fadeOut();
    }
    
    //Unbind events
    $(document).off('click.d_i_modal');
    $(document).off('click.d_i_modal_button');
    $(document).off('keydown.dom_int_modal_escape');
	return false;
}

//Takes care of updating the UI of the stand-alone drag-and-drop domestic/international toggle component
//Accepts an action of 'dom' or 'int' denoting the direction of the change.
function updateToggleComponentUI(action) {
	var toggle_int_option_container = dom_int_toggle_component_container.find('.international_option');
	var toggle_dom_option_container = dom_int_toggle_component_container.find('.domestic_option');
	var toggle_labels_to_update = dom_int_toggle_component_container.find('.toggle_label');
	
    if(action === 'dom') {  
		toggle_labels_to_update.addClass('domestic_colour').removeClass('international_colour');
		dom_int_toggle_component_container.find('.toggle_link_international').hide();
		dom_int_toggle_component_container.find('.toggle_link_domestic').show();
		toggle_dom_option_container.addClass('selected');
		toggle_int_option_container.removeClass('selected');

    } 
    else if (action === 'int') {    
		toggle_labels_to_update.removeClass('domestic_colour').addClass('international_colour');
		dom_int_toggle_component_container.find('.toggle_link_domestic').hide();
		dom_int_toggle_component_container.find('.toggle_link_international').show();
		toggle_dom_option_container.removeClass('selected');
		toggle_int_option_container.addClass('selected');
        
    } 
    else {
    	the_modal_to_close.fadeOut();
    }

	return false;
}

// START --> To add custom class to Tooltip used in DomIntl Switch to make it exclusive; Ref: https://stackoverflow.com/questions/13160357/adding-custom-class-to-tooltip
;(function($) {

    if (typeof $.fn.tooltip.Constructor === 'undefined') {
        throw new Error('Bootstrap Tooltip must be included first!');
    }

    var Tooltip = $.fn.tooltip.Constructor;

    // add customClass option to Bootstrap Tooltip
    $.extend( Tooltip.Default, {
        customClass: ''
    });

    var _show = Tooltip.prototype.show;

    Tooltip.prototype.show = function () {

        // invoke parent method
        _show.apply(this,Array.prototype.slice.apply(arguments));

        if ( this.config.customClass ) {
            var tip = this.getTipElement();
            $(tip).addClass(this.config.customClass);
        }

    };

})(window.jQuery);
// END <-- To add custom class to Tooltip used in DomIntl Switch to make it exclusive; Ref: https://stackoverflow.com/questions/13160357/adding-custom-class-to-tooltip
var domestic_colour_class = 'domestic_colour';
var international_colour_class = 'international_colour';
var fast_facts_dom_int_toggle_container = $('.ff_toggle_options');
var fast_facts_bottom_container = $('.fast_facts_bottom_container');
var fast_facts_int_option = fast_facts_dom_int_toggle_container.find('#ff_modal_int_option');
var fast_facts_dom_option = fast_facts_dom_int_toggle_container.find('#ff_modal_dom_option');
var toggle_button = $('.ff_toggle_label, .ff_toggle_icon');

var course_id_value = $('#course_id_input').val();
var course_name_value = $('#course_name_input').val();
var course_url_value = $('#course_url_input').val();

var save_course_label = $('.ff_save_course_label');
var save_course_icon = $('.ff_save_course_icon');
//Because I don't wanna miss these in a race condition some-how
var ff_course_page_cookie_name = 'ksdf8rmdfg9ksd934gmngLFQjhas08jsd7klsfHGFDAud';

var before_fade_delay = 500;

var jotforms_to_update = [];


function addQueryStringToPrepops(){
    var params = getAllQueryStringParams();
    for(var jotform_index = 0 ; jotform_index < jotforms_to_update.length; jotform_index++){
        var props = jotforms_to_update[jotform_index].props;
        for(var param_name in params){
            if(jotforms_to_update[jotform_index].utm_update && countsAsUTMField(param_name)){
                //if the form is set to receive saved utm_ fields *AND* the parameter is a utm_ param, it's set from the saved info
                //so we do nothing here
            }else{
                props[param_name] = params[param_name];
            }
        }
    }
}

function fixJotformPrepops(target){
    addQueryStringToPrepops();
	for(var index = 0 ; index < jotforms_to_update.length; index++)
	{
		var props = jotforms_to_update[index].props;
		var iframe = jotforms_to_update[index].iframe;
		if(props)
		{
			//TODO(Christof): make this work for drop downs (also check select elements) and check boxes/radio buttons? for now we really only care about the hidden fields so this is fine, but...
    		iframe.contents().find("input").each(function(index, element){
    			var found = false;
    			for(var prop in props)
   				{
   					var input_element_name = $(element).prop('name');
					if(input_element_name.indexOf(prop) != -1){
						if(input_element_name === prop || prop === input_element_name.substring(input_element_name.indexOf("_") + 1)) {
                            var NewValue = decodeURIComponent(props[prop]);
                            $(element).val(NewValue);
                            found = true;
                            break;
						}
					}   				
   				}
    			if(!found)
				{
    				//NOTE(Christof): since we are fixing the broken jotform prefiller, we need to clear any fields that aren't set
    				var value = element.getAttribute("value") || "";
    				$(element).val(value);
				}
    		});
		}
	}
}

function setupFastFactsTooltips() {
	//Handle tooltips for fastfacts
	var all_ff_tooltips = $(".fast_facts_tooltip_icon");
	var ff_tooltip_template = '<div class="tooltip ff_tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>';

	all_ff_tooltips.on("click focus", function (e) { 
		e.preventDefault();
	    return false;
	});
	//Apply tooltip settings
	all_ff_tooltips.tooltip({animation: true, container: '.fast_facts_tooltip_icon',placement:'top',trigger:"click hover focus", template: ff_tooltip_template});
}
$(document).ready(function () {	
	var is_course_page = $('.course_pages').length > 0;
	if(is_course_page) {
		setupFastFactsTooltips();
	}
	
	//This polyfill adds nodeList.forEach(callback[, thisArg]) compatibility to all Browsers supporting ES5
	//See: https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Browser_Compatibility
	//This specifically relates to IE deciding that forEach on a nodelist is not a thing it wants to support
	if (window.NodeList && !NodeList.prototype.forEach) {
	    NodeList.prototype.forEach = function (callback, thisArg) {
	        thisArg = thisArg || window;
	        for (var i = 0; i < this.length; i++) {
	            callback.call(thisArg, this[i], i, this);
	        }
	    };
	}

	//JOTFORMS OBSERVER
	//We need to fix the height of the iframes for jotforms because the 3rd party code is setting the first form in the DOM to 0 height
	//because the second form is hidden...
	var observer = new MutationObserver(function(mutations) {
	    mutations.forEach(function(mutationRecord) {
	        var inlineStyleChanged = mutationRecord.target.attributes.style.nodeValue;
	        if(inlineStyleChanged.indexOf('height: 0px') > -1) {
	        	//fixJotformHeights();
	        }
	    });
	});

	var targets = document.querySelectorAll('.jotform-form iframe');
	//fixJotformHeights();
	if(targets.length > 0) {
		targets.forEach(function(targetRecord) {
	        observer.observe(targetRecord, { attributes : true, attributeOldValue: true,  attributeFilter : ['style'] });
	    });
	}

	//END JOTFORMS OBSERVER


	//ff dom int toggle clicked
	toggle_button.on("click", function () {
		openFastFactsModal();

	    return false;
	});
	//ff_save_course_button
	//TODO: Check the cookies as well, maybe wait for response before changing the UI?
	$('.ff_save_course').on("click", function () {
		if($(this).hasClass('saved')) {
			//unsave course
			updateFastFactsSaveCourseUI('unsave');
			var result = setCookie(ff_course_page_cookie_name, course_id_value, 90, 'delete');
			//todo: add check here to check the value of the result and see if the cookie was properly deleted or saved
			console.log('attempted to UN-save cookie, result: ',result);
			updateSavedCourseListUI(course_id_value, 'unsave');
		}
		else {
			//save course
			updateFastFactsSaveCourseUI('save');
			var result = setCookie(ff_course_page_cookie_name, course_id_value, 90, 'append');
			console.log('attempted to save cookie, result: ',result);
			//todo: add check here to check the value of the result and see if the cookie was properly deleted or saved
			updateSavedCourseListUI(course_id_value, 'save');
		}
	    return false;
	});

	function openFastFactsModal() {
	    $('.ff_modal_overlay , .ff_modal').fadeIn(function() {
	    	//Focus the currently selected item
	    	$('.option_container:not(.selected) .ff_switch_button').focus();	    	
	    });

	    //Bind the escape key when the modal is opened so it can close the modal
	    //NOTE: REMEMBER TO UNBIND THIS "closeModalSwitchContent()" DOES THIS
	    //NOTE: If this does not work in all browsers, extend it here
	    $(document).on('keydown.ff_modal_escape',function(e){
	        if(e.which==27)
	        {
	            closeModalSwitchContent('close');
	            
	        }
	    });
	    //Bind the document click event and use it's target to decide what to do
	    $(document).on('click.ff_modal', function(e) {
	        var click_target = $(e.target);
	        var option_container_clicked = click_target.closest('.option_container');
	        
	        if (!click_target.closest('.ff_modal').length) {
	        	closeModalSwitchContent('close');
	        	
	        } else if (option_container_clicked.prop('id') === 'ff_modal_dom_option'){
	        	if(!option_container_clicked.hasClass('selected')) {
	        		closeModalSwitchContent('dom');
	        	} else {
	        		closeModalSwitchContent('close');
	        	}
	        	
	        } else if (option_container_clicked.prop('id') === 'ff_modal_int_option'){
	        	if(!option_container_clicked.hasClass('selected')) {
	        		closeModalSwitchContent('int');
	        	} else {
	        		closeModalSwitchContent('close');
	        	}
	        	
	        } else {
	        	closeModalSwitchContent('close');
	        }
	    });

	}
	
	//Because there is some js preventing buttons doing their thing:
	$('.ff_switch_button').on("click", function () { 
		var closest_option_container = $(this).closest('.option_container');
		var id_of_option_clicked = $(this).prop('id');

		if(id_of_option_clicked === 'ff_modal_int_option_button') {
			if(!closest_option_container.hasClass('selected')) {
        		closeModalSwitchContent('int');
        	} else {
        		closeModalSwitchContent('close');
        	}
		} else if(id_of_option_clicked === 'ff_modal_dom_option_button') {
			if(!closest_option_container.hasClass('selected')) {
        		closeModalSwitchContent('dom');
        	} else {
        		closeModalSwitchContent('close');
        	}
		} else {
			console.log("something went wrong :(");
		}
		return false;
	});
	
	function closeModalSwitchContent(action) {
		var result = '';
        if(action === 'dom') {  
			updateDomIntContentUI('dom');
    		result = updateOrSetDomIntCookie('dom');
    		hideTooltip();
    		closeToolTip();
    		//console.log('attempt to set location cookie to domestic, result: ',result);
        	$('.ff_modal_overlay , .ff_modal').delay(before_fade_delay).fadeOut();
        } else if (action === 'int') {    
			updateDomIntContentUI('int');
    		result = updateOrSetDomIntCookie('int');
    		hideTooltip();
    		closeToolTip();
    		//console.log('attempt to set location cookie to international, result: ',result);
        	$('.ff_modal_overlay , .ff_modal').delay(before_fade_delay).fadeOut();
            
        } else if (action === 'close') {            	
        	$('.ff_modal_overlay , .ff_modal').fadeOut();
        } else {
        	$('.ff_modal_overlay , .ff_modal').fadeOut();
            
        }
        //Unbind events
        $(document).off('click.ff_modal');
        $(document).off('keydown.ff_modal_escape');
    	return false;
    }

	
	
	//Applies some styles to all jotforms to fix an issue with 3rd party code
	function fixJotformHeights() {
		 $('.jotform-form iframe').css('height', '');
    	return false;
    }
	
	

});

//Accepts an argument of "int" or "dom" to update just the domestic and international content of the fast facts UI.
function updateFastFactsUI(action) {
	
    if(action === 'dom') {            	
    	fast_facts_dom_int_toggle_container.find('.ff_toggle_label').addClass(domestic_colour_class).removeClass(international_colour_class);
		fast_facts_bottom_container.addClass(domestic_colour_class).removeClass(international_colour_class);
		fast_facts_dom_option.addClass('selected');
		fast_facts_int_option.removeClass('selected');
    } else if (action === 'int') {            	
    	fast_facts_dom_int_toggle_container.find('.ff_toggle_label').removeClass(domestic_colour_class).addClass(international_colour_class);
		fast_facts_bottom_container.removeClass(domestic_colour_class).addClass(international_colour_class);
		fast_facts_dom_option.removeClass('selected');
		fast_facts_int_option.addClass('selected');
    } else {
    	console.log('something went wrong :(');
    }
    
	//Check cookies and update the save course buttons in the fast facts component
	var all_saved_courses = getCookie(ff_course_page_cookie_name);
	if(all_saved_courses && all_saved_courses.split(',').indexOf(course_id_value) > -1) {
		updateFastFactsSaveCourseUI('save');
	} else {
		updateFastFactsSaveCourseUI('unsave');
	}
            
	return false;
}


//Updates just the UI of the fast facts component
//Accepts a string "action" with a value of "save" or "unsave"
function updateFastFactsSaveCourseUI(action) {
	
	if(action === 'unsave' || action === 'delete') {
		//Unsaved
		save_course_label.removeClass('saved');
		save_course_icon.removeClass('saved');
		
		save_course_label.text('Save course');
		save_course_icon.find('.save_course_heart_filled').hide();
		save_course_icon.find('.save_course_heart_empty').show();
		
	} else {
		//Saved
		save_course_label.addClass('saved');
		save_course_icon.addClass('saved');
		
		save_course_label.text('Unsave course');
		save_course_icon.find('.save_course_heart_empty').hide();
		save_course_icon.find('.save_course_heart_filled').show();
	}
	return false;
}

//Used for udating the course list when a course is saved via the Fast Facts component or when one is deleted
//Accepts a course id and also an action "save" or "unsave"
//TODO: Investigate if the function getCourseBookmark() can be used to get a list of valid courses (current version of this function uses purely front-end means - that way a course you are currently on will (almost) always be added to the list, even if it fails the back-end validation
function updateSavedCourseListUI(course_id, action) {
	
	//Check if there are other courses in the cookie, if yes, just remove the one unsaved, if no, show the thing in the place of none
	//Note: Using cookie because list html code is duplicated on the page...
	var all_saved_courses = getCookie(ff_course_page_cookie_name);
	var other_courses_saved = false;
	var course_row_in_lists = $('.courseBookmarkRow'+course_id);
	var menu_icon_container = $('.course_bookmark_menu_container');
	var course_bookmark_menu_list_container = $('.course_bookmark_menu_list_container');
	var course_bookmark_menu_list_container_empty = $('.course_bookmark_menu_list_container_empty');

	if(all_saved_courses && all_saved_courses.split(',').length >= 1) {
		other_courses_saved = true;
	} else {
		other_courses_saved = false;
	}
	
	if(action === 'unsave' || action === 'delete') {
		//Unsaved
		menu_icon_container.show();
		course_row_in_lists.slideUp(500, function() {
		    $(this).remove();
		    
		    if(other_courses_saved) {
				//course list has other things in it
				course_bookmark_menu_list_container.show();
				course_bookmark_menu_list_container_empty.hide();
			}
			else {
				//course list is empty
				course_bookmark_menu_list_container.hide();
				course_bookmark_menu_list_container_empty.show();
			}
		});
		
	} else {
		//Saved
		//Add course to list
		menu_icon_container.show();
		course_bookmark_menu_list_container_empty.hide();
		course_bookmark_menu_list_container.show();
		var course_to_add_to_lists = {"courseId": course_id,  "courseName": course_name_value,  "courseLink": course_url_value };
		//This line uses handlebars.js which is included in a clientlib so there is a chance there is a race condition??
		$(".courseBookmarkTarget").append(Handlebars.compile($("#courseBookmarkBaseMenu").html())(course_to_add_to_lists));
	}
	return false;
}

//setGeoLocation("cookie-name-here", "cookie-value-here", cookie-expiry-here);
/*
 name: string
 expiry: integer (in days. 0 which means no expiry)
*/
var cookie_expire_int = 90;
var dom_int_tooltip_cookie_name = "tooltip_closed";

function checkIPGeolocation(success, failure)
{
    //Don't do the geolocation check if we're in authoring mode - this will still fire on "View as Published"
    var is_authoring = $('.aem_author_mode').length > 0;
    if(is_authoring){
        return;
    }
	$.ajax({
        method: "GET",
        url: '/flinders-services/ip-geolocate',
    }).done(function (data){
    	console.log("Got geolocation response from server", data);
    	setCookie(dom_int_tooltip_cookie_name, "no", cookie_expire_int, "overwrite");
    	if(data.success)
    	{
    		var location = data.domestic? 'dom':'int';
		    updateOrSetDomIntCookie(location);
		    updateDomIntContentUI(location);
		    setToolTipValue(location);
		    if(typeof(success) == "function")
			{
		    	success();
			}
    	}
    	else
    	{
    		if(typeof(failure) == "function")
			{
    			console.log("IP detection failed, using fallback");
    			failure();
			}
    		else
    		{
    			console.error("IP detection failed, no fallback available!");
    		}
    	}
    });	
}

function setGeoLocation(name, expiry) {
	console.log('Attempting to get geolocation...');
	var geo_location_result = 'AU';
	var current_geo_cookie = getCookie(name);
	var location_settings_enabled = ("geolocation" in navigator);
	var location_has_been_decided = false;
    if (!current_geo_cookie || current_geo_cookie.length === 0) {
    	checkIPGeolocation(function(){
    		location_has_been_decided = true;
    	},
    	function(){
	        if (location_settings_enabled && navigator.geolocation) {
	        	try {            	
	            	navigator.geolocation.getCurrentPosition(
	                    function(position) {
	                		$.ajax({
	                            method: "GET",
	                            url: "https://maps.googleapis.com/maps/api/geocode/json",
	                            data: { latlng:position.coords.latitude+","+position.coords.longitude, sensor: false, key: "AIzaSyCk31-dxBJJw86bIKdhDkdJjgZ7nTp1dOs" }
	                        }).done(function( data ) {
	                        	geo_location_result = data.results[data.results.length - 1].address_components[0].short_name;
	                            setCookie(name, geo_location_result , expiry, "overwrite");
	                            updateAllForLocation(geo_location_result);
	                            location_has_been_decided = true;
	                        });
	                    }, 
	                    function(error) {
	                    	console.log('Error - navigator.geolocation.getCurrentPosition failed: Defaulting to domestic.',error);
	                    	geo_location_result = 'AU';
	                        setCookie(name, geo_location_result, expiry, "overwrite");
	                        updateAllForLocation(geo_location_result);
	                        location_has_been_decided = true;
	                    }, 
	                    {timeout: 12000}
	                );
	        	}
	        	catch(err) {
	        		console.log('Error when trying to get location. Defaulting to Domestic.', err);
	        		setCookie(name, geo_location_result, expiry, "overwrite");
	                updateAllForLocation(geo_location_result);
	                location_has_been_decided = true;
	        	}
	            
	        } else {
	        	console.log('Warning - location services disabled!');
	            setCookie(name, geo_location_result, expiry, "overwrite");
	            updateAllForLocation(geo_location_result);
	            location_has_been_decided = true;
	        }
    	});
    }
    else {
    	console.log('Warning - geolocation cookie already set! ');
    	setCookie(name, geo_location_result, expiry, "overwrite");
        updateAllForLocation(geo_location_result);
        location_has_been_decided = true;
    }
    
    //if all else fails...check again!!
    setTimeout(function(){ 
    	//console.log('Checking if geolocation has been decided...');
    	if(location_has_been_decided) {
        	//console.log('...it has');
    	}
    	else {
    		//console.log('...it has not...setting to defaults');
    		setCookie(name, geo_location_result, expiry, "overwrite");
            updateAllForLocation(geo_location_result);
            location_has_been_decided = true;
    	}
	}, 3000);
}
// To hide DomIntl Tooltip on Switch selection
function hideTooltip(){
    if($('.domIntlToolTip').is(':visible')){
        $('.domIntIcons').tooltip('hide');
    }
}
// DomIntl Tooltip Close btn functionality
function closeToolTip() {
    $('body .tooltip').hide();
    setCookie(dom_int_tooltip_cookie_name, "yes", cookie_expire_int, "overwrite");
};

function updateAllForLocation(location) {
	setCookie(dom_int_tooltip_cookie_name, "no", cookie_expire_int, "overwrite");
	if (!location || location.toUpperCase() === "AU" || location.toUpperCase() === "NZ") {
        updateOrSetDomIntCookie('dom');
        updateDomIntContentUI('dom');
        setToolTipValue('dom');
        
    } else {
        updateOrSetDomIntCookie('int');
        updateDomIntContentUI('int');
        setToolTipValue('int');
    }
}

// To set Tooltip on screen
function setToolTipValue(action){
	setTimeout(function(){ 
		var domIntlText;
	    var tooltip_cookie = getCookie(dom_int_tooltip_cookie_name);
	    var dom_int_tooltip_not_closed = (tooltip_cookie && tooltip_cookie.indexOf('no') > -1);
	    var dom_int_toggle_is_shown = ($('#dom_int_toggle_show_input').val() == 'true');
	    var page_type = $("#conversation_feed_page_type").val();
	    if(action === 'dom'){
	        domIntlText = "domestic student";
	    } else{
	        domIntlText = "international student";
	    }
	    var alertMessage = "You are viewing  <b style='color:#ffd300;'>"+domIntlText+"</b> information. <br/> If this isn't correct, you can change it here.";
	    if (dom_int_toggle_is_shown && dom_int_tooltip_not_closed && !$('.yellow_header .tooltip').length && page_type != 'staff_profile') {
	    	var dom_int_icon_container = $('.navigation-global .domIntIcons');
	    	dom_int_icon_container.attr('data-original-title', alertMessage).tooltip({container: "#dom_int_icon_container", trigger: 'manual',placement:'bottom',offset:"20 0"}).tooltip('show').tooltip('show');
	        // To combat double close btns
	        if( !$('.tooltip .close').length ) {
	            $('.tooltip').append('<button type="button" class="close" tabindex="0" onclick="closeToolTip();">&times;</button>');
	        }
	    }
	}, 1000);
    
}
/*
    created by jl - 2018-02-13
*/

/*
 getCookie("cookie-name-here");
 name: string
 */
//TODO: Change this to "getCookieByName(name)"
//TODO: move all cookie strings into an array here and give them human-readable alternatives that can be called in the functions i.e. "getCookieByName('geo-location')"
function getCookie(name) {
    var array = document.cookie.split(";");

    for (var i = 0; i < array.length; i++) {
        var parts = array[i].split('=');

        if (parts.length == 2 && parts[0].trim() == name) {
            return  parts[1].replace(/[^a-z0-9,]/gi, "");
        }
    }

    return false;
}

/*
 setCookie("cookie-name-here", "cookie-value-here", cookie-expiry-here, "operation-here");
 name: string
 value: string
 expiry: integer (in days. 0 which means no expiry)
 operation: string | can be append, delete or overwrite. default is overwrite
 */
function setCookie(name, value, expiry, operation) {
    var date = new Date();
    var expires;
    var path = "; path=/";
    var gdpr_opt_in_cookie_name = "gdpr_opted_in";

    var cookie;

    //accepts only alphanumeric values
    value = value.replace(/[^a-z0-9,]/gi, "");

    if (name.trim().length > 0 && value.trim().length > 0) {
        switch (operation) {
            case "append":
                cookie = name + "=" + appendValueToCookie(name, value);

                break;
            case "delete":
                cookie = name + "=" + deleteValueFromCookie(name, value);

                break;
            default:
                cookie = name + "=" + value;

                break;
        }

        if (expiry != null && expiry > 0) {
            date.setTime(date.getTime() + (expiry * 24 * 60 * 60 * 1000));

            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        if(!checkCookiesForOptIn(gdpr_opt_in_cookie_name)) {
            console.log("Warning: Opt-in not accepted, so cookie will not be persisted!", name);
            //Do some closure magic to keep the value of expires BEFORE we change it
            var setCookie = (function(inner_expires){ return function(){
                //console.log("Setting cookie "+name+" to "+value+" post GDPR opt in! expires: "+inner_expires);
                document.cookie = cookie + inner_expires + path;
            } })(expires);
            RegisterPostGDPRHook(setCookie);
            expires = "; expires=Thu, 01-Jan-1970 00:00:01 GMT";
        }

        document.cookie = cookie + expires + path;

        return {code:1, message:"success", name: name, value: value, action: operation};
    } else {
        return {code:0, message:"cookie name/value are not available"};
    }
}

function appendValueToCookie(name, value) {
    var currentCookie = getCookie(name);

    if (currentCookie.length > 0) {
        if (currentCookie.split(",").indexOf(value) == -1) {
            return currentCookie + "," + value;
        } else {
            return currentCookie;
        }
    }

    return value;
}

function deleteValueFromCookie(name, value) {
    var currentCookie = getCookie(name);

    if (currentCookie.length > 0) {
        return currentCookie.replace(value, "").replace(/^,/, "").replace(/,$/, "").replace(",,", ","); //extra replace removes leading/ending comma and double commas
    }
}

$(document).ready(function() {
    PageIsLoaded = true;
    if(typeof gdpr_delayed_function === 'function')
    {
        gdpr_delayed_function();
    }

});



$('#gdpr_accept_button, #gdpr_reject_button, .gdpr_opt_in_button').on('click', function () {
    var gdpr_notification_container = $('#gdpr_notification_container');
    setOptInCookie(gdpr_opt_in_cookie_name,'true',gdpr_opt_in_cookie_duration);

    if(checkCookiesForOptIn(gdpr_opt_in_cookie_name)) {
        $('body').removeClass("gdpr-shown"); //Only need to remove this class when a user clicks on the button because it shouldn't be added if they have already opted in
        gdpr_notification_container.fadeOut();
        /* For global header to move it back to the top */
        var global_header_top = $('.header_site').offset().top + 25;
        $('.global_header').css("top", global_header_top);
        handlePolicyOptIn();
    } else {
        console.log("Warning: Did not hide notification because it was not actually accepted! Maybe cookies are disabled?");
    }
});

$('.gdpr_opt_out_button').on('click', function () {
    handlePolicyOptOut();
});



function setOptInCookie(name,value,days) {
    var expires = "";
    var domain = "";
    var host = window.location.host;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    //This will allow non-flinders domains to have the cookies saved, like localhost and dev/test author
    if(host.indexOf(".flinders.edu.au") > 1 ) {
        domain = "; domain=.flinders.edu.au";
    }
    document.cookie = name + "=" + (value || "")  + expires + domain +"; path=/";
}


//Attempt to delete all cookies!
function deleteAllCookies() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++)
    {
        var split_cookie =  cookies[i].split("=");
        deleteCookieFromAllPaths(split_cookie[0]);
    }
}

//Note: does not delete cookies that are httpOnly, but does try to delete for variants of the path. (Note: most of our cookies have path "/" set.)
function deleteCookieFromAllPaths(name) {
    var split_path_array = location.pathname.split('/');
    var current_path = ' path=';
    document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;';

    for (var i = 0; i < split_path_array.length; i++) {
        current_path += ((current_path.substr(-1) !== '/') ? '/' : '') + split_path_array[i];
        document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;' + current_path + ';';
    }
}


$(function () {
    var offset = 64;
    if($(".sub_site_header").length) {
        offset = 70;
    }
    $.getHeaderTopOffset = $.fn.getHeaderTopOffset = function () {

        var breadcrumbOffsetTop = $('.header-tail').offset().top;
        var headerOffsetTop = breadcrumbOffsetTop - offset - 1;

        return headerOffsetTop;
    }
});

/**
 * menu-aim is a jQuery plugin for dropdown menus that can differentiate
 * between a user trying hover over a dropdown item vs trying to navigate into
 * a submenu's contents.
 *
 * menu-aim assumes that you have are using a menu with submenus that expand
 * to the menu's right. It will fire events when the user's mouse enters a new
 * dropdown item *and* when that item is being intentionally hovered over.
 *
 * __________________________
 * | Monkeys  >|   Gorilla  |
 * | Gorillas >|   Content  |
 * | Chimps   >|   Here     |
 * |___________|____________|
 *
 * In the above example, "Gorillas" is selected and its submenu content is
 * being shown on the right. Imagine that the user's cursor is hovering over
 * "Gorillas." When they move their mouse into the "Gorilla Content" area, they
 * may briefly hover over "Chimps." This shouldn't close the "Gorilla Content"
 * area.
 *
 * This problem is normally solved using timeouts and delays. menu-aim tries to
 * solve this by detecting the direction of the user's mouse movement. This can
 * make for quicker transitions when navigating up and down the menu. The
 * experience is hopefully similar to amazon.com/'s "Shop by Department"
 * dropdown.
 *
 * Use like so:
 *
 *      $("#menu").menuAim({
 *          activate: $.noop,  // fired on row activation
 *          deactivate: $.noop  // fired on row deactivation
 *      });
 *
 *  ...to receive events when a menu's row has been purposefully (de)activated.
 *
 * The following options can be passed to menuAim. All functions execute with
 * the relevant row's HTML element as the execution context ('this'):
 *
 *      .menuAim({
 *          // Function to call when a row is purposefully activated. Use this
 *          // to show a submenu's content for the activated row.
 *          activate: function() {},
 *
 *          // Function to call when a row is deactivated.
 *          deactivate: function() {},
 *
 *          // Function to call when mouse enters a menu row. Entering a row
 *          // does not mean the row has been activated, as the user may be
 *          // mousing over to a submenu.
 *          enter: function() {},
 *
 *          // Function to call when mouse exits a menu row.
 *          exit: function() {},
 *
 *          // Selector for identifying which elements in the menu are rows
 *          // that can trigger the above events. Defaults to "> li".
 *          rowSelector: "> li",
 *
 *          // You may have some menu rows that aren't submenus and therefore
 *          // shouldn't ever need to "activate." If so, filter submenu rows w/
 *          // this selector. Defaults to "*" (all elements).
 *          submenuSelector: "*",
 *
 *          // Direction the submenu opens relative to the main menu. Can be
 *          // left, right, above, or below. Defaults to "right".
 *          submenuDirection: "right"
 *      });
 *
 * https://github.com/kamens/jQuery-menu-aim
*/
(function($) {

    $.fn.menuAim = function(opts) {
        // Initialize menu-aim for all elements in jQuery collection
        this.each(function() {
            init.call(this, opts);
        });

        return this;
    };

    function init(opts) {
        var $menu = $(this),
            activeRow = null,
            mouseLocs = [],
            lastDelayLoc = null,
            timeoutId = null,
            options = $.extend({
                rowSelector: "> li",
                submenuSelector: "*",
                submenuDirection: "right",
                tolerance: 75,  // bigger = more forgivey when entering submenu
                enter: $.noop,
                exit: $.noop,
                activate: $.noop,
                deactivate: $.noop,
                exitMenu: $.noop
            }, opts);

        var MOUSE_LOCS_TRACKED = 3,  // number of past mouse locations to track
            DELAY = 300;  // ms delay when user appears to be entering submenu

        /**
         * Keep track of the last few locations of the mouse.
         */
        var mousemoveDocument = function(e) {
                mouseLocs.push({x: e.pageX, y: e.pageY});

                if (mouseLocs.length > MOUSE_LOCS_TRACKED) {
                    mouseLocs.shift();
                }
            };

        /**
         * Cancel possible row activations when leaving the menu entirely
         */
        var mouseleaveMenu = function() {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }

                // If exitMenu is supplied and returns true, deactivate the
                // currently active row on menu exit.
                if (options.exitMenu(this)) {
                    if (activeRow) {
                        options.deactivate(activeRow);
                    }

                    activeRow = null;
                }
            };

        /**
         * Trigger a possible row activation whenever entering a new row.
         */
        var mouseenterRow = function() {
                if (timeoutId) {
                    // Cancel any previous activation delays
                    clearTimeout(timeoutId);
                }

                options.enter(this);
                possiblyActivate(this);
            },
            mouseleaveRow = function() {
                options.exit(this);
            };

        /*
         * Immediately activate a row if the user clicks on it.
         */
        var clickRow = function() {
                activate(this);
            };

        /**
         * Activate a menu row.
         */
        var activate = function(row) {
                if (row == activeRow) {
                    return;
                }

                if (activeRow) {
                    options.deactivate(activeRow);
                }

                options.activate(row);
                activeRow = row;
            };

        /**
         * Possibly activate a menu row. If mouse movement indicates that we
         * shouldn't activate yet because user may be trying to enter
         * a submenu's content, then delay and check again later.
         */
        var possiblyActivate = function(row) {
                var delay = activationDelay();

                if (delay) {
                    timeoutId = setTimeout(function() {
                        possiblyActivate(row);
                    }, delay);
                } else {
                    activate(row);
                }
            };

        /**
         * Return the amount of time that should be used as a delay before the
         * currently hovered row is activated.
         *
         * Returns 0 if the activation should happen immediately. Otherwise,
         * returns the number of milliseconds that should be delayed before
         * checking again to see if the row should be activated.
         */
        var activationDelay = function() {
                if (!activeRow || !$(activeRow).is(options.submenuSelector)) {
                    // If there is no other submenu row already active, then
                    // go ahead and activate immediately.
                    return 0;
                }

                var offset = $menu.offset(),
                    upperLeft = {
                        x: offset.left,
                        y: offset.top - options.tolerance
                    },
                    upperRight = {
                        x: offset.left + $menu.outerWidth(),
                        y: upperLeft.y
                    },
                    lowerLeft = {
                        x: offset.left,
                        y: offset.top + $menu.outerHeight() + options.tolerance
                    },
                    lowerRight = {
                        x: offset.left + $menu.outerWidth(),
                        y: lowerLeft.y
                    },
                    loc = mouseLocs[mouseLocs.length - 1],
                    prevLoc = mouseLocs[0];

                if (!loc) {
                    return 0;
                }

                if (!prevLoc) {
                    prevLoc = loc;
                }

                if (prevLoc.x < offset.left || prevLoc.x > lowerRight.x ||
                    prevLoc.y < offset.top || prevLoc.y > lowerRight.y) {
                    // If the previous mouse location was outside of the entire
                    // menu's bounds, immediately activate.
                    return 0;
                }

                if (lastDelayLoc &&
                        loc.x == lastDelayLoc.x && loc.y == lastDelayLoc.y) {
                    // If the mouse hasn't moved since the last time we checked
                    // for activation status, immediately activate.
                    return 0;
                }

                // Detect if the user is moving towards the currently activated
                // submenu.
                //
                // If the mouse is heading relatively clearly towards
                // the submenu's content, we should wait and give the user more
                // time before activating a new row. If the mouse is heading
                // elsewhere, we can immediately activate a new row.
                //
                // We detect this by calculating the slope formed between the
                // current mouse location and the upper/lower right points of
                // the menu. We do the same for the previous mouse location.
                // If the current mouse location's slopes are
                // increasing/decreasing appropriately compared to the
                // previous's, we know the user is moving toward the submenu.
                //
                // Note that since the y-axis increases as the cursor moves
                // down the screen, we are looking for the slope between the
                // cursor and the upper right corner to decrease over time, not
                // increase (somewhat counterintuitively).
                function slope(a, b) {
                    return (b.y - a.y) / (b.x - a.x);
                };

                var decreasingCorner = upperRight,
                    increasingCorner = lowerRight;

                // Our expectations for decreasing or increasing slope values
                // depends on which direction the submenu opens relative to the
                // main menu. By default, if the menu opens on the right, we
                // expect the slope between the cursor and the upper right
                // corner to decrease over time, as explained above. If the
                // submenu opens in a different direction, we change our slope
                // expectations.
                if (options.submenuDirection == "left") {
                    decreasingCorner = lowerLeft;
                    increasingCorner = upperLeft;
                } else if (options.submenuDirection == "below") {
                    decreasingCorner = lowerRight;
                    increasingCorner = lowerLeft;
                } else if (options.submenuDirection == "above") {
                    decreasingCorner = upperLeft;
                    increasingCorner = upperRight;
                }

                var decreasingSlope = slope(loc, decreasingCorner),
                    increasingSlope = slope(loc, increasingCorner),
                    prevDecreasingSlope = slope(prevLoc, decreasingCorner),
                    prevIncreasingSlope = slope(prevLoc, increasingCorner);

                if (decreasingSlope < prevDecreasingSlope &&
                        increasingSlope > prevIncreasingSlope) {
                    // Mouse is moving from previous location towards the
                    // currently activated submenu. Delay before activating a
                    // new menu row, because user may be moving into submenu.
                    lastDelayLoc = loc;
                    return DELAY;
                }

                lastDelayLoc = null;
                return 0;
            };

        /**
         * Hook up initial menu events
         */
        $menu
            .mouseleave(mouseleaveMenu)
            .find(options.rowSelector)
                .mouseenter(mouseenterRow)
                .mouseleave(mouseleaveRow)
                .click(clickRow);

        $(document).mousemove(mousemoveDocument);

    };
})(jQuery);


$(function () {
    if(window.flindersHeaderCodeHasRun){
        return;
    }
    window.flindersHeaderCodeHasRun = true;
    var widthMobile = 990;
    var headerQuicklink = $('.header_quicklink');

    // yellow band -> mobile version subheader -> burger
    if ($('.subpage_global_header .top_main_navigation > li > a').length) {
        $('#navbar-main-top-collapse .top_main_navigation').append('<li id="global-mobile-navigation" class="nav-item dropdown"><a href="/content/flinders.html" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" class="nav_top_link 2">Global navigation</a><div class="dropdown-menu"><div id="dropmenu_section_global" class="dropmenu_section"></div></div></li>');
    }

    $('.subpage_global_header .top_main_navigation > li > a').each(function () {
    	var current_header_item = $(this);
    	var current_header_item_dom_int_class = '';
    	var current_header_item_dom_int_style = '';
    	var current_dom_int_state = current_state; //This comes from domestic-international-toggle.js
    	if(current_header_item.hasClass('domestic_content') && !current_header_item.hasClass('international_content')) {
    		current_header_item_dom_int_class = 'domestic_content';
    		if(current_dom_int_state === 'int') {
    			current_header_item_dom_int_style = "display:none;";
    		}
    	}
    	if(current_header_item.hasClass('international_content') && !current_header_item.hasClass('domestic_content')) {
    		current_header_item_dom_int_class = 'international_content';
    		if(current_dom_int_state === 'dom') {
    			current_header_item_dom_int_style = "display:none;";
    		}
    	}
        $('#global-mobile-navigation .dropmenu_section').append('<p class="link_overview '+ current_header_item_dom_int_class +'" style="'+current_header_item_dom_int_style+'"><a href="' + current_header_item.prop("href") + '">' + current_header_item.text() + '</a></p>');

        var subPagesDomIntlMenu = $('.smDomIntlSubPageMenu');
        subPagesDomIntlMenu.show();
        $('#global-mobile-navigation').after(subPagesDomIntlMenu);
    });


    /*clone logo in subheader*/
    var headerWrapper = $('.js-header-wrap');
    headerWrapper
        .append($('.js-header-search-side')
            .clone());

    headerQuicklink.click(function () {
        var mainNavbar = $('#navbar-main-top-collapse');
        if (mainNavbar.hasClass('in') == true) {
            mainNavbar.collapse('hide');
        }
    });

    $('.nav_top_link').each(function () {
        if ($(this).siblings('div').find('.dropmenu_section:eq(0)').attr('id') == 'dropmenu_section_global') {
            return true;
        }
        $(this).siblings('div').find('.dropmenu_section:eq(0)').prepend('<p class="link_overview"><a href="' + $(this).attr('href') + '">Overview</a></p>');
    });

    // dropdown -> disabled -> for mobile version
    $('.top_main_navigation .dropdown').on('click.bs.dropdown', function () {
        if ($(window).width() > widthMobile) {
            if ($(this).children('a:visible').attr('target')) {
                window.open($(this).children('a').attr('href'), $(this).children('a').attr('target'));
            } else {
                window.location = $(this).children('a').attr('href');
            }
        }
    });
    $('.top_main_navigation a[attr="data-toggle"]').on('click.bs.dropdown', function () {
        if ($(window).width() > widthMobile) {
            if ($(this).children('a:visible').attr('target')) {
                window.open($(this).children('a').attr('href'), $(this).children('a').attr('target'));
            } else {
                window.location = $(this).children('a').attr('href');
            }
        }
    });
    $('.top_main_navigation .dropdown > div a:not([data-toggle="dropdown"])').on('click', function () {
        if ($(this).attr('target')) {
            window.open($(this).attr('href'), $(this).attr('target'));
        } else {
            window.location = $(this).attr('href');
        }
        return false;
    });

    var logoLine = $('.logo_line');
    var headerSite = $('.home_header_line');

    mousedown = false;
    $('a').on('mousedown', function () {
        mousedown = true;
    });
    $('a').on('focus', function () {
        if ($(window).width() > widthMobile) {
            if ($(this).parents('.top_main_navigation, .header_quicklink_section')[0]) {
                if (!$(this).parents('li').hasClass('open_row')) {
                    $('.top_main_navigation > li, .header_quicklink_section > li').removeClass('open_row');
                    $(this).parents('li').addClass('open_row');
                    logoLine.addClass('header_active');
                    headerSite.addClass('header_active');
                }
                clearTimeout(window['top_main_navigation_blur']);
                var search_icon = $('.header_search_top');
                if (search_icon.hasClass('active')) {
                    search_icon.removeClass('active');
                    $('.logo_line').removeClass('header_active').removeClass('search_transorm_dark_bg');
                    $('.home_header_line').removeClass('header_active');
                    $('.header_global_search_form').stop().fadeOut();
                }
            } else {
                $('.top_main_navigation > li, .header_quicklink_section > li').removeClass('open_row');
                if (!mousedown) {
                    logoLine.removeClass('header_active');
                    headerSite.removeClass('header_active');
                    if ($(this).parent().hasClass('header_search_top')) {
                        $(this).click();
                    } else {
                        var search_icon = $('.header_search_top');
                        if (search_icon.hasClass('active')) {
                            search_icon.removeClass('active');
                            $('.logo_line').removeClass('header_active').removeClass('search_transorm_dark_bg');
                            $('.home_header_line').removeClass('header_active');
                            $('.header_global_search_form').stop().fadeOut();
                        }
                    }
                }
            }
            mousedown = false;
        }
    });
    $('.top_main_navigation a').on('blur', function () {
        if ($(window).width() > widthMobile) {
            window['top_main_navigation_blur'] = setTimeout(function () {
                $('.top_main_navigation > li, .header_quicklink_section > li').removeClass('open_row');
                logoLine.removeClass('header_active');
                headerSite.removeClass('header_active');
            }, 150);
        }
    });
    // Multi-Level Dropdowns -> for mobile version
    $('.head_list_heading a').on('click', function (e) {
        var element = $(this);
        var parentElement = element.parent();

        if ($(window).width() > widthMobile) {
            window.location = element.attr('href');
        } else {
            if (parentElement.next('ul:hidden')[0]) {
                parentElement.addClass('open');
            } else {
                parentElement.removeClass('open');
            }
            parentElement
                .next('ul')
                .toggle();
        }
        e.stopPropagation();
        e.preventDefault();
    });
    $('.top_main_navigation, .header_quicklink_section').menuAim({
        tolerance: 20,
        submenuDirection: 'below',
        activate: function (row) {
            var $row = $(row);
            var dataRole = $row.parent().attr('data-role');
            $row.addClass('open_row');
            logoLine.addClass('header_active');
            headerSite.addClass('header_active');
            $('.js-menu-aim').each(function () {
                clearTimeout(window[dataRole + '_yellow']);
            });
            $('.header_search_top').removeClass('active');
            $('.header_global_search_form').hide();
        },
        deactivate: function (row) {
            $(row).removeClass('open_row');
            if ($('.header_search_top').hasClass('active')) {
                logoLine.removeClass('header_active');
                headerSite.removeClass('header_active');
            }
        },
        enter: function (row) {
            var $row = $(row);
            var dataRole = $row.parent().attr('data-role');

            if (!$row.siblings('.open_row')[0]) {
                $row.addClass('open_row');
            }
            logoLine.addClass('header_active');
            headerSite.addClass('header_active');

            clearTimeout(window[dataRole + '_close']);
            $('.js-menu-aim').each(function () {
                clearTimeout(window[$(this).attr('data-role') + '_yellow']);
            });
            $('.header_search_top').removeClass('active');
            $('.header_global_search_form').hide();
        },
        exitMenu: function (menu) {
            var $menu = $(menu);
            var dataRole = $menu.attr('data-role');
            window[dataRole + '_close'] = setTimeout(function () {
                if($("[id^=deleteCourseBookmarkConfirmationDialog]").hasClass('in')){
                    $('#sc').addClass('open_row');
                } else {
                    $(menu)
                        .children()
                        .removeClass('open_row');
                }
            }, 150);
            window[dataRole + '_yellow'] = setTimeout(function () {
                if (!$('.header_search_top').hasClass('active')) {
                    logoLine.removeClass('header_active');
                    headerSite.removeClass('header_active');
                }
            }, 150);
        }
    });
    var burger = $('.header_burger');
    var scrollPosition = 0;

    //JD: Maybe make sure the thing we want to observe actually exists before observing...
    if(burger.length > 0) {
        var observer = new MutationObserver(function (mutations) {
            var scrollSetted = false;
            mutations.forEach(function (mutation) {
                if (mutation.type == "attributes") {
                    if (mutation.attributeName == "aria-expanded") {
                        if ($('.header_burger[aria-expanded="true"]').length) {
                            if (!scrollSetted) {
                                scrollPosition = $(document).scrollTop();
                                scrollSetted = true;
                            }
                            $('body').addClass("hiddenOverflow");
                        } else {

                            $('body').removeClass("hiddenOverflow");
                            $(document).scrollTop(scrollPosition);
                        }
                    }
                }
            });
        });

        observer.observe(burger.get(0), {
            childList: true,
            attributes: true,
            characterData: true,
            attributeFilter: ['aria-expanded']
        });
    }

});

$(function () {
    var search_icon = $('.header_search_top a');
    function removeClassTopNav(classname) {
        classname.removeClass('header_active search_transorm_dark_bg');
    }
    search_icon.on('click', function (event) {
        if($('.header_burger').attr('aria-expanded') == "true") {
            $('.header_burger').click();
        }
        if($('.header_quicklink').attr('aria-expanded') == "true") {
            $('.quicklink_section_mv').removeClass('open');
        }
        if ($('.header_search_top').hasClass('active')) {
            $('.header_global_search_form').stop().fadeOut();
           
        } else {
            $('.header_global_search_form').stop().fadeIn();
        }          
        event.stopPropagation();
        if ($('.header_search_top').hasClass('active')) {
            search_icon.parent().removeClass('active');
            $('.header_global_search_form .gsc-input input[type="text"].gsc-input').blur();
            removeClassTopNav($('.global_header .logo_line'));
            removeClassTopNav($('.home_header_line'));
            if($('.sectionfixed')[0]) {
               removeClassTopNav($('.head_inner_second_line .logo_line'));
            }
        } else {
            search_icon.parent().addClass('active');
            $('.header_global_search_form input[type="text"].gsc-input').focus();
            $('.global_header .logo_line').addClass('header_active search_transorm_dark_bg');
            $('.home_header_line').addClass('header_active');
            if($('.sectionfixed')[0]) {
                $('.head_inner_second_line .logo_line').addClass('header_active search_transorm_dark_bg');
            }
        }
    });
    $('span.header_global_search_insert, span.header_global_search_insert *').click(function (event) {
        return false;
    });
    $('*:not(.header_search_top, .header_search_top *, span.header_global_search_insert, .nav_top_link, span.header_global_search_insert *)').on('click',function (e) {
        if(search_icon.parent().hasClass('active')) {
            search_icon.parent().removeClass('active');
            removeClassTopNav($('.global_header .logo_line'));
            removeClassTopNav($('.home_header_line'));
            if($('.sectionfixed')[0]) {
                removeClassTopNav($('.head_inner_second_line .logo_line'));
            }
            $('.header_global_search_form').stop().fadeOut();
        }
    });
    $('.header_search_top, .header_search_top img').keypress(function (e) {
        if (e.keyCode == 13) {
            $('.header_search_icon_black').click();
        }
    });
});
$(function () {
    var widthMobile = 992;
    var $navi = $('.global_header .logo_line');
    var isAuthor = false;
    var isStaffPortalHeader = false;
    if($(".author").length) {
    	isAuthor = true;
    }
    if($(".sub_site_header").length) {
        isStaffPortalHeader = true;
    }
    var body_sub_page = $('.body_sub_page');
    $(window).scroll(function () {
        if ($(window).width() > widthMobile) {
            var y = $(this).scrollTop(),
                speed = 0.003,
                percent = Math.round((y * speed) * 100) / 100;
            if(isStaffPortalHeader) {
                percent = y / 100;
            }

            if (percent >= 1) {
                percent = 1;
            }
            else if (percent < 0) {
                percent = 0;
            }
    
            // APPLY STYLING
            // Only on flinders main site.
            if (!isStaffPortalHeader) {
                $navi.css({
                    'background-color': 'rgba(255, 211,0,' + percent + ')'
                });
                var global_header_top = $('.header_site').offset().top;
                if (percent > 0) {
                    $('.global_header').css("top", global_header_top);
                } else if (percent <= 0) {
                    global_header_top = global_header_top + 25;
                    $('.global_header').css("top", global_header_top);
                }
            }

    
            // YELLOW HEADER
            if (percent >= 1) {

                if(isStaffPortalHeader) {
                    body_sub_page.addClass('sectionfixed');
                } else {
                    $navi.addClass('yellow_header');
                }
                /*appeared  "Back to top" icon*/
                $('.js-scroll-top').show();    
            } else {

                if(isStaffPortalHeader) {
                    body_sub_page.removeClass('sectionfixed');
                } else {
                    $navi.removeClass('yellow_header');
                }
                /*removed  "Back to top" icon*/
                $('.js-scroll-top').hide();
            }

            var headerOffsetTop = $(this).getHeaderTopOffset();

            if (y > headerOffsetTop) { // should add when top is greater than 0
                if(!isStaffPortalHeader && !isAuthor && y > 0) {
                    body_sub_page.addClass('sectionfixed');
                }
                // Code to fix the redundant double hover over items while scrolling - clone header issue...
                $('body .pull-right:first ul li').removeClass('open_row');
            }
            else {
                if(!isStaffPortalHeader) {
                    body_sub_page.removeClass('sectionfixed');
                }
                $('.logo_line').removeClass('header_active').removeClass('search_transorm_dark_bg');
                $('.home_header_line').removeClass('header_active');
                $('.header_search_top').removeClass('active');
                $('.header_global_search_form').fadeOut('500');
                // Code to fix the redundant double hover over items while scrolling - clone header issue...
                $('body .pull-right:last ul li').removeClass('open_row');
            }
        }
    });
    $(window).scroll();
});

$(readyFunction);

function readyFunction() {
    var windowWidth;
    var attached;
    var navigationBlock = $('#sticky_nav');

    widthCheck();

    $(window).on('resize', function () {
        setTimeout(function () {
            widthCheck();
        }, 100);
    });

    function widthCheck() {
        windowWidth = $(window).width();
        if (windowWidth < 992) {
            if (attached !== false) {
                if (navigationBlock) {
                    navigationBlock.trigger('sticky_kit:detach');
                }

                $('.context-navigation_expand')
                    .addClass('fa-plus')
                    .removeClass('fa-times')
                    .parents('.context-navigation__list-wrapper')
                    .find('ul').hide();
            }
            attached = false;
        } else {
            if (attached !== true) {
                if (navigationBlock) {
                    make_sticky();
                }

                $('.context-navigation_expand')
                    .addClass('fa-times')
                    .removeClass('fa-plus')
                    .parents('.context-navigation__list-wrapper')
                    .find('ul').show();
            }
            attached = true;
        }
    }

    function make_sticky() {
        navigationBlock.stick_in_parent({
            //parent: '.container',
            offset_top: 68
        });
    }

    $('.context-navigation_expand').on('click', function (e) {
        var element = $(this);
        e.preventDefault();
        e.stopPropagation();
        if (element.hasClass('fa-plus')) {
            element
                .addClass('fa-times')
                .removeClass('fa-plus')
                .parents('.context-navigation__list-wrapper')
                .find('ul')
                .show();
        } else {
            element
                .addClass('fa-plus')
                .removeClass('fa-times')
                .parents('.context-navigation__list-wrapper')
                .find('ul')
                .hide();
        }
    })
}

document.addEventListener("DOMContentLoaded", function() {
    var stickyMatches = document.querySelectorAll('.section_sticky');

    widthCheck();

    $(window).on('resize', function () {
        setTimeout(function () {
            widthCheck();
        }, 100);
    });

    function widthCheck() {
        var selectedSection;
        windowWidth = $(window).width();
        if (windowWidth < 992) {
            for (i = 0; i < stickyMatches.length; ++i) {
                selectedSection = stickyMatches[i].parentNode;
                selectedSection.style.position = "inherit";
                selectedSection.style.top = "auto";
                selectedSection.style.zIndex = "auto";
            }
        } else {
            for (i = 0; i < stickyMatches.length; ++i) {
                const topOffset = stickyMatches[i].dataset.stickyOffset || 70;
                const zindexSticky = stickyMatches[i].dataset.stickyZindex;
                selectedSection = stickyMatches[i].parentNode;
                selectedSection.style.position = "sticky";
                selectedSection.style.top = topOffset + "px";
                selectedSection.style.zIndex = zindexSticky;
            }
        }
    }

});


function buildEvents(category) {
    var eventsList = $('#eventsList');
    if (eventsList.length) {
        var config = {
            method: 'getEvents',
            filterBy: '',
            name: '',
            limit: '3',
            startDate: 'now',
            sessionOrderBy: 'start_date'
        };
        if (category) {
            config.filterBy = 'category';
            config.name = category;
        }
        $.ajax({
            method: "GET",
            url: 'https://events.flinders.edu.au/json/',
            headers: {},
            data: config
        }).done(function (data) {
            var events = data.events;
            var eventTemplate = $('#event').text();
            var compiledEventTemplate = doT.template(eventTemplate);
            var dataToProvide;
            for (var i = 0; i < data.limit; i++) {
                dataToProvide = events[i];
                dataToProvide.eventUrl = 'http://events.flinders.edu.au/' + dataToProvide.url;
                dataToProvide.calendarUrl = 'http://events.flinders.edu.au/session/ical/id/' + dataToProvide.id;
                dataToProvide.date = new Date(moment(dataToProvide.sessions[0].start_date));
                dataToProvide.date_day = moment(dataToProvide.date).format('DD');
                dataToProvide.date_month = moment(dataToProvide.date).format('MMM');
                dataToProvide.date_time = moment(dataToProvide.date).format('HH:mm a');
                dataToProvide.place = dataToProvide.sessions[0].location;
                
                eventsList.append(compiledEventTemplate(dataToProvide));
            }
        });
    }
}


function buildEventonFeed(category, categoryType, showFeature) {
    var feedUrl = "https://events.flinders.edu.au";
    var parametersUrl = "?json=get_posts&post_type=ajde_events&orderby=meta_value&meta_key=evcal_srow&order=asc&count=3";
    var showFeatureImage = showFeature;
    var eventList = $('#eventsList');
    
    // Is the event category set in the dialogue. 
    if (category !== "") {
        // Set the URL to include the categoryType slug and category slug. categoryType is the eventon plugin slug (examples: event-type, event-type-2 etc) category slug (examples: feature, student-event, alumni-development, etc)
        feedUrl =  feedUrl + "/" + categoryType + "/" + category + '/';
        var categorySlug = "#" + category;
        eventList = $(categorySlug);
    }

    //Set the feed URL
    feedUrl = feedUrl + parametersUrl;

    

    //if events exist
    if (eventList.length) {
        $.ajax({
            method: "GET",
            url: feedUrl,
            headers: {}
        }).done(function (data) {
            var events = data.posts;
            var eventTemplate = $('#event').text();
            var compiledEventTemplate = doT.template(eventTemplate);
            var dataToProvide;
            for (var i = 0; i < data.count; i++) {
                dataToProvide = events[i];
                dataToProvide.eventUrl = dataToProvide.url;
                dataToProvide.date = new Date(moment.unix(dataToProvide.custom_fields.evcal_srow));
                dataToProvide.date_day = moment.utc(dataToProvide.date).format('DD');
                dataToProvide.date_month = moment.utc(dataToProvide.date).format('MMM');
                dataToProvide.date_time = moment.utc(dataToProvide.date).format('h:mm a');
                dataToProvide.location = dataToProvide.taxonomy_event_location[0].title;
                dataToProvide.bg_Color = dataToProvide.custom_fields.evcal_event_color;
                
                //Does the event have a feature image and is the show feature dialogue checked.
                if (dataToProvide.hasOwnProperty("thumbnail_images") && showFeatureImage == 'showFeature') {
                   dataToProvide.bgImage = dataToProvide.thumbnail_images.full.url;
                   dataToProvide.overlay = 'events_overlay';
                   dataToProvide.buttonStyle = 'classic_transparent_button_white_border__small';
                }
                else {
                    dataToProvide.bgImage = '';
                    dataToProvide.overlay = '';
                    dataToProvide.buttonStyle = 'classic_white_button_navy_border__small';
                    
                }

                eventList.append(compiledEventTemplate(dataToProvide));
            }
        });
    }
}



var the_events = $('.eventList');

the_events.each(function() {

        var categoryType = $(this).children('.categoryType');
        var eventCategory = $(this).children('.eventCategory');
        var articleLayout = $(this).children('.articleLayout');
        var eventCount = $(this).children('.eventCount');
        var showFeatureImage = $(this).children('.showFeatureImage');
        var removeGutter = $(this).children('.removeGutter');
        var removeBorder = $(this).children('.removeBorder');
        var showExcerpt = $(this).children('.showExcerpt');
        var eventBtnText = $(this).children('.eventBtnText');

        populateEvents(categoryType.val(), eventCategory.val(), articleLayout.val(), eventCount.val(), showFeatureImage.val(), showExcerpt.val(), eventBtnText.val(), removeGutter.val(), removeBorder.val(), this);

});

function populateEvents(categoryType, eventCategory, articleLayout, eventCount, showFeatureImage, showExcerpt, eventBtnText, removeGutter, removeBorder, eventOutput ) {

    var feedUrl = "https://events.flinders.edu.au";
    var parametersUrl = "?json=get_posts&post_type=ajde_events&orderby=meta_value&meta_key=evcal_srow&order=asc&count=" + eventCount;


    // Is the event category set in the dialogue. 
    if (eventCategory !== "") {
        // Set the URL to include the categoryType slug and category slug. categoryType is the eventon plugin slug (examples: event-type, event-type-2 etc) category slug (examples: feature, student-event, alumni-development, etc)
        feedUrl =  feedUrl + "/" + categoryType + "/" + eventCategory;
    }

    //Set the feed URL
    feedUrl = feedUrl + "/" + parametersUrl;

    $.ajax({
            method: "GET",
            url: feedUrl,
            headers: {}
        }).done(function (data) {
            var events_data = data.posts;
            var events_count = data.count;
            var dataToProvide;
            var eventsTemplate = $('.eventsStandardLayout').first().text();
            var compiledEventsTemplate;

            var start_day_month;
            var end_day_month;

            //apply layout class to main wrapper

            if ( articleLayout == 'overlayLayout') {
                eventsTemplate = $('.eventsOverlayLayout').first().text();        
            }
            else if ( articleLayout == 'listLayout') {
                eventsTemplate = $('.eventsListLayout').first().text();
            }
            
            if ( events_count == "0" ){
                eventsTemplate = $('.noEvents').first().text();
                compiledEventsTemplate = doT.template(eventsTemplate);
                $(eventOutput).append(compiledEventsTemplate());
            }
            else {
                compiledEventsTemplate = doT.template(eventsTemplate);
            }

            for (var i = 0; i < data.count; i++) {
                
                dataToProvide = events_data[i];
                dataToProvide.eventUrl = dataToProvide.url;
                dataToProvide.startDate = new Date(moment.unix(dataToProvide.custom_fields.evcal_srow));
                dataToProvide.endDate = new Date(moment.unix(dataToProvide.custom_fields.evcal_erow));
                dataToProvide.startDate_day = moment.utc(dataToProvide.startDate).format('DD');
                dataToProvide.endDate_day = moment.utc(dataToProvide.endDate).format('DD');
                dataToProvide.startDate_month = moment.utc(dataToProvide.startDate).format('MMM');
                dataToProvide.endDate_month = moment.utc(dataToProvide.endDate).format('MMM');
                dataToProvide.startDate_time = moment.utc(dataToProvide.startDate).format('h:mm a');
                dataToProvide.endDate_time = moment.utc(dataToProvide.endDate).format('h:mm a');

                // MAkes sure there is valid location data
                try {
                dataToProvide.location = dataToProvide.taxonomy_event_location[0].title;
                }
                catch(err) {
                  dataToProvide.location = "";
                }

                dataToProvide.title = dataToProvide.title;
                dataToProvide.event_excerpt = dataToProvide.excerpt;

                start_day_month = dataToProvide.startDate_day + dataToProvide.startDate_month;
                end_day_month = dataToProvide.endDate_day + dataToProvide.endDate_month;

                // Is there alternative text for the event detail button
                if (eventBtnText == "") {
                    dataToProvide.eventBtnDetails = "View details";
                }
                else {
                    dataToProvide.eventBtnDetails = eventBtnText;
                }

                start_day_month = dataToProvide.startDate_day + dataToProvide.startDate_month;
                end_day_month = dataToProvide.endDate_day + dataToProvide.endDate_month;

                //If the event does not go over multiple dates then hide the end date.
                if (start_day_month == end_day_month) {
                    dataToProvide.multipleDateHidden = "hide_date";
                }

                // Does the events have a feature image and is the show feature dialogue checked?
                if (dataToProvide.hasOwnProperty("thumbnail_images") && showFeatureImage == 'showFeature') {
                   dataToProvide.bgImage = dataToProvide.thumbnail_images.full.url;
                   dataToProvide.overlay ='events_overlay';
                   dataToProvide.showFeature ='events_image';

                   if (articleLayout == "standardLayout" || articleLayout == "listLayout") {
                        dataToProvide.buttonStyle = 'events-read-more-btn-navy';
                   }
                   else {
                        dataToProvide.buttonStyle = 'events-read-more-btn-white';
                   }
                   
                }
                else {
                    //if standard layout does not have a thumbnail but has feature image set to showfeature.
                    if ( articleLayout == 'standardLayout' && showFeatureImage == 'showFeature') {
                    dataToProvide.showFeature ='events_image';
                    dataToProvide.bgImage = "https://www.flinders.edu.au/content/dam/images/aem-components/events-component/events-component-feature-image-fallback-02.jpg";
                    dataToProvide.buttonStyle = 'events-read-more-btn-navy';
                    }
                    else {
                    dataToProvide.bgImage = '#';
                    dataToProvide.overlay = 'events_overlay_no_bg_image';
                    dataToProvide.buttonStyle = 'events-read-more-btn-navy';
                    }                 
                }

                //is remove gutter checked
                if (removeGutter !== 'no-gutter') {
                    dataToProvide.articleRowSpacing = 'rowSpacing';
                }

                // is remove border checked
                if (removeBorder == "no-border") {
                    dataToProvide.articleBorder = '';
                }
                else {
                    dataToProvide.articleBorder = 'events-border';
                }

                // Is show excertp checked?
                if (showExcerpt == 'showExcerpt') {
                    dataToProvide.show_excerpt ='events_show_excerpt';
                }
                else {
                    dataToProvide.show_excerpt ='events_hide_excerpt';                   
                }
                
                // Default column layout for eventCount = 3, 6 or 9 or all(10000).
                dataToProvide.column_layout = 'col-md-12 col-lg-4';

                // Column layout if article laout is list.
                if (articleLayout == 'listLayout'){
                    dataToProvide.column_layout = 'col-sm-12';
                }
                // Column layout based on the number of articles selected to display.
                else if (eventCount == '1') {
                    dataToProvide.column_layout = 'col-lg-12';
                }
                else if (eventCount == '2'){
                    dataToProvide.column_layout = 'col-sm-12 col-md-6';
                }
                else if (eventCount == '4' || eventCount == '8' ){
                    dataToProvide.column_layout = 'col-sm-12 col-md-6 col-lg-3';
                }

                $(eventOutput).append(compiledEventsTemplate(dataToProvide));

            }


            //Ellipsis calls - force content to a number of lines
            $('.events_excerpts_line, .events_overlay_excerpts_line, .events_title h3').ellipsis({
              lines: 2,
              responsive: true
            });
            //End Ellipsis

        });

}






function getNewsFeed(url_news_json) {
    if(!url_news_json){
        return false;
    }
    $.ajax({
        dataType: "json",
        url: url_news_json,
        success: function (data) {
            $.each(data.posts, function( index, value ) {
                if (!$('.news_component_section_wrap .component_section_item:eq('+index+')')[0]) {
                        $('.news_component_section_wrap').append($('.news_component_section_wrap .component_section_item:eq('+(index-1)+')').clone());
                }
                $('.news_component_section_wrap .component_section_item:last h3').html(value.title );
                $('.news_component_section_wrap .component_section_item:last .js-news-body').html(value.excerpt);

                $('.news_component_section_wrap .component_section_item:last .component_section_picture img').attr('src', value.thumbnail_images.full.url );
                $('.news_component_section_wrap .component_section_item:last .js-link-tonews, .component_section .component_section_item:last .component_section_picture .js-link-tonews').attr('href', value.url );
                $('.news_component_section_wrap .component_section_item:last .news_date em').html(moment(value.date).format("DD MMMM YYYY"));              
                
                if(index == 2) {
                    return false;
                }
            });
        }
    });
}


var the_news = $('.newsList');
var newsList_class_count = 0;

the_news.each(function() {

        var sourceUrl = $(this).children('.sourceUrl');
        var articleCount = $(this).children('.articleCount');
        var showFeatureImage = $(this).children('.showFeatureImage');
        var articleLayout = $(this).children('.articleLayout');
        var showExcerpt = $(this).children('.showExcerpt');
        var hideArticleDate = $(this).children('.hideArticleDate');
        
        populateNews(sourceUrl.val(), articleCount.val(), showFeatureImage.val(), articleLayout.val(), showExcerpt.val(), hideArticleDate.val(), this);

});

function populateNews(sourceUrl, articleCount, showFeatureImage, articleLayout, showExcerpt, hideArticleDate, that) {

    var feedUrl = sourceUrl;
    var count = articleCount;
    var layout = articleLayout;
    var parametersUrl = "?json=get_recent_posts&count=" + count;
    var showFeatureImage = showFeatureImage;
    var showExcerptChecked = showExcerpt;
    var hideArticleDate = hideArticleDate;


    //Set the feed URL
    feedUrl = feedUrl + parametersUrl;

    $.ajax({
            method: "GET",
            url: feedUrl,
            headers: {}
        }).done(function (data) {
            var news = data.posts;
            var dataToProvide;


            //apply layout class to main wrapper
            if ( layout == 'standardLayout') {
                var newsTemplate = $('.newsStandard').first().text();        
            }
            else {
                var newsTemplate = $('.newsOverlay').first().text();
            }


            var compiledNewsTemplate = doT.template(newsTemplate);
        
            for (var i = 0; i < data.count; i++) {
                dataToProvide = news[i];
                dataToProvide.newsUrl = dataToProvide.url;
                dataToProvide.date = new Date(moment(dataToProvide.date));
                dataToProvide.date_day = moment(dataToProvide.date).format('DD');
                dataToProvide.date_month = moment(dataToProvide.date).format('MMM');
                dataToProvide.date_year = moment(dataToProvide.date).format('YYYY');
                dataToProvide.date_time = moment(dataToProvide.date).format('h:mm a');
                dataToProvide.news_title = dataToProvide.title;
                dataToProvide.news_excerpt = dataToProvide.excerpt;
                
                //Does the news have a feature image and is the show feature dialogue checked.
                if (dataToProvide.hasOwnProperty("thumbnail_images") && showFeatureImage == 'showFeature') {
                   dataToProvide.bgImage = dataToProvide.thumbnail_images.full.url;
                   dataToProvide.overlay ='news_overlay';
                   if ( layout == "standardLayout") {
                        dataToProvide.buttonStyle = 'classic_white_button_navy_border__small';  
                   }
                   else {
                        dataToProvide.buttonStyle = 'classic_transparent_button_white_border__small';
                   }
                   
                }
                else {
                    dataToProvide.bgImage = '';
                    dataToProvide.overlay = '';
                    dataToProvide.buttonStyle = 'classic_white_button_navy_border__small';                   
                }

                // Is show excertp checked?
                if (showExcerptChecked == 'showExcerpt') {
                    dataToProvide.show_excerpt ='news_show_excerpt';
                }
                else {
                    dataToProvide.show_excerpt ='hidden';                   
                }
                
                // Choose the column layout based on the number of articles selected to display.
                dataToProvide.column_layout = 'col-md-12 col-lg-4';
                if (count == '1') {
                    dataToProvide.column_layout = 'col-lg-12';
                }
                else if (count == '2'){
                    dataToProvide.column_layout = 'col-sm-12 col-md-6';
                }
                else if (count == '4'){
                    dataToProvide.column_layout = 'col-sm-12 col-md-6 col-lg-3';
                }

                //hide the article date
                if (hideArticleDate == 'hideArticleDate') {
                    dataToProvide.hide_date = 'hidden';
                }

                $(that).append(compiledNewsTemplate(dataToProvide));

            }

            $('.news_excerpts_line').ellipsis({
                lines: 3,             // force ellipsis after a certain number of lines. Default is 'auto'
                responsive: true      // set to true if you want ellipsis to update on window resize. Default is false
            });

            $('.news_overlay_excerpts_line').ellipsis({
                lines: 2,             // force ellipsis after a certain number of lines. Default is 'auto'
                responsive: true      // set to true if you want ellipsis to update on window resize. Default is false
            });

            $('.news_title h3').ellipsis({
                lines: 2,             // force ellipsis after a certain number of lines. Default is 'auto'
                responsive: true      // set to true if you want ellipsis to update on window resize. Default is false
            });
        });

}






var checked_conversation_feed = false ;
function populateConversationFeeds() {
	// For conversation feed.
	if (!checked_conversation_feed) {
		checked_conversation_feed = true;
		$(".conversation_component").each(function() {
			var ele = $(this);
			
			var page_type = $("#conversation_feed_page_type").val();
			
			if(page_type == 'staff_profile') {
				getConversationFeedForStaffProfile(ele);
			} else {
			    var feedPath = ele.find(".conversation_feed_url").val();
				getConversationFeed(ele, feedPath);
			}
			
		});
	}
	
}

function getConversationFeedForStaffProfile(element) {
	var ele = element;
	var flinders_uni_default_feed = "https://theconversation.com/institutions/flinders-university-972/articles.atom";

	var spp_social_the_conversation = $('#spp_social_the_conversation');
	
	if(spp_social_the_conversation.length) {
        getConversationFeed(ele, spp_social_the_conversation.prop('href'));
	}
	else {
		getConversationFeed(ele, flinders_uni_default_feed);
	}
	
}

// Striping out articles after profiles in feed url.
function validateConversationFeedUrl(conversation_feed_url) {
	var feed_url = conversation_feed_url;
	
	//if (feed_url.indexOf('profiles') > -1 && feed_url.indexOf('/articles') > -1) {
    if (feed_url.indexOf('/articles') > -1) {
		
		validated_feed_url = feed_url.substr(0,feed_url.indexOf('/articles'));
		
	} else {
		
		validated_feed_url = feed_url;
	}
	// Checking if there is trailing slash then remove it.
	if(validated_feed_url.charAt(validated_feed_url.length-1) == "/") {
		validated_feed_url = validated_feed_url.replace(/\/$/, "");
	}
	return validated_feed_url;
}

// Conversation feed.
function getConversationFeed(element, profile) {
    var url_conversation_xml = '/flinders-services/staff/conversation';
    var profileUrl = 'https://theconversation.com/institutions/flinders-university-972';

    if (profile) {
        profileUrl = validateConversationFeedUrl(profile);
    }

    url_conversation_xml = url_conversation_xml + '/?profile=' + profileUrl;
    
	var container = element;
	 
    $.ajax({
    	url: url_conversation_xml,
    	method: "GET",
    	beforeSend: function(){
            $('.ajax-loader').css("visibility", "visible");
          },
    	dataType: "xml",
    	crossDomain: true,
        success: function (data) {
        	$(data).find("entry").each(function (index, value) { 
        		var ele = $(this);
        		var url = ele.find("link").attr("href");
        		var title = ele.find("title").text();
        		var date = moment(ele.find("published").text()).format("DD-MMMM-YYYY");
        		
        		var add_to_list = {"title": title, "date": date, "url": url};
        		container.find('.conversation_component_section_wrap').append(Handlebars.compile($("#component_section_item").html())(add_to_list));
                if(index == 2) {
                    return false;
                }
            });
        	$(data).find("Error").each(function (index, value) { 
        		var ele = $(this);
        		errorMessage(ele.find("name").text());
        	});
        	
        }, // End of success
        complete: function(){
    	    $('.ajax-loader').css("visibility", "hidden");
    	},
    	error: function (jqXHR, textStatus, exception, errorThrown) {
            ajaxErrorHandler(jqXHR, textStatus, exception, errorThrown)
      	}
    });
    container.find('.conversation_component_read_more .conversation_component_read_more_button').prop('href', profileUrl );
}

//accordion menu for navigation component.

$(document).ready(function() {

    var windowWidth;
    var attached;
    checkWidth();

    function checkWidth() {
        windowWidth = $(window).width();
        if (windowWidth < 992) {
            if (attached !== false) {
                $('.context-navigation_expand')
                    .addClass('fa-plus')
                    .removeClass('fa-times')
            }
            attached = false;
        } else {
            if (attached !== true) {
                $('.context-navigation_expand')
                    .addClass('fa-times')
                    .removeClass('fa-plus')
            }
            attached = true;
        }
    }
	$(".cmp-navigation__parent--level-0").hide();
	
	$('li.cmp-navigation__item--active').each(function () {
		var currentLi = $(this);
		var currentExpansion = currentLi.find('.cmp-navigation__expand-collapse:first');
		if (currentExpansion.length > 0) {
			currentExpansion.children('.fa').switchClass('fa-plus', 'fa-minus', 1000, "easeInOutQuad")
			currentLi.addClass('open');
			currentLi.children('.cmp-navigation__parent--level').slideDown(750);
		}  
		
    });
	
// expand and collapse on click.
	$(".cmp-navigation__expand-collapse").on("click" , function(e) {
		e.preventDefault();
		
		var all_accordion_items = $(this).closest('.cmp-navigation__group').children('.accordion_item');
		var current_accordion_item = $(this).closest('.accordion_item');
		var prev_all_accordion_items = $(this).children('.fa');
		
		if(current_accordion_item.hasClass('open')) {
			all_accordion_items.removeClass('open');
			all_accordion_items.find('.accordion_item').removeClass('open');
			all_accordion_items.find('div.cmp-navigation__item-link').css( "background-color", "#fff" );
			all_accordion_items.find('.fa-minus').switchClass('fa-minus', 'fa-plus', 1000, "easeInOutQuad");
			all_accordion_items.find('.cmp-navigation__parent--level').slideUp(750);
		} else {
			all_accordion_items.removeClass('open');
			all_accordion_items.find('div.cmp-navigation__item-link').css( "background-color", "#fff" );
			all_accordion_items.find('.fa-minus').switchClass('fa-minus', 'fa-plus', 1000, "easeInOutQuad");
			all_accordion_items.children('.cmp-navigation__parent--level').slideUp(750);
			current_accordion_item.addClass('open');
			prev_all_accordion_items.switchClass('fa-plus', 'fa-minus', 1000, "easeInOutQuad");
			current_accordion_item.children('.cmp-navigation__parent--level').slideDown(750);
		}
	});

});

var social_tick_size = 42;
var right_social_buffer_is_shown = false;
var left_social_buffer_is_shown = false;
var max_social_scroll_value = 0;
$(document).ready(function() {
	
	//This event is triggered ***after*** the animation for showing the tab has finished
	$('#staffProfileTab.nav-tabs a.nav-link').on('shown.bs.tab', function(event){
		var tab_just_shown = $(this);
		var content_area_shown_id = tab_just_shown.prop('hash');
		var associated_content_area = $(content_area_shown_id);
	    //add ellipsis to expert lebels
		associated_content_area.find('.expertise_list_item_label').ellipsis({
			lines: 2,      
			ellipClass: 'ellip',
			responsive: true
		});
	});
	
	var div_height = $("#further_info_detail .further_detail_inner").height();
	if (div_height > 210) {
		$("div #further_info_detail").addClass('fixedHeight');
	} else {
		$("div #further_info_detail").removeClass('fixedHeight');
		$("div #further_info_read_more").hide();
	}
	/* Click event to show or hide further information.*/
	$(document).on('keyup', '.further_info_read_more_button',function(e){
	    if(e.which==13 || e.which==32) {
	    	$(this).closest('.further_info_read_more_button').click();
	    	
	    }
	});
	
	$('body').on('click', '.further_info_read_more a', function() {
		var ele_clicked = $(this);
		var div_container = $("#further_info_detail");
		var transition_delay = 1000;
		
		if (div_container.hasClass("fixedHeight")) {
			linkText = 'Read less';
			$('#further_info_detail').removeClass("fixedHeight", transition_delay);
		} else {
			linkText = 'Read more';
			$('#further_info_detail').addClass("fixedHeight", transition_delay);
		}
		ele_clicked.text(linkText);
	});
	
	//Click event to show phone number.
	$('.profile_contact_phone a').on('click', function() {
		var ele_clicked = $(this);
		var phone_number = $('.profile_phone_number').val();
		ele_clicked.html(phone_number + '<span><i class="fa fa-phone"></i></span>');		
	});
	
	var left_buffer_is_shown = false;
	$('.tab_navigation_container').on('scroll', function() {
		var nav_container_scrolling = $(this);
		var current_scroll_left_value = nav_container_scrolling.scrollLeft();
		var left_buffer_element = nav_container_scrolling.children('.left_buffer');
		
		if(!left_buffer_is_shown && current_scroll_left_value > 0) {
			left_buffer_is_shown = true;
			left_buffer_element.fadeIn();
		} else if(left_buffer_is_shown && current_scroll_left_value === 0) {
			left_buffer_is_shown = false;
			left_buffer_element.fadeOut();
		}
	});
	
	adjustWidthForTabContainer();
	adjustSocialMediaContainerWidth();
	
	$('.profile_contact_phone a').on('click', function() {
		var ele_clicked = $(this);
		var phone_number = $('.profile_phone_number').val();
		ele_clicked.html(phone_number + '<span><i class="fa fa-phone"></i></span>');
		//ele_clicked.text(phone_number);
		
	});
	$('.left_block').on('click', function() {
		scrollSocialMediaListOneTick("left");
	});
	$('.right_block').on('click', function() {
		scrollSocialMediaListOneTick("right");
	});
	
	
	$('.social_media_container').on('scroll', function() {
		var social_container_scrolling = $(this);
		var social_container_scrolling_width = social_container_scrolling.width();
		var current_scroll_left_value = social_container_scrolling.scrollLeft();
		var left_social_buffer_element = social_container_scrolling.children('.left_block');
		var right_social_buffer_element = social_container_scrolling.children('.right_block');

		if(right_social_buffer_is_shown && current_scroll_left_value === max_social_scroll_value) {
			right_social_buffer_element.fadeOut(function() {
				right_social_buffer_is_shown = false;
		    });
			
		} else if (!right_social_buffer_is_shown && current_scroll_left_value < max_social_scroll_value){
			right_social_buffer_element.fadeIn();
			right_social_buffer_is_shown = true;
		}
		if(!left_social_buffer_is_shown && current_scroll_left_value > 0) {
			left_social_buffer_is_shown = true;
			left_social_buffer_element.fadeIn();
		} else if(left_social_buffer_is_shown && current_scroll_left_value === 0) {
			left_social_buffer_is_shown = false;
			left_social_buffer_element.fadeOut();
		}
	});
	//used for updating social scroll when the screen has changed size
	var rtime;
	var timeout = false;
	var delta = 200;
	$(window).resize(function() {
	    rtime = new Date();
	    if (timeout === false) {
	        timeout = true;
	        setTimeout(screenResizeEnd, delta);
	    }
	});
	function screenResizeEnd() {
	    if (new Date() - rtime < delta) {
	        setTimeout(screenResizeEnd, delta);
	    } else {
	        timeout = false;
	        adjustSocialMediaContainerWidth();
	    }               
	}
	
}); //end document.ready

// Error message.
function errorMessage(err_msg) {
	var msg;	
	msg = "<p>" + err_msg + "</p><p>It looks like there is a problem retrieving this data.</p><p>Please try refreshing your browser or revisit later.</p><p>You can also report this by <a href='mailto:digitalpresence@flinders.edu.au'>sending us an email</a>.</p>";	
	$('.error_msg').html(msg).css("visibility", "visible");	
}


// AjaxErrorHandler
function ajaxErrorHandler(jqXHR, textStatus, exception, errorThrown) {
	var error_msg;
	if (jqXHR.status === 0) {
		error_msg = 'No connection.\n Verify Network.';
    } else if (jqXHR.status == 404) {
    	error_msg = '404 Requested page not found.';
    } else if (jqXHR.status == 500) {
    	error_msg = '500 Internal Server Error.';
    } else if (textStatus === 'parsererror') {
    	error_msg = 'Requested JSON parse failed.';
    } else if (textStatus === 'timeout') {
    	error_msg = 'Time out error.';
    } else if (textStatus === 'abort') {
    	error_msg = 'Ajax request aborted.';
    } else {
    	error_msg = 'Uncaught Error.\n' + jqXHR.responseText;
    }
	errorMessage(error_msg);
}

function adjustWidthForTabContainer() {	
	var staff_profile_nav_tab = $("#staffProfileTab");
	var all_spp_nav_tabs = staff_profile_nav_tab.find(".nav-item");
	var total_tab_continer_width = 0;
	
	all_spp_nav_tabs.each(function() {
		var current_nav_item_width = $(this).width();		
		total_tab_continer_width += current_nav_item_width;
	});
	staff_profile_nav_tab.width(total_tab_continer_width);
	
	return total_tab_continer_width;
}
function adjustSocialMediaContainerWidth() {	
	var social_media_container = $(".social_media_container");
	var social_media_container_width = social_media_container.width();
	var social_media_list = social_media_container.find('.social_media_list');
	var all_social_media_list_items = social_media_container.find('.social_media_item');
	var social_border_width = 1;
	var calculated_social_media_list_width = social_border_width; //1px for first left border.
	var right_block = social_media_container.find('.right_block');
	
	all_social_media_list_items.each(function() {
		var current_social_item_width = $(this).width();		
		calculated_social_media_list_width += (current_social_item_width + social_border_width);
	});
	social_media_list.width(calculated_social_media_list_width);
	//Set the max scroll value
	max_social_scroll_value = social_media_list.width() - social_media_container_width;
	
	if(calculated_social_media_list_width > social_media_container_width) {
		right_social_buffer_is_shown = true;
		right_block.fadeIn();
	} else {
		right_social_buffer_is_shown = false;
		right_block.fadeOut();
	}
	
	return calculated_social_media_list_width;
}

function scrollSocialMediaListOneTick(direction) {		
	var social_container = $(".social_media_container");
	var left_block = social_container.find('.left_block');
	var right_block = social_container.find('.right_block');
	
	if(direction === "left") {
		social_container.animate( { scrollLeft: '-='+social_tick_size }, 300);
//		left_block.fadeIn();
	}
	else {
		social_container.animate( { scrollLeft: '+='+social_tick_size }, 300);
//		right_block.fadeIn();
	}
		
	return social_container.scrollLeft();
}

function setSocialTickSize(size) {
	social_tick_size = size;
	return size;
}

(function () {
    var $, AbstractChosen, Chosen, SelectParser, _ref,
        __bind = function (fn, me) {
            return function () {
                return fn.apply(me, arguments);
            };
        },
        __hasProp = {}.hasOwnProperty,
        __extends = function (child, parent) {
            for (var key in parent) {
                if (__hasProp.call(parent, key)) child[key] = parent[key];
            }
            function ctor() {
                this.constructor = child;
            }

            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };

    SelectParser = (function () {
        function SelectParser() {
            this.options_index = 0;
            this.parsed = [];
        }

        SelectParser.prototype.add_node = function (child) {
            if (child.nodeName.toUpperCase() === "OPTGROUP") {
                return this.add_group(child);
            } else {
                return this.add_option(child);
            }
        };

        SelectParser.prototype.add_group = function (group) {
            var group_position, option, _i, _len, _ref, _results;
            group_position = this.parsed.length;
            this.parsed.push({
                array_index: group_position,
                group: true,
                label: this.escapeExpression(group.label),
                title: group.title ? group.title : void 0,
                children: 0,
                disabled: group.disabled,
                classes: group.className
            });
            _ref = group.childNodes;
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                _results.push(this.add_option(option, group_position, group.disabled));
            }
            return _results;
        };

        SelectParser.prototype.add_option = function (option, group_position, group_disabled) {
            if (option.nodeName.toUpperCase() === "OPTION") {
                if (option.text !== "") {
                    if (group_position != null) {
                        this.parsed[group_position].children += 1;
                    }
                    this.parsed.push({
                        array_index: this.parsed.length,
                        options_index: this.options_index,
                        value: option.value,
                        text: option.text,
                        html: option.innerHTML,
                        title: option.title ? option.title : void 0,
                        selected: option.selected,
                        disabled: group_disabled === true ? group_disabled : option.disabled,
                        group_array_index: group_position,
                        group_label: group_position != null ? this.parsed[group_position].label : null,
                        classes: option.className,
                        style: option.style.cssText
                    });
                } else {
                    this.parsed.push({
                        array_index: this.parsed.length,
                        options_index: this.options_index,
                        empty: true
                    });
                }
                return this.options_index += 1;
            }
        };

        SelectParser.prototype.escapeExpression = function (text) {
            var map, unsafe_chars;
            if ((text == null) || text === false) {
                return "";
            }
            if (!/[\&\<\>\"\'\`]/.test(text)) {
                return text;
            }
            map = {
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#x27;",
                "`": "&#x60;"
            };
            unsafe_chars = /&(?!\w+;)|[\<\>\"\'\`]/g;
            return text.replace(unsafe_chars, function (chr) {
                return map[chr] || "&amp;";
            });
        };

        return SelectParser;

    })();

    SelectParser.select_to_array = function (select) {
        var child, parser, _i, _len, _ref;
        parser = new SelectParser();
        _ref = select.childNodes;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            child = _ref[_i];
            parser.add_node(child);
        }
        return parser.parsed;
    };

    AbstractChosen = (function () {
        function AbstractChosen(form_field, options) {
            this.form_field = form_field;
            this.options = options != null ? options : {};
            this.label_click_handler = __bind(this.label_click_handler, this);
            if (!AbstractChosen.browser_is_supported()) {
                return;
            }
            this.is_multiple = this.form_field.multiple;
            this.set_default_text();
            this.set_default_values();
            this.setup();
            this.set_up_html();
            this.register_observers();
            this.on_ready();
        }

        AbstractChosen.prototype.set_default_values = function () {
            var _this = this;
            this.click_test_action = function (evt) {
                return _this.test_active_click(evt);
            };
            this.activate_action = function (evt) {
                return _this.activate_field(evt);
            };
            this.active_field = false;
            this.mouse_on_container = false;
            this.results_showing = false;
            this.result_highlighted = null;
            this.is_rtl = this.options.rtl || /\bchosen-rtl\b/.test(this.form_field.className);
            this.allow_single_deselect = (this.options.allow_single_deselect != null) && (this.form_field.options[0] != null) && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
            this.disable_search_threshold = this.options.disable_search_threshold || 0;
            this.disable_search = this.options.disable_search || false;
            this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
            this.group_search = this.options.group_search != null ? this.options.group_search : true;
            this.search_contains = this.options.search_contains || false;
            this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
            this.max_selected_options = this.options.max_selected_options || Infinity;
            this.inherit_select_classes = this.options.inherit_select_classes || false;
            this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
            this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
            this.include_group_label_in_selected = this.options.include_group_label_in_selected || false;
            this.max_shown_results = this.options.max_shown_results || Number.POSITIVE_INFINITY;
            this.case_sensitive_search = this.options.case_sensitive_search || false;
            return this.hide_results_on_select = this.options.hide_results_on_select != null ? this.options.hide_results_on_select : true;
        };

        AbstractChosen.prototype.set_default_text = function () {
            if (this.form_field.getAttribute("data-placeholder")) {
                this.default_text = this.form_field.getAttribute("data-placeholder");
            } else if (this.is_multiple) {
                this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
            } else {
                this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
            }
            this.default_text = this.escape_html(this.default_text);
            return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
        };

        AbstractChosen.prototype.choice_label = function (item) {
            if (this.include_group_label_in_selected && (item.group_label != null)) {
                return "<b class="
                group - name
                ">" + item.group_label + "</b>" + item.html;
            } else {
                return item.html;
            }
        };

        AbstractChosen.prototype.mouse_enter = function () {
            return this.mouse_on_container = true;
        };

        AbstractChosen.prototype.mouse_leave = function () {
            return this.mouse_on_container = false;
        };

        AbstractChosen.prototype.input_focus = function (evt) {
            var _this = this;
            if (this.is_multiple) {
                if (!this.active_field) {
                    return setTimeout((function () {
                        return _this.container_mousedown();
                    }), 50);
                }
            } else {
                if (!this.active_field) {
                    return this.activate_field();
                }
            }
        };

        AbstractChosen.prototype.input_blur = function (evt) {
            var _this = this;
            if (!this.mouse_on_container) {
                this.active_field = false;
                return setTimeout((function () {
                    return _this.blur_test();
                }), 100);
            }
        };

        AbstractChosen.prototype.label_click_handler = function (evt) {
            if (this.is_multiple) {
                return this.container_mousedown(evt);
            } else {
                return this.activate_field();
            }
        };

        AbstractChosen.prototype.results_option_build = function (options) {
            var content, data, data_content, shown_results, _i, _len, _ref;
            content = '';
            shown_results = 0;
            _ref = this.results_data;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                data = _ref[_i];
                data_content = '';
                if (data.group) {
                    data_content = this.result_add_group(data);
                } else {
                    data_content = this.result_add_option(data);
                }
                if (data_content !== '') {
                    shown_results++;
                    content += data_content;
                }
                if (options != null ? options.first : void 0) {
                    if (data.selected && this.is_multiple) {
                        this.choice_build(data);
                    } else if (data.selected && !this.is_multiple) {
                        this.single_set_selected_text(this.choice_label(data));
                    }
                }
                if (shown_results >= this.max_shown_results) {
                    break;
                }
            }
            return content;
        };

        AbstractChosen.prototype.result_add_option = function (option) {
            var classes, option_el;
            if (!option.search_match) {
                return '';
            }
            if (!this.include_option_in_results(option)) {
                return '';
            }
            classes = [];
            if (!option.disabled && !(option.selected && this.is_multiple)) {
                classes.push("active-result");
            }
            if (option.disabled && !(option.selected && this.is_multiple)) {
                classes.push("disabled-result");
            }
            if (option.selected) {
                classes.push("result-selected");
            }
            if (option.group_array_index != null) {
                classes.push("group-option");
            }
            if (option.classes !== "") {
                classes.push(option.classes);
            }
            option_el = document.createElement("li");
            option_el.className = classes.join(" ");
            option_el.style.cssText = option.style;
            option_el.setAttribute("data-option-array-index", option.array_index);
            option_el.innerHTML = option.search_text;
            if (option.title) {
                option_el.title = option.title;
            }
            return this.outerHTML(option_el);
        };

        AbstractChosen.prototype.result_add_group = function (group) {
            var classes, group_el;
            if (!(group.search_match || group.group_match)) {
                return '';
            }
            if (!(group.active_options > 0)) {
                return '';
            }
            classes = [];
            classes.push("group-result");
            if (group.classes) {
                classes.push(group.classes);
            }
            group_el = document.createElement("li");
            group_el.className = classes.join(" ");
            group_el.innerHTML = group.search_text;
            if (group.title) {
                group_el.title = group.title;
            }
            return this.outerHTML(group_el);
        };

        AbstractChosen.prototype.results_update_field = function () {
            this.set_default_text();
            if (!this.is_multiple) {
                this.results_reset_cleanup();
            }
            this.result_clear_highlight();
            this.results_build();
            if (this.results_showing) {
                return this.winnow_results();
            }
        };

        AbstractChosen.prototype.reset_single_select_options = function () {
            var result, _i, _len, _ref, _results;
            _ref = this.results_data;
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                result = _ref[_i];
                if (result.selected) {
                    _results.push(result.selected = false);
                } else {
                    _results.push(void 0);
                }
            }
            return _results;
        };

        AbstractChosen.prototype.results_toggle = function () {
            if (this.results_showing) {
                return this.results_hide();
            } else {
                return this.results_show();
            }
        };

        AbstractChosen.prototype.results_search = function (evt) {
            if (this.results_showing) {
                return this.winnow_results();
            } else {
                return this.results_show();
            }
        };

        AbstractChosen.prototype.winnow_results = function () {
            var escapedSearchText, highlightRegex, option, regex, results, results_group, searchText, startpos, text, _i, _len, _ref;
            this.no_results_clear();
            results = 0;
            searchText = this.get_search_text();
            escapedSearchText = searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
            regex = this.get_search_regex(escapedSearchText);
            highlightRegex = this.get_highlight_regex(escapedSearchText);
            _ref = this.results_data;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                option.search_match = false;
                results_group = null;
                if (this.include_option_in_results(option)) {
                    if (option.group) {
                        option.group_match = false;
                        option.active_options = 0;
                    }
                    if ((option.group_array_index != null) && this.results_data[option.group_array_index]) {
                        results_group = this.results_data[option.group_array_index];
                        if (results_group.active_options === 0 && results_group.search_match) {
                            results += 1;
                        }
                        results_group.active_options += 1;
                    }
                    option.search_text = option.group ? option.label : option.html;
                    if (!(option.group && !this.group_search)) {
                        option.search_match = this.search_string_match(option.search_text, regex);
                        if (option.search_match && !option.group) {
                            results += 1;
                        }
                        if (option.search_match) {
                            if (searchText.length) {
                                startpos = option.search_text.search(highlightRegex);
                                text = option.search_text.substr(0, startpos + searchText.length) + '</em>' + option.search_text.substr(startpos + searchText.length);
                                option.search_text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
                            }
                            if (results_group != null) {
                                results_group.group_match = true;
                            }
                        } else if ((option.group_array_index != null) && this.results_data[option.group_array_index].search_match) {
                            option.search_match = true;
                        }
                    }
                }
            }
            this.result_clear_highlight();
            if (results < 1 && searchText.length) {
                this.update_results_content("");
                return this.no_results(searchText);
            } else {
                this.update_results_content(this.results_option_build());
                return this.winnow_results_set_highlight();
            }
        };

        AbstractChosen.prototype.get_search_regex = function (escaped_search_string) {
            var regex_anchor, regex_flag;
            regex_anchor = this.search_contains ? "" : "^";
            regex_flag = this.case_sensitive_search ? "" : "i";
            return new RegExp(regex_anchor + escaped_search_string, regex_flag);
        };

        AbstractChosen.prototype.get_highlight_regex = function (escaped_search_string) {
            var regex_anchor, regex_flag;
            regex_anchor = this.search_contains ? "" : "\\b";
            regex_flag = this.case_sensitive_search ? "" : "i";
            return new RegExp(regex_anchor + escaped_search_string, regex_flag);
        };

        AbstractChosen.prototype.search_string_match = function (search_string, regex) {
            var part, parts, _i, _len;
            if (regex.test(search_string)) {
                return true;
            } else if (this.enable_split_word_search && (search_string.indexOf(" ") >= 0 || search_string.indexOf("[") === 0)) {
                parts = search_string.replace(/\[|\]/g, "").split(" ");
                if (parts.length) {
                    for (_i = 0, _len = parts.length; _i < _len; _i++) {
                        part = parts[_i];
                        if (regex.test(part)) {
                            return true;
                        }
                    }
                }
            }
        };

        AbstractChosen.prototype.choices_count = function () {
            var option, _i, _len, _ref;
            if (this.selected_option_count != null) {
                return this.selected_option_count;
            }
            this.selected_option_count = 0;
            _ref = this.form_field.options;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                if (option.selected) {
                    this.selected_option_count += 1;
                }
            }
            return this.selected_option_count;
        };

        AbstractChosen.prototype.choices_click = function (evt) {
            evt.preventDefault();
            if (!(this.results_showing || this.is_disabled)) {
                return this.results_show();
            }
        };

        AbstractChosen.prototype.keydown_checker = function (evt) {
            var stroke, _ref;
            stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
            this.search_field_scale();
            if (stroke !== 8 && this.pending_backstroke) {
                this.clear_backstroke();
            }
            switch (stroke) {
                case 8:
                    this.backstroke_length = this.get_search_field_value().length;
                    break;
                case 9:
                    if (this.results_showing && !this.is_multiple) {
                        this.result_select(evt);
                    }
                    this.mouse_on_container = false;
                    break;
                case 13:
                    if (this.results_showing) {
                        evt.preventDefault();
                    }
                    break;
                case 27:
                    if (this.results_showing) {
                        evt.preventDefault();
                    }
                    break;
                case 32:
                    if (this.disable_search) {
                        evt.preventDefault();
                    }
                    break;
                case 38:
                    evt.preventDefault();
                    this.keyup_arrow();
                    break;
                case 40:
                    evt.preventDefault();
                    this.keydown_arrow();
                    break;
            }
        };

        AbstractChosen.prototype.keyup_checker = function (evt) {
            var stroke, _ref;
            stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
            this.search_field_scale();
            switch (stroke) {
                case 8:
                    if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
                        this.keydown_backstroke();
                    } else if (!this.pending_backstroke) {
                        this.result_clear_highlight();
                        this.results_search();
                    }
                    break;
                case 13:
                    evt.preventDefault();
                    if (this.results_showing) {
                        this.result_select(evt);
                    }
                    break;
                case 27:
                    if (this.results_showing) {
                        this.results_hide();
                    }
                    break;
                case 9:
                case 16:
                case 17:
                case 18:
                case 38:
                case 40:
                case 91:
                    break;
                default:
                    this.results_search();
                    break;
            }
        };

        AbstractChosen.prototype.clipboard_event_checker = function (evt) {
            var _this = this;
            if (this.is_disabled) {
                return;
            }
            return setTimeout((function () {
                return _this.results_search();
            }), 50);
        };

        AbstractChosen.prototype.container_width = function () {
            if (this.options.width != null) {
                return this.options.width;
            } else {
                return "" + this.form_field.offsetWidth + "px";
            }
        };

        AbstractChosen.prototype.include_option_in_results = function (option) {
            if (this.is_multiple && (!this.display_selected_options && option.selected)) {
                return false;
            }
            if (!this.display_disabled_options && option.disabled) {
                return false;
            }
            if (option.empty) {
                return false;
            }
            return true;
        };

        AbstractChosen.prototype.search_results_touchstart = function (evt) {
            this.touch_started = true;
            return this.search_results_mouseover(evt);
        };

        AbstractChosen.prototype.search_results_touchmove = function (evt) {
            this.touch_started = false;
            return this.search_results_mouseout(evt);
        };

        AbstractChosen.prototype.search_results_touchend = function (evt) {
            if (this.touch_started) {
                return this.search_results_mouseup(evt);
            }
        };

        AbstractChosen.prototype.outerHTML = function (element) {
            var tmp;
            if (element.outerHTML) {
                return element.outerHTML;
            }
            tmp = document.createElement("div");
            tmp.appendChild(element);
            return tmp.innerHTML;
        };

        AbstractChosen.browser_is_supported = function () {
            if ("Microsoft Internet Explorer" === window.navigator.appName) {
                return document.documentMode >= 8;
            }
            if (/iP(od|hone)/i.test(window.navigator.userAgent) || /IEMobile/i.test(window.navigator.userAgent) || /Windows Phone/i.test(window.navigator.userAgent) || /BlackBerry/i.test(window.navigator.userAgent) || /BB10/i.test(window.navigator.userAgent) || /Android.*Mobile/i.test(window.navigator.userAgent)) {
                // OIA: force on mobiles
                // return false;
                return true;
            }
            return true;
        };

        AbstractChosen.default_multiple_text = "Select Some Options";

        AbstractChosen.default_single_text = "Select an Option";

        AbstractChosen.default_no_result_text = "No results match";

        return AbstractChosen;

    })();

    $ = jQuery;

    $.fn.extend({
        chosen: function (options) {
            if (!AbstractChosen.browser_is_supported()) {
                return this;
            }
            return this.each(function (input_field) {
                var $this, chosen;
                $this = $(this);
                chosen = $this.data('chosen');
                if (options === 'destroy') {
                    if (chosen instanceof Chosen) {
                        chosen.destroy();
                    }
                    return;
                }
                if (!(chosen instanceof Chosen)) {
                    $this.data('chosen', new Chosen(this, options));
                }
            });
        }
    });

    Chosen = (function (_super) {
        __extends(Chosen, _super);

        function Chosen() {
            _ref = Chosen.__super__.constructor.apply(this, arguments);
            return _ref;
        }

        Chosen.prototype.setup = function () {
            this.form_field_jq = $(this.form_field);
            return this.current_selectedIndex = this.form_field.selectedIndex;
        };

        Chosen.prototype.set_up_html = function () {
            var container_classes, container_props;
            container_classes = ["chosen-container"];
            container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));
            if (this.inherit_select_classes && this.form_field.className) {
                container_classes.push(this.form_field.className);
            }
            if (this.is_rtl) {
                container_classes.push("chosen-rtl");
            }
            container_props = {
                'class': container_classes.join(' '),
                'style': "width: " + (this.container_width()) + ";",
                'title': this.form_field.title
            };
            if (this.form_field.id.length) {
                container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + "_chosen";
            }
            this.container = $("<div />", container_props);
            if (this.is_multiple) {
                this.container.html('<ul class="chosen-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chosen-drop"><ul class="chosen-results"></ul></div>');
            } else {
                this.container.html('<a class="chosen-single chosen-default"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chosen-drop"><div class="chosen-search"><input type="text" autocomplete="off" /></div><ul class="chosen-results"></ul></div>');
            }
            this.form_field_jq.hide().after(this.container);
            this.dropdown = this.container.find('div.chosen-drop').first();
            this.search_field = this.container.find('input').first();
            this.search_results = this.container.find('ul.chosen-results').first();
            this.search_field_scale();
            this.search_no_results = this.container.find('li.no-results').first();
            if (this.is_multiple) {
                this.search_choices = this.container.find('ul.chosen-choices').first();
                this.search_container = this.container.find('li.search-field').first();
            } else {
                this.search_container = this.container.find('div.chosen-search').first();
                this.selected_item = this.container.find('.chosen-single').first();
            }
            this.results_build();
            this.set_tab_index();
            return this.set_label_behavior();
        };

        Chosen.prototype.on_ready = function () {
            return this.form_field_jq.trigger("chosen:ready", {
                chosen: this
            });
        };

        Chosen.prototype.register_observers = function () {
            var _this = this;
            this.container.bind('touchstart.chosen', function (evt) {
                _this.container_mousedown(evt);
            });
            this.container.bind('touchend.chosen', function (evt) {
                _this.container_mouseup(evt);
            });
            this.container.bind('mousedown.chosen', function (evt) {
                _this.container_mousedown(evt);
            });
            this.container.bind('mouseup.chosen', function (evt) {
                _this.container_mouseup(evt);
            });
            this.container.bind('mouseenter.chosen', function (evt) {
                _this.mouse_enter(evt);
            });
            this.container.bind('mouseleave.chosen', function (evt) {
                _this.mouse_leave(evt);
            });
            this.search_results.bind('mouseup.chosen', function (evt) {
                _this.search_results_mouseup(evt);
            });
            this.search_results.bind('mouseover.chosen', function (evt) {
                _this.search_results_mouseover(evt);
            });
            this.search_results.bind('mouseout.chosen', function (evt) {
                _this.search_results_mouseout(evt);
            });
            this.search_results.bind('mousewheel.chosen DOMMouseScroll.chosen', function (evt) {
                _this.search_results_mousewheel(evt);
            });
            this.search_results.bind('touchstart.chosen', function (evt) {
                _this.search_results_touchstart(evt);
            });
            this.search_results.bind('touchmove.chosen', function (evt) {
                _this.search_results_touchmove(evt);
            });
            this.search_results.bind('touchend.chosen', function (evt) {
                _this.search_results_touchend(evt);
            });
            this.form_field_jq.bind("chosen:updated.chosen", function (evt) {
                _this.results_update_field(evt);
            });
            this.form_field_jq.bind("chosen:activate.chosen", function (evt) {
                _this.activate_field(evt);
            });
            this.form_field_jq.bind("chosen:open.chosen", function (evt) {
                _this.container_mousedown(evt);
            });
            this.form_field_jq.bind("chosen:close.chosen", function (evt) {
                _this.close_field(evt);
            });
            this.search_field.bind('blur.chosen', function (evt) {
                _this.input_blur(evt);
            });
            this.search_field.bind('keyup.chosen', function (evt) {
                _this.keyup_checker(evt);
            });
            this.search_field.bind('keydown.chosen', function (evt) {
                _this.keydown_checker(evt);
            });
            this.search_field.bind('focus.chosen', function (evt) {
                _this.input_focus(evt);
            });
            this.search_field.bind('cut.chosen', function (evt) {
                _this.clipboard_event_checker(evt);
            });
            this.search_field.bind('paste.chosen', function (evt) {
                _this.clipboard_event_checker(evt);
            });
            if (this.is_multiple) {
                return this.search_choices.bind('click.chosen', function (evt) {
                    _this.choices_click(evt);
                });
            } else {
                return this.container.bind('click.chosen', function (evt) {
                    evt.preventDefault();
                });
            }
        };

        Chosen.prototype.destroy = function () {
            $(this.container[0].ownerDocument).unbind('click.chosen', this.click_test_action);
            if (this.form_field_label.length > 0) {
                this.form_field_label.unbind('click.chosen');
            }
            if (this.search_field[0].tabIndex) {
                this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
            }
            this.container.remove();
            this.form_field_jq.removeData('chosen');
            return this.form_field_jq.show();
        };

        Chosen.prototype.search_field_disabled = function () {
            this.is_disabled = this.form_field.disabled || this.form_field_jq.parents('fieldset').is(':disabled');
            this.container.toggleClass('chosen-disabled', this.is_disabled);
            this.search_field[0].disabled = this.is_disabled;
            if (!this.is_multiple) {
                this.selected_item.unbind('focus.chosen', this.activate_field);
            }
            if (this.is_disabled) {
                return this.close_field();
            } else if (!this.is_multiple) {
                return this.selected_item.bind('focus.chosen', this.activate_field);
            }
        };

        Chosen.prototype.container_mousedown = function (evt) {
            var _ref1;
            if (this.is_disabled) {
                return;
            }
            if (evt && ((_ref1 = evt.type) === 'mousedown' || _ref1 === 'touchstart') && !this.results_showing) {
                evt.preventDefault();
            }
            if (!((evt != null) && ($(evt.target)).hasClass("search-choice-close"))) {
                if (!this.active_field) {
                    if (this.is_multiple) {
                        this.search_field.val("");
                    }
                    $(this.container[0].ownerDocument).bind('click.chosen', this.click_test_action);
                    this.results_show();
                } else if (!this.is_multiple && evt && (($(evt.target)[0] === this.selected_item[0]) || $(evt.target).parents("a.chosen-single").length)) {
                    evt.preventDefault();
                    this.results_toggle();
                }
                return this.activate_field();
            }
        };

        Chosen.prototype.container_mouseup = function (evt) {
            if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
                return this.results_reset(evt);
            }
        };

        Chosen.prototype.search_results_mousewheel = function (evt) {
            var delta;
            if (evt.originalEvent) {
                delta = evt.originalEvent.deltaY || -evt.originalEvent.wheelDelta || evt.originalEvent.detail;
            }
            if (delta != null) {
                evt.preventDefault();
                if (evt.type === 'DOMMouseScroll') {
                    delta = delta * 40;
                }
                return this.search_results.scrollTop(delta + this.search_results.scrollTop());
            }
        };

        Chosen.prototype.blur_test = function (evt) {
            if (!this.active_field && this.container.hasClass("chosen-container-active")) {
                return this.close_field();
            }
        };

        Chosen.prototype.close_field = function () {
            $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
            this.active_field = false;
            this.results_hide();
            this.container.removeClass("chosen-container-active");
            this.clear_backstroke();
            this.show_search_field_default();
            this.search_field_scale();
            return this.search_field.blur();
        };

        Chosen.prototype.activate_field = function () {
            if (this.is_disabled) {
                return;
            }
            this.container.addClass("chosen-container-active");
            this.active_field = true;
            this.search_field.val(this.search_field.val());
            return this.search_field.focus();
        };

        Chosen.prototype.test_active_click = function (evt) {
            var active_container;
            active_container = $(evt.target).closest('.chosen-container');
            if (active_container.length && this.container[0] === active_container[0]) {
                return this.active_field = true;
            } else {
                return this.close_field();
            }
        };

        Chosen.prototype.results_build = function () {
            this.parsing = true;
            this.selected_option_count = null;
            this.results_data = SelectParser.select_to_array(this.form_field);
            if (this.is_multiple) {
                this.search_choices.find("li.search-choice").remove();
            } else if (!this.is_multiple) {
                this.single_set_selected_text();
                if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
                    this.search_field[0].readOnly = true;
                    this.container.addClass("chosen-container-single-nosearch");
                } else {
                    this.search_field[0].readOnly = false;
                    this.container.removeClass("chosen-container-single-nosearch");
                }
            }
            this.update_results_content(this.results_option_build({
                first: true
            }));
            this.search_field_disabled();
            this.show_search_field_default();
            this.search_field_scale();
            return this.parsing = false;
        };

        Chosen.prototype.result_do_highlight = function (el) {
            var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
            if (el.length) {
                this.result_clear_highlight();
                this.result_highlight = el;
                this.result_highlight.addClass("highlighted");
                maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
                visible_top = this.search_results.scrollTop();
                visible_bottom = maxHeight + visible_top;
                high_top = this.result_highlight.position().top + this.search_results.scrollTop();
                high_bottom = high_top + this.result_highlight.outerHeight();
                if (high_bottom >= visible_bottom) {
                    return this.search_results.scrollTop((high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0);
                } else if (high_top < visible_top) {
                    return this.search_results.scrollTop(high_top);
                }
            }
        };

        Chosen.prototype.result_clear_highlight = function () {
            if (this.result_highlight) {
                this.result_highlight.removeClass("highlighted");
            }
            return this.result_highlight = null;
        };

        Chosen.prototype.results_show = function () {
            if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
                this.form_field_jq.trigger("chosen:maxselected", {
                    chosen: this
                });
                return false;
            }
            this.container.addClass("chosen-with-drop");
            this.results_showing = true;
            this.search_field.focus();
            this.search_field.val(this.get_search_field_value());
            this.winnow_results();
            return this.form_field_jq.trigger("chosen:showing_dropdown", {
                chosen: this
            });
        };

        Chosen.prototype.update_results_content = function (content) {
            return this.search_results.html(content);
        };

        Chosen.prototype.results_hide = function () {
            if (this.results_showing) {
                this.result_clear_highlight();
                this.container.removeClass("chosen-with-drop");
                this.form_field_jq.trigger("chosen:hiding_dropdown", {
                    chosen: this
                });
            }
            return this.results_showing = false;
        };

        Chosen.prototype.set_tab_index = function (el) {
            var ti;
            if (this.form_field.tabIndex) {
                ti = this.form_field.tabIndex;
                this.form_field.tabIndex = -1;
                return this.search_field[0].tabIndex = ti;
            }
        };

        Chosen.prototype.set_label_behavior = function () {
            this.form_field_label = this.form_field_jq.parents("label");
            if (!this.form_field_label.length && this.form_field.id.length) {
                this.form_field_label = $("label[for='" + this.form_field.id + "']");
            }
            if (this.form_field_label.length > 0) {
                return this.form_field_label.bind('click.chosen', this.label_click_handler);
            }
        };

        Chosen.prototype.show_search_field_default = function () {
            if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
                this.search_field.val(this.default_text);
                return this.search_field.addClass("default");
            } else {
                this.search_field.val("");
                return this.search_field.removeClass("default");
            }
        };

        Chosen.prototype.search_results_mouseup = function (evt) {
            var target;
            target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
            if (target.length) {
                this.result_highlight = target;
                this.result_select(evt);
                return this.search_field.focus();
            }
        };

        Chosen.prototype.search_results_mouseover = function (evt) {
            var target;
            target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
            if (target) {
                return this.result_do_highlight(target);
            }
        };

        Chosen.prototype.search_results_mouseout = function (evt) {
            if ($(evt.target).hasClass("active-result" || $(evt.target).parents('.active-result').first())) {
                return this.result_clear_highlight();
            }
        };

        Chosen.prototype.choice_build = function (item) {
            var choice, close_link,
                _this = this;
            choice = $('<li />', {
                "class": "search-choice"
            }).html("<span>" + (this.choice_label(item)) + "</span>");
            if (item.disabled) {
                choice.addClass('search-choice-disabled');
            } else {
                close_link = $('<a />', {
                    "class": 'search-choice-close',
                    'data-option-array-index': item.array_index
                });
                close_link.bind('click.chosen', function (evt) {
                    return _this.choice_destroy_link_click(evt);
                });
                choice.append(close_link);
            }
            return this.search_container.before(choice);
        };

        Chosen.prototype.choice_destroy_link_click = function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (!this.is_disabled) {
                return this.choice_destroy($(evt.target));
            }
        };

        Chosen.prototype.choice_destroy = function (link) {
            if (this.result_deselect(link[0].getAttribute("data-option-array-index"))) {
                if (this.active_field) {
                    this.search_field.focus();
                } else {
                    this.show_search_field_default();
                }
                if (this.is_multiple && this.choices_count() > 0 && this.get_search_field_value().length < 1) {
                    this.results_hide();
                }
                link.parents('li').first().remove();
                return this.search_field_scale();
            }
        };

        Chosen.prototype.results_reset = function () {
            this.reset_single_select_options();
            this.form_field.options[0].selected = true;
            this.single_set_selected_text();
            this.show_search_field_default();
            this.results_reset_cleanup();
            this.trigger_form_field_change();
            if (this.active_field) {
                return this.results_hide();
            }
        };

        Chosen.prototype.results_reset_cleanup = function () {
            this.current_selectedIndex = this.form_field.selectedIndex;
            return this.selected_item.find("abbr").remove();
        };

        Chosen.prototype.result_select = function (evt) {
            var high, item;
            if (this.result_highlight) {
                high = this.result_highlight;
                this.result_clear_highlight();
                if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
                    this.form_field_jq.trigger("chosen:maxselected", {
                        chosen: this
                    });
                    return false;
                }
                if (this.is_multiple) {
                    high.removeClass("active-result");
                } else {
                    this.reset_single_select_options();
                }
                high.addClass("result-selected");
                item = this.results_data[high[0].getAttribute("data-option-array-index")];
                item.selected = true;
                this.form_field.options[item.options_index].selected = true;
                this.selected_option_count = null;
                if (this.is_multiple) {
                    this.choice_build(item);
                } else {
                    this.single_set_selected_text(this.choice_label(item));
                }
                if (!(this.is_multiple && (!this.hide_results_on_select || (evt.metaKey || evt.ctrlKey)))) {
                    this.results_hide();
                    this.show_search_field_default();
                }
                if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
                    this.trigger_form_field_change({
                        selected: this.form_field.options[item.options_index].value
                    });
                }
                this.current_selectedIndex = this.form_field.selectedIndex;
                evt.preventDefault();
                return this.search_field_scale();
            }
        };

        Chosen.prototype.single_set_selected_text = function (text) {
            if (text == null) {
                text = this.default_text;
            }
            if (text === this.default_text) {
                this.selected_item.addClass("chosen-default");
            } else {
                this.single_deselect_control_build();
                this.selected_item.removeClass("chosen-default");
            }
            return this.selected_item.find("span").html(text);
        };

        Chosen.prototype.result_deselect = function (pos) {
            var result_data;
            result_data = this.results_data[pos];
            if (!this.form_field.options[result_data.options_index].disabled) {
                result_data.selected = false;
                this.form_field.options[result_data.options_index].selected = false;
                this.selected_option_count = null;
                this.result_clear_highlight();
                if (this.results_showing) {
                    this.winnow_results();
                }
                this.trigger_form_field_change({
                    deselected: this.form_field.options[result_data.options_index].value
                });
                this.search_field_scale();
                return true;
            } else {
                return false;
            }
        };

        Chosen.prototype.single_deselect_control_build = function () {
            if (!this.allow_single_deselect) {
                return;
            }
            if (!this.selected_item.find("abbr").length) {
                this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
            }
            return this.selected_item.addClass("chosen-single-with-deselect");
        };

        Chosen.prototype.get_search_field_value = function () {
            return this.search_field.val();
        };

        Chosen.prototype.get_search_text = function () {
            return this.escape_html($.trim(this.get_search_field_value()));
        };

        Chosen.prototype.escape_html = function (text) {
            return $('<div/>').text(text).html();
        };

        Chosen.prototype.winnow_results_set_highlight = function () {
            var do_high, selected_results;
            selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
            do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
            if (do_high != null) {
                return this.result_do_highlight(do_high);
            }
        };

        Chosen.prototype.no_results = function (terms) {
            var no_results_html;
            no_results_html = $('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>');
            no_results_html.find("span").first().html(terms);
            this.search_results.append(no_results_html);
            return this.form_field_jq.trigger("chosen:no_results", {
                chosen: this
            });
        };

        Chosen.prototype.no_results_clear = function () {
            return this.search_results.find(".no-results").remove();
        };

        Chosen.prototype.keydown_arrow = function () {
            var next_sib;
            if (this.results_showing && this.result_highlight) {
                next_sib = this.result_highlight.nextAll("li.active-result").first();
                if (next_sib) {
                    return this.result_do_highlight(next_sib);
                }
            } else {
                return this.results_show();
            }
        };

        Chosen.prototype.keyup_arrow = function () {
            var prev_sibs;
            if (!this.results_showing && !this.is_multiple) {
                return this.results_show();
            } else if (this.result_highlight) {
                prev_sibs = this.result_highlight.prevAll("li.active-result");
                if (prev_sibs.length) {
                    return this.result_do_highlight(prev_sibs.first());
                } else {
                    if (this.choices_count() > 0) {
                        this.results_hide();
                    }
                    return this.result_clear_highlight();
                }
            }
        };

        Chosen.prototype.keydown_backstroke = function () {
            var next_available_destroy;
            if (this.pending_backstroke) {
                this.choice_destroy(this.pending_backstroke.find("a").first());
                return this.clear_backstroke();
            } else {
                next_available_destroy = this.search_container.siblings("li.search-choice").last();
                if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
                    this.pending_backstroke = next_available_destroy;
                    if (this.single_backstroke_delete) {
                        return this.keydown_backstroke();
                    } else {
                        return this.pending_backstroke.addClass("search-choice-focus");
                    }
                }
            }
        };

        Chosen.prototype.clear_backstroke = function () {
            if (this.pending_backstroke) {
                this.pending_backstroke.removeClass("search-choice-focus");
            }
            return this.pending_backstroke = null;
        };

        Chosen.prototype.search_field_scale = function () {
            var div, f_width, h, style, style_block, styles, w, _i, _len;
            if (this.is_multiple) {
                h = 0;
                w = 0;
                style_block = "position:absolute; left: -1000px; top: -1000px; display: none; white-space: pre;";
                styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
                for (_i = 0, _len = styles.length; _i < _len; _i++) {
                    style = styles[_i];
                    style_block += style + ":" + this.search_field.css(style) + ";";
                }
                div = $('<div />', {
                    'style': style_block
                });
                div.text(this.get_search_field_value());
                $('body').append(div);
                w = div.width() + 25;
                div.remove();
                f_width = this.container.outerWidth();
                if (w > f_width - 10) {
                    w = f_width - 10;
                }
                return this.search_field.css({
                    'width': w + 'px'
                });
            }
        };

        Chosen.prototype.trigger_form_field_change = function (extra) {
            this.form_field_jq.trigger("input", extra);
            return this.form_field_jq.trigger("change", extra);
        };

        return Chosen;

    })(AbstractChosen);

}).call(this);

$(function () {

    /*media hub selectors in filter*/
    if ($('.chosen-select').length > 0) {
        $(".chosen-select").chosen({disable_search_threshold: 100});
        $('.chosen-select').on('touchstart', function(e){
            e.stopPropagation(); e.preventDefault();
            // Trigger the mousedown event.
            $(this).trigger('mousedown');
        });
    }

    /*media hub yellow panel button in filter -mobile version - */
    $('.filter_section_button_mobile a').click(function () {
        $(this).closest('.filter_section_button_mobile').toggleClass('close_view_btn').next().toggleClass('close_view');

    });
    /*solve problem with $.zIndex*/
    $.zIndex = $.fn.zIndex = function (opt) {
        var def = {inc: 10, group: "*"};
        $.extend(def, opt);
        var zmax = 0;
        $(def.group).each(function () {
            var cur = parseInt($(this).css('z-index'));
            zmax = cur > zmax ? cur : zmax;
        });
        if (!this.jquery)
            return zmax;

        return this.each(function () {
            zmax += def.inc;
            $(this).css("z-index", zmax);
        });
    }

    /*media hub datepicker*/
    // Block autokeyboard for datepickers on mobiles and tablets
    if (/iP(ad|od|hone)/i.test(window.navigator.userAgent) || /IEMobile/i.test(window.navigator.userAgent) || /Windows Phone/i.test(window.navigator.userAgent) || /BlackBerry/i.test(window.navigator.userAgent) || /BB10/i.test(window.navigator.userAgent) || /Android.*Mobile/i.test(window.navigator.userAgent)) {
        $("#from").prop('readonly', true);
        $("#to").prop('readonly', true);
    }
    var dateFormat = "dd/mm/yy",
        from = $("#from").datepicker({
            defaultDate: "+1w",
            dateFormat: 'dd/mm/yy',
            showButtonPanel: true,
            numberOfMonths: 1,
            beforeShow: function (textbox, instance) {
                setTimeout(function () {
                    var buttonPane = $(textbox).datepicker("widget").find(".ui-datepicker-buttonpane");
                    buttonPane.append('<span onclick="$(\'#from\').datepicker(\'setDate\', null); $(\'#to\').datepicker(\'option\', \'minDate\', null);">Clear filter</span>');
                }, 1);

                instance.dpDiv.css({
                    marginLeft: 'auto'
                });
                $('#ui-datepicker-div').addClass('datepicker_hub');
                $('.ui-datepicker-current').hide();
            }
        }).on("change", function () {
            if (getDate(this)) {
                to.datepicker("option", "minDate", getDate(this));
            }
        }),
        to = $("#to").datepicker({
            defaultDate: "+1w",
            showButtonPanel: true,
            dateFormat: 'dd/mm/yy',
            numberOfMonths: 1,
            beforeShow: function (textbox, instance) {
                setTimeout(function () {
                    var buttonPane = $(textbox).datepicker("widget").find(".ui-datepicker-buttonpane");
                    buttonPane.append('<span onclick="$(\'#to\').datepicker(\'setDate\', null); $(\'#from\').datepicker(\'option\', \'maxDate\', null);">Clear filter</span>');
                }, 1);
                if ($(window).width() > 768) {
                    instance.dpDiv.css({
                        marginLeft: -(textbox.offsetWidth / 48 * (48 + 4)) + 'px'
                    });
                } else {
                    instance.dpDiv.css({
                        marginLeft: 'auto'
                    });
                }
                $('#ui-datepicker-div').addClass('datepicker_hub');
                $('.ui-datepicker-current').hide();
            }
        }).on("change", function () {
            if (getDate(this)) {
                from.datepicker("option", "maxDate", getDate(this));
            }
        });
        var strSelectedDate_1 = new Date($("#from").val());
        var strSelectedDate_2 = new Date($("#to").val());
        var formatedDate1 = $.datepicker.formatDate( "dd/mm/yy", strSelectedDate_1);
        var formatedDate2 = $.datepicker.formatDate( "dd/mm/yy", strSelectedDate_1);


    $(window).resize(function () {
        if ($(window).width() > 768) {
            from.datepicker("hide");
            from.blur();
            to.datepicker("hide");
            to.blur();
        }
    });

    function getDate(element) {
        var date;
        try {
            date = $.datepicker.parseDate(dateFormat, element.value);
        } catch (error) {
            date = null;
        }
        return date;
    }

    /*media hub Search autocomplete*/
    $("#hub_search").autocomplete({
        source: "hub_json/search_example.json",
        appendTo: ".hub_filter_search_results"
    });
    $( ".js-hub-searchtext" ).on( "focus", function() {
        $(this).parent().addClass('active');
        return false;});
    $( ".js-hub-searchtext" ).on( "blur", function() {
        $(this).parent().removeClass('active');
        return false;});
    $( ".js-search-header-active input" ).on( "focus", function() {
        $(this).closest('.gsc-search-box').addClass('active');
        return false;});
    $( ".js-search-header-active input" ).on( "blur", function() {
        $(this).closest('.gsc-search-box').removeClass('active');
        return false;
    });

    //Check for a hash in the location, if there is one, adjust the scroll
    $(document).ready(function() {
    	var hash = window.location.hash;
    	if(hash){
    		$('html, body').stop(); //hopefully stop animation
    		handleAnchorTag($('a[name="'+ hash.replace('#','') +'"], a[id="'+ hash.replace('#','') +'"]').first());
    	}
    });

    /*smooth scroll for anchors*/
    $('.subpage_global_header a[href^="#"], .js-scroll-top[href^="#"],  .head_inner_second_line a[href^="#"], .global_header a[href^="#"], .rte.text a[href^="#"], .context-navigation__list-wrapper a[href^="#"]').on('click',function(){
        //ignore target and scroll to the top!
        if ($(this).hasClass('js-scroll-top')) {
            $.scrollTo($('div[name="'+ $(this).attr("href").substring(1) +'"]'), 1500, 'easeInOutExpo');
        }
        else {
        	handleAnchorTag($('a[name="'+ $(this).attr("href").substring(1) +'"], a[id="'+ $(this).attr("href").substring(1) +'"]').first());
        }
        return false;
    });
    /*smooth scroll for anchors for cta-button*/
    $('.cta-button a[href^="#"]').not('a[href^="#js-"]').on('click',function(){
        if ($(this).hasClass('js-scroll-top')) {
            $.scrollTo($('body[name="'+ $(this).attr("href").substring(1) +'"]'), 1500, 'easeInOutExpo');
        }
        else {
        	handleAnchorTag($('a[name="'+ $(this).attr("href").substring(1) +'"], a[id="'+ $(this).attr("href").substring(1) +'"]').first());
        }
        return false;
    });


    //Smooth scrolling for In page Nav (sticky nav) links
    $('.in_page_nav a.link[href^="#"]').on('click',function(event){
        var extra_offset = $(this).closest(".in_page_nav").get(0).dataset.mobileOffset;
        if ($(window).width() > 991) {
            extra_offset = $(this).closest(".in_page_nav").get(0).dataset.desktopOffset;
        }
        handleAnchorTag($('a[name="'+ $(this).attr("href").substring(1) +'"], a[id="'+ $(this).attr("href").substring(1) +'"]').first(), extra_offset);
        event.preventDefault();
    });

    //GENERIC FUNCTION TO HANDLE ANCHOR TAG SCROLLING
    //target is the html dom element that we want to scroll to
    function handleAnchorTag(scroll_target, extra_offset) {
        extra_offset = extra_offset || 0;
        var total_offset = 76 ;
        var subsite_header_offset = 30;

        if ($(window).width() > 768) {
            total_offset = total_offset + subsite_header_offset; // changed the offset as new header added.
        }
        // For pages with gdpr message.
        if ($('html, body').hasClass('gdpr-shown')) {
            var height = $(".gdpr-notification__container:visible").height();
            total_offset = total_offset + height;
        }

        if(scroll_target.data('parent') === "#accordion") {
            if(scroll_target.hasClass('collapsed')) {
                //This means the accordion for this header is closed
                scroll_target.click();
            }
        } else if(scroll_target.closest('.accordion-card').length == 1) {
            //the target is inside an accordion
            //This line will only click on the parent accordion header if it is collapsed, otherwise it does nothing.
            scroll_target.closest('.accordion-card').find(".accordion-card__header a[data-parent='#accordion'].collapsed").click();

        } else {
            scroll_target.addClass("d-block");
            total_offset = total_offset + 24; // 24 is line height.
        }
        $.scrollTo(scroll_target, 600, { offset: - total_offset - extra_offset});
        if (scroll_target.hasClass("d-block")) {
            scroll_target.removeClass("d-block");
        }

    }

    ////////////////////////////////////////
    /////Start content table pagination/////
    ////////////////////////////////////////

    var scroll_to_element = false;

    function contentTableInputPageChangeDelay(ctInput) {
        var val = $(ctInput).val();
        if(!$.isNumeric(val))return;
        var dynatable = $('#'+$(ctInput).attr('id').substr(0,$(ctInput).attr('id').indexOf("_pag_input_page"))).data('dynatable');
        var maxPage = Math.ceil(dynatable.settings.dataset.queryRecordCount / dynatable.settings.dataset.perPage);
        if(val>0&&val<=maxPage&&dynatable.settings.dataset.page!=val){
            //top = $(ctInput).offset().top - $(window).scrollTop();
            dynatable.paginationPage.set(val);
            dynatable.process();
           // $.scrollTo('#dynatable-search-'+dynatable.$element.attr('id'), 600, {  offset: -100 });
            scrollToContentTable('#dynatable-search-'+dynatable.$element.attr('id'));
        }
    }

    function scrollToContentTable(contentTableId) {
    	if(scroll_to_element) {
    		$.scrollTo(contentTableId, 600, {  offset: -130 });
    	}
    }

    function contentTableInputPageChange(ctInput) {
        if ($(this).data("timeout")) clearTimeout($(this).data("timeout"));
        $(this).data("timeout",setTimeout(function () {
            contentTableInputPageChangeDelay(ctInput);
        },1000));
    }

    function bindPaginationNavigation(dynatable){
        var currentPage = dynatable.settings.dataset.page;
        var maxPage = Math.ceil(dynatable.settings.dataset.queryRecordCount / dynatable.settings.dataset.perPage);
        $('.content-table-pagination-max-'+dynatable.settings.index_on_page).text(maxPage);
        $('#' + dynatable.$element.attr('id') + '_pag_input_page').val(currentPage);
        if(currentPage>1) {
            $('#' + dynatable.$element.attr('id') + '_pag_nav_prev').attr('data-dynatable-page', currentPage-1);
            $('#' + dynatable.$element.attr('id') + '_pag_nav_prev').show();
            $('#' + dynatable.$element.attr('id') + '_pag_nav_prev').on('click',scrollToContentTable('#dynatable-search-'+dynatable.$element.attr('id')));
        }else{
            $('#' + dynatable.$element.attr('id') + '_pag_nav_prev').hide();
        }
        if(currentPage<maxPage) {
            $('#' + dynatable.$element.attr('id') + '_pag_nav_next').attr('data-dynatable-page', currentPage+1);
            $('#' + dynatable.$element.attr('id') + '_pag_nav_next').show();
            $('#' + dynatable.$element.attr('id') + '_pag_nav_next').on('click',scrollToContentTable('#dynatable-search-'+dynatable.$element.attr('id')));
        }else{
            $('#' + dynatable.$element.attr('id') + '_pag_nav_next').hide();
        }
        var ev = $._data($('#' + dynatable.$element.attr('id') + '_pag_input_page').get(0), 'events');
        if(!ev || !ev.input)
        $('#' + dynatable.$element.attr('id') + '_pag_input_page').on('input',function(e){
            contentTableInputPageChange(this);
        });
    }
    function getContentTableSearchLabel(table) {
       var attr = table.attr('search_label');
       if (typeof attr !== typeof undefined && attr !== false) {
            if(attr.length>0)
                return attr;
            else
                return 'Search';
        }else{
            return 'Search'
        }
    }
    function setContentTableSearchAlign(table) {
        if(table.hasClass('table_search_left_align')){
            $('#dynatable-search-'+(table.attr('id'))).css("text-align","left");
        }
    }
    function setContentTableSearchHide(table) {
        var attr = table.attr('search_hide');
        if (typeof attr !== typeof undefined && attr !== false) {
            return false;
        }else{
            return true
        }
    }
    function addIconToContentTableSearch(table) {
        $('<a class="content-table-search-icon"><i class="material-icons"></i></a>').insertAfter('#dynatable-query-search-'+table.attr('id'));
    }
    function bindPaginatedTable(table, rows, index){
        table.bind('dynatable:init', function(e, dynatable) {
            dynatable.$element.find('.dynatable-sort-header:eq(0)').click(); //NOTE: This triggers the scroll
            $('.content-table-pagination-max-'+dynatable.settings.index_on_page).text(Math.ceil(dynatable.settings.dataset.queryRecordCount / dynatable.settings.dataset.perPage));
        }).dynatable({
            inputs: {
                queryEvent: 'blur change keyup',
                multisort: false,
                paginationLinkTarget: null,
                paginationLinkPlacement: 'after',
                paginationClass: 'dynatable-pagination-links media_hub_pagination pagination-links',
                paginationPrev: '',
                paginationNext: '',
                paginationGap: [1,2,2,1],
                pageText: 'Page <input class="js-pagination-current" id="'+table.attr('id')+'_pag_input_page" type="text" value="1" /> of <span class="content-table-pagination-max-'+index+' js-pagination-max content-table-pagination-max"></span><a href="javascript:void(0);" id="'+table.attr('id')+'_pag_nav_prev" title="" class="js-gallery-nav pag_yellow_button btn_left dynatable-page-link"></a> <a href="javascript:void(0);" id="'+table.attr('id')+'_pag_nav_next" title="" class="js-gallery-nav pag_yellow_button btn_right dynatable-page-link"></a>',
                searchText: getContentTableSearchLabel(table),
                processingText: 'Processing...'
            },
            features: {
                paginate: true,
                sort: true,
                search: setContentTableSearchHide(table),
                recordCount: false,
                perPageSelect: false,
                pushState: false,
                appendArrowUp:true
            },
            dataset:{
                ajax: false,
                perPageDefault: rows
            },
             index_on_page: index
        }).bind('dynatable:afterProcess', function(data){
            $(this).find('td').mark($('#dynatable-query-search-'+$(this).attr('id')).val());
            bindPaginationNavigation($(this).data('dynatable'));
        });
        $.when(table.dynatable()).done(function(table) {
            var dynatable = table.data('dynatable');
            bindPaginationNavigation(dynatable);
            setContentTableSearchAlign(table);
            addIconToContentTableSearch(table);
            scroll_to_element = true;
        });
        var ev = $._data($('#' + table.attr('id') + '_pag_input_page').get(0), 'events');
        if(!ev || !ev.input)
        $('#' + table.attr('id') + '_pag_input_page').on('input',function(e){
            contentTableInputPageChange(this);
        });
    };
    $('.table_sort_search_class').each(function (index, table) {
        if($(table).hasClass('table_search_pagination_25')){
            bindPaginatedTable($(table),25, index);
        }else if($(table).hasClass('table_search_pagination_50')){
            bindPaginatedTable($(table), 50, index);
        }else{
            $(table).bind('dynatable:init', function(e, dynatable) {
                dynatable.$element.find('.dynatable-sort-header:eq(0)').click();
            }).dynatable({
                inputs: {
                    queryEvent: 'blur change keyup',
                    multisort: false,
                    searchText: getContentTableSearchLabel($(table))
                },
                features: {
                    paginate: false,
                    sort: true,
                    search: setContentTableSearchHide($(table)),
                    recordCount: false,
                    perPageSelect: false,
                    pushState: false,
                    appendArrowUp:true
                }
            }).bind('dynatable:afterProcess', function(data){
                //$('#table_sort_search td').mark($('#dynatable-query-search-table_sort_search').val());
                $(this).find('td').mark($('#dynatable-query-search-'+$(this).attr('id')).val());

            });
            setContentTableSearchAlign($(table));
            addIconToContentTableSearch($(table));
        }

    });
    ////////////////////////////////////////
    //////End content table pagination//////
    ////////////////////////////////////////

    //parallax effect
     $('.parallax_section').parallax();

    //Detect iOS and apply iOS specific code
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
    	//Apply class to body tag for iOS-specific styles when needed
    	$('body').addClass("ios_device");
    	//Display jotform modal fallback (direct link to jotform) for iOS because iOS hates modals.
    	//the "d-block" class used for buttons has !important on it, which means just showing and hiding does not work
    	$('.jotform_modal_button').removeClass('d-block').hide();
    	$('.jotform_fallback_button').show();
    	//for fixed parallax
    	$('.fixed_parallax_section').addClass('fixed-parallax-ios');
	}

    //RTE styles plugin workaround for lists
    $(".rte ol li, .rte ul li").find("span[class^='text_color']:first", this).each(function () {
    	var currentSpan = $(this);
    	var firstNode = currentSpan.parent().contents()[0];
    	var nodeTypeText = 3;
    	//if the first node is "text" then do not apply the style to the list item i.e.
    	//"<li> Words here <span class="className">more words</span></li>" Will not add "className" to the li tag
    	//"<li><span class="className">more words</span> Words here</li>" *Will* add "className" to the li tag
    	if (firstNode.nodeType !== nodeTypeText){
    		if(currentSpan.hasClass('text_color_flinders_gold')){
            	currentSpan.parent().addClass('text_color_flinders_gold');
            }else if(currentSpan.hasClass('text_color_flinders_navy')) {
            	currentSpan.parent().addClass('text_color_flinders_navy');
            }else if(currentSpan.hasClass('text_color_flinders_white')) {
            	currentSpan.parent().addClass('text_color_flinders_white');
            }else if(currentSpan.hasClass('text_color_flinders_black')) {
            	currentSpan.parent().addClass('text_color_flinders_black');
            }else if(currentSpan.hasClass('text_color_flinders_light_grey')) {
            	currentSpan.parent().addClass('text_color_flinders_light_grey');
            }else if(currentSpan.hasClass('text_color_flinders_medium_grey')) {
            	currentSpan.parent().addClass('text_color_flinders_medium_grey');
            }else if(currentSpan.hasClass('text_color_flinders_dark_grey')) {
            	currentSpan.parent().addClass('text_color_flinders_dark_grey');
            }else if(currentSpan.hasClass('text_color_flinders_midnight_blue')) {
                currentSpan.parent().addClass('text_color_flinders_midnight_blue');
            }else if(currentSpan.hasClass('text_bg_color_flinders_gold')) {
            	currentSpan.parent().addClass('text_bg_color_flinders_gold');
            }else if(currentSpan.hasClass('text_size_large')) {
            	currentSpan.parent().addClass('text_size_large');
            }else {
            	//do nothing
            }
    	}
    });

    //cta buttom alignment
    $('p.component_section_d1').each(function () {
        if($(this).parent().hasClass('cta-button')){
            if($(this).hasClass('cta_text_alignment_left'))
                $(this).parent().css("text-align", 'left');
            else if($(this).hasClass('cta_text_alignment_centre'))
                $(this).parent().css("text-align", 'center');
            else if($(this).hasClass('cta_text_alignment_right'))
                $(this).parent().css("text-align", 'right');
        }
    })

    // Start - Tippy for rte tooltip.
    var tooltips = $('.rteTooltip');
    tooltips.each(function(index, element) {
        tippy(element, {
            allowHTML: true,
            trigger: 'mouseenter click',
            arrow: true,
            interactive: true,
            appendTo: document.body,
        });
    });
    // End - Tippy for rte tooltip.

});

$(".course_list_component .item_heading").on("click" , function(e) {
	e.preventDefault();
	var all_accordion_items = $(this).closest('.accordion_container').children('.accordion_item');
	var current_accordion_item = $(this).closest('.accordion_item');

	if(current_accordion_item.hasClass('open')) {
		all_accordion_items.removeClass('open');
		all_accordion_items.children('.item_content').slideUp(750);
	} else {
		all_accordion_items.removeClass('open');
		all_accordion_items.children('.item_content').slideUp(750);
		current_accordion_item.addClass('open');
		current_accordion_item.children('.item_content').slideDown(750);
	}
});

function getAllQueryStringParams(){
    var Result = {};
    if(document.location.search){
        var searchString = document.location.search.replace(/^\?/,'');
        var params = searchString.split('&');
        for(var index = 0; index< params.length; index++){
            var keyValue = params[index].split('=');
            if(keyValue.length == 2){
                var key = keyValue[0];
                var value = keyValue[1];
                Result[key] = decodeURIComponent(value);
            }
        }
    }
    return Result;
}
/*
UTILITY FUNCTION
    Fade elements in one after another (as opposed to all at once)
requires:
    jQuery fadeIn() - https://api.jquery.com/fadeIn/
accepts:
    duration (int) - the duration each individual element takes to complete their fadeIn() transition
    elements_array (array) - an array of jquery elements. NOTE: not a jQuery set of elements
example:
    fadeInRecursive(150,$.makeArray($(".pickle")));
*/
function fadeInRecursive(duration, elements_array){
    if (elements_array) {
        $(elements_array.shift()).fadeIn(duration,function() {
            fadeInRecursive(duration, elements_array)
        });
    }
}

/*
UTILITY FUNCTION
    Fade elements in one after another (as opposed to all at once) when elements are visually hidden using opacity.
requires:
    jQuery fadeTo() - https://api.jquery.com/fadeto/
accepts:
    duration (int) - the duration each individual element takes to complete their fadeTo() transition
    finalOpacity - the opacity value between 0 and 1 (inclusive) for the fadeTo transition to finish at, this will almost always be 1
    elements_array (array) - an array of jquery elements. NOTE: not a jQuery set of elements
example:
    fadeToRecursive(150, 1, $.makeArray($(".pickle")));
*/
function fadeToRecursive(duration, finalOpacity, elements_array) {
    if (elements_array) {
        $(elements_array.shift()).fadeTo(duration, finalOpacity, function () {
            fadeToRecursive(duration, finalOpacity, elements_array);
        });
    }
}
/*
UTILITY FUNCTION
    Provided a jQuery set of elements and the method for calculating height, returns the height of the tallest element.
requires:
    jQuery height() - https://api.jquery.com/height/
    jQuery innerHeight() - https://api.jquery.com/innerHeight/
    jQuery outerHeight() - https://api.jquery.com/outerHeight/
    jQuery each() - https://api.jquery.com/each/
accepts:
    elements (jQuery set) - jquery elements i.e. the result of a jQuery selector
    calculation_method (string) - the method for calculating height, expected values 'inner' 'outer' 'outer-all' any other value will be default'
returns:
    max_height (int) - the height of the tallest element.
example:
    getMaxHeightOfElements($(".pickle"));
*/
function getMaxHeightOfElements(elements, calculation_method) {
    var max_height = 0;
    switch (calculation_method) {
        case 'inner':
            //.innerHeight() - includes: element height, padding; excludes: border, margin
            $(elements).each(function () {
                if ($(this).innerHeight() > max_height) {
                    max_height = $(this).innerHeight();
                }
            });
            break;
        case 'outer':
            //.outerHeight() - includes: element height, padding, border; excludes: margin
            $(elements).each(function () {
                if ($(this).outerHeight() > max_height) {
                    max_height = $(this).outerHeight();
                }
            });
            break;
        case 'outer-all':
            //.outerHeight(true) - includes: element height, padding, border, margin
            $(elements).each(function () {
                if ($(this).outerHeight(true) > max_height) {
                    max_height = $(this).outerHeight(true);
                }
            });
            break;
        default:
            //.height() - includes: element height; excludes: padding, border, margin
            $(elements).each(function () {
                if ($(this).height() > max_height) {
                    max_height = $(this).height();
                }
            });
    }

    return max_height;
}

/*
UTILITY FUNCTION
    Provided an array of element ID's and their immediate parent container, attempts to re-order the matching elements based on the order of the array.
        - if any elements in the parent container do not match the elements in the array, they will keep their order but be listed after all array elements.
        - if parent_container matches multiple, elements will be cloned instead of moved, not what we want in this case but someone might want that!
requires:
    jQuery prepend() - https://api.jquery.com/prepend/
accepts:
    array_of_ids (array) - an array of DOM element ID's
    parent_container (jQuery) - a jQuery element that ideally contains the elements to be ordered
example:
    sortDomElementsById(["pickle_1","pickle_2"], $("#pickle"));
*/
function sortDomElementsById(array_of_ids, parent_container) {
    // Note(JD) - Using pop() here because we are prepending to the parent.
    // If we just looped through the array and prepended, the last item in the array would appear first.
    // If we appended instead, then elements not in the array will appear first (which we don't want in this case)
    while (array_of_ids.length) {
    	var element = parent_container.find("#" + array_of_ids.pop());
    	parent_container.prepend(element);
    }
}

$(function () {
    var twitterSlider = $('.twitter-feed .testimonials-slider');
    var slider = $('.testimonials-slider').not(twitterSlider);
    var standAlone = $('.testimonial');

    var breakpoints = {};

    breakpoints.sm = 768;
    breakpoints.md = 992;
    breakpoints.lg = 1200;

    var sizeOfSlide = 370; // Size of a slide.


// For testimonial slider
    var maxTestimonialSlideToShow = Math.round(slider.width() / sizeOfSlide);

    var maxItemsToSlide = 1;

// Setting up how many to slider for testimonial.
    if (maxTestimonialSlideToShow <=0) {
        maxTestimonialSlideToShow =1;
    }

    if (maxTestimonialSlideToShow >1) {
        maxItemsToSlide = 2;
    }

    var sliderExpanders = (function () {
        var slideSelector = '.testimonials-slider__slide',
            slideTextSelector = '.testimonials-slider-slide__text',
            sliderTextExpanderSelector = '.testimonials-quote__expander';

        var hiddenClass = 'hidden';

        var $slides;

        function init($sel) {
            $slides = $sel.find(slideSelector);

            addFunctionality();
        }

        function addFunctionality() {

            $slides.each(function () {
                var $this = $(this);
                var $slideTextSelector = $this.find(slideTextSelector);
                var slideText = $this.find(slideTextSelector)[0];
                var slideTextExpander = $this.find(sliderTextExpanderSelector);
                var sliderTextMinHeight = $this.find(slideTextSelector).css('height').slice(0, -2);

                if (slideText.scrollHeight <= sliderTextMinHeight) {
                    slideTextExpander.addClass(hiddenClass);
                } else {
                    _cropText($slideTextSelector);
                    _bindClick(slideTextExpander);
                }

            });

            function _cropText($selector) {
                $selector.data('text', $selector.html());

                $selector.ellipsis({
                    lines: 10
                });

                // debug:
                // console.log('_cropText');
            }

            function _bindClick(btn) {
                btn.click(function (e) {
                    var $this = $(this);
                    var relSliderText = $this.closest(slideSelector).find(slideTextSelector)

                    e.preventDefault();

                    // debug:
                    // console.log('data-text', relSliderText.data('text'));

                    _removeElipsis(relSliderText);

                    $this.closest(slideSelector).find(slideTextSelector).css({'height': 'auto', 'max-height': 'none'});

                    $this.addClass(hiddenClass);
                });

            }

        }

        function _removeElipsis(elm) {
            elm.html(elm.data('text'));
        }

        function resetFunctionality() {
            $slides.each(function () {
                var $this = $(this);

                var slideText = $this.find(slideTextSelector);
                var slideTextExpander = $this.find(sliderTextExpanderSelector);

                slideText.removeAttr('style');
                _removeElipsis(slideText);

                if (slideTextExpander.hasClass(hiddenClass)) {
                    slideTextExpander.removeClass(hiddenClass);
                }
            });
        }

        return {
            init: init,
            addFunctionality: addFunctionality,
            resetFunctionality: resetFunctionality
        };
    }());

    if ($(window).width() < breakpoints.sm) {
        window.addEventListener('orientationchange', function () {
            sliderExpanders.resetFunctionality();
            setTimeout(function () {
                sliderExpanders.addFunctionality();
            }, 500);
        });
    }

    standAlone.each(function () {
        var $this = $(this);

        sliderExpanders.init($this);

        $this.on('breakpoint', function () {
            sliderExpanders.resetFunctionality();
            sliderExpanders.addFunctionality();
        });
    });

    slider.each(function () {
        var $this = $(this);

        $this.on('init', function () {
            sliderExpanders.init($this);
        });

        $this.slick({
            accessibility: true,
            dots: true,
            infinite: false,
            slidesToShow: maxTestimonialSlideToShow,
            slidesToScroll: maxItemsToSlide,
            adaptiveHeight: true,
            prevArrow: $this.prev('.testimonials-wrapper').children('.testimonials-arrows').children('.testimonials-arrows__angle_left'),
            nextArrow: $this.prev('.testimonials-wrapper').children('.testimonials-arrows').children('.testimonials-arrows__angle_right'),
            responsive: [
                {
                    breakpoint: breakpoints.lg,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: breakpoints.md,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: breakpoints.sm,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        });
    });


    function buildSlider(twitterSliderCurrent, fullWidth, slidesToshow, maxItemsToSlide) {

            twitterSliderCurrent.slick({
              accessibility: true,
              dots: true,
              infinite: false,
              slidesToShow: slidesToshow,
              slidesToScroll: maxItemsToSlide,
              adaptiveHeight: true,
              prevArrow: twitterSliderCurrent.prev('.testimonials-wrapper').children('.testimonials-arrows').children('.testimonials-arrows__angle_left'),
              nextArrow: twitterSliderCurrent.prev('.testimonials-wrapper').children('.testimonials-arrows').children('.testimonials-arrows__angle_right'),
              responsive: [
                  {
                      breakpoint: breakpoints.lg,
                      settings: {
                          slidesToShow: 3,
                          slidesToScroll: 3
                      }
                  },
                  {
                      breakpoint: breakpoints.md,
                      settings: {
                          slidesToShow: 2,
                          slidesToScroll: 2
                      }
                  },
                  {
                    breakpoint: breakpoints.sm,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
              ]
          });
    }
    function getStringWithMarkup(string) {
        //replacing links and mentions with "a" tag
        return string
            .replace(/(https?:\/\/([-\w\.]+)+(:\d+)?(\/([\w\/_\.]*(\?\S+)?)?)?)/ig, function (match) {
                return '<a class="testimonials-slider-slide__link" target="_blank" href="' + match + '">' + match + '</a>';
            })
            .replace(/\B\@([\w\-]+)/gim, function(match, name){
                return '<a class="testimonials-slider-slide__link" target="_blank" href="http://twitter.com/' + name + '">' + match + '</a>';
            });
    }

    function buildTwitterFeed(feed, limit, fullWidth, twitterSliderCurrent, slidesToshow, maxItemsToSlide) {
        var feedName = feed || 'flinders';
        var config = {
            limit: limit || '3'
        };

        var postTemplate = $('#twitter-post').text();
        var compiledPostTemplate = doT.template(postTemplate);


        $.ajax({
            method: "GET",
            dataType: "json",
            url: '/bin/mvc.do/flinders/twitter/' + feedName,
            headers: {},
            data: config
        }).done(function (data) {

            if (data.error == 404) {
                twitterSliderCurrent.closest('.testimonials').find('.testimonials-wrapper').append('<p class="alert alert-warning">you should reload  page after 15 minutes </p>');
                twitterSliderCurrent.closest('.testimonials').find('.testimonials-arrows').hide();

            } else {
                var tweets = data.tweets;
                var dataToProvide;
                for (var i = 0; i < tweets.length; i++) {
                    dataToProvide = {
                        text: getStringWithMarkup(tweets[i].text),
                        feedName: feedName,
                        name: tweets[i].user.name,
                        userPhoto: tweets[i].user.profile_image_url_https,
                        posted: moment(tweets[i].created_at, "ddd MMM DD HH:mm:ss ZZ YYYY").fromNow()
                    };
                    if (tweets[i].entities.media){
                        dataToProvide.postLink = tweets[i].entities.media[0].url;
                        dataToProvide.postImage = tweets[i].entities.media[0].media_url_https;
                    }

                    twitterSliderCurrent.append(compiledPostTemplate(dataToProvide));

                }
                buildSlider(twitterSliderCurrent, fullWidth, slidesToshow, maxItemsToSlide);
            }
        });
    }

    var feed, limit, maxTwitterSlidesToShow, itemsToSlide;
 
    if (twitterSlider.length) {
        maxTwitterSlidesToShow = Math.round(twitterSlider.width() / sizeOfSlide);

        if (maxTwitterSlidesToShow <= 0) {
            maxTwitterSlidesToShow = 1;
        }

        if (maxTwitterSlidesToShow > 2) {
            itemsToSlide = 2;
        }
        $.each(twitterSlider, function() {
            feed = $(this).parents('.twitter-feed').attr('data-feed');
            limit = $(this).parents('.twitter-feed').attr('data-limit');
            buildTwitterFeed(feed, limit, false, $(this), maxTwitterSlidesToShow, itemsToSlide);
        });
    }


});

//JS for the pathways-finder and pathways-finder-results pages
var PATHWAYS_SORT_ORDER_COURSE_NAME_ASC = "AZ";
var PATHWAYS_SORT_ORDER_COURSE_NAME_DESC = "ZA";
var PATHWAYS_SORT_ORDER_ATAR_ASC = "ATAR_asc";
var PATHWAYS_SORT_ORDER_ATAR_DESC = "ATAR_desc";

var selected_pathways_finder_value = "";
var pathways_finder_present = false;
var pathways_finder_results_present = false;
var pathways_results_page_size = 18;
var pathways_results_total_pages = 1;

var search_filters = {studyArea: "all", atarMin: 0, atarMax: -1};
var sorting_method = "suggested";

var pathways_courses_data = [];

//Handlebars Helpers
Handlebars.registerHelper('times', function(n, block) {
    //This helper is a basic for loop
    //Example use:
    //  {{#times numberOfPages}}
    // 		{{#if @first}}
    // 			<a class="paginator_page paginator_page--selected" href="#">{{@index}}</a>
    // 		{{else}}
    // 			<a class="paginator_page" href="#">{{@index}}</a>
    // 		{{/if}}
    // 	{{/times}}
    var accum = '';
    for(var i = 0; i < n; ++i) {
        block.data.index = i;
        block.data.indexOffset = i + 1; //in case we don't want to use a 0-indexed thingo
        block.data.first = i === 0;
        block.data.last = i === (n - 1);
        accum += block.fn(this);
    }
    return accum;
});

Handlebars.registerHelper('testAtar', function(atarValue) {
    if($.isNumeric(atarValue)) {
        return "<div>"+atarValue+"</div>";
    } else {
        return "<div class=\"pathways-finder-results__atar--small\">"+atarValue+"</div>";
    }
});

$(document).ready(function () {
    checkForPathwaysComponents();

    if(pathways_finder_present) {
        $(".pathways-finder-search-button").on("click", function (e) {
            e.preventDefault();
            var button_clicked = $(this);
            var button_href = button_clicked.prop("href");

            if(button_clicked.hasClass("target_other")) {
                var separator = button_href.indexOf('?') !== -1 ? "&" : "?";
                window.location = button_href+separator+"q="+selected_pathways_finder_value;
            } else {
                if(pathways_finder_results_present) {
                    updateResults();
                }
            }
        });
        $(".pathways-finder__select").change(function() {
            setStudyAreaFromDropdown($(this))
            if(pathways_finder_results_present) {
                updateResults();
            }
        });
        autoSelectDropdownFromQueryString();
    }
    if(pathways_finder_results_present) {
        updateResults();
        var order_selector_dropdown = $(".pathways-finder-results__view-selector .view_dropdown");
        order_selector_dropdown.change(function() {
            var selected_option = $(this).find("option:selected");
            sorting_method = selected_option.val();
            updateResults();
        });

        //ATAR filters
        $(".pathways-finder-results__atar-filter-item_sub").on("click", function (e) {
            e.preventDefault();
            var selected_class = "pathways-finder-results__atar-filter-item_sub--selected";
            var all_atar_buttons = $(".pathways-finder-results__atar-filter-item_sub");
            var button_clicked = $(this);

            if(button_clicked.hasClass(selected_class)) {
                button_clicked.removeClass(selected_class);
            } else {
                all_atar_buttons.removeClass(selected_class);
                button_clicked.addClass(selected_class);
            }
            updateSearchFilters();
            updateResults();
        });
    }

});

function setStudyAreaFromDropdown(dropdown_element) {
    selected_pathways_finder_value = dropdown_element.find("option:selected").val();
    search_filters.studyArea = selected_pathways_finder_value;
}

function checkForPathwaysComponents() {
    if($(".pathways-finder").length > 0) {
        pathways_finder_present = true;
    }
    if($(".pathways-finder-results").length > 0) {
        pathways_finder_results_present = true;
    }
}
//Borrowed from Sajari because it works
var get_hash_value = function(e){var t = new RegExp("[?&]" + e.replace(/[\[\]]/g, "\\$&") + "(=([^&#]*)|&|#|$)"),a = t.exec(window.location.href);return a && a[2] ? decodeURIComponent(a[2].replace(/\+/g, " ")) : ""};

function autoSelectDropdownFromQueryString() {
    var q = get_hash_value("q");
    var pathways_finder_select = $(".pathways-finder__select").first();
    var valid_study_area = false;
    if(q && q.length > 0) {

        pathways_finder_select.find("option").each(function(){
            if($(this).val() === q) {
                valid_study_area = true;
                return false; //this is how you break out of each() in jquery apparently, returning true is a continue
            }
        });
        if(valid_study_area) {
            pathways_finder_select.val(q).prop('selected', true);
        }
    }
    if(pathways_finder_results_present) {
        setStudyAreaFromDropdown(pathways_finder_select);
    }

}

function updateSearchFilters() {
    //look for atars
    var selected_atar_filter = $(".pathways-finder-results__atar-filter-item_sub--selected");
    if(selected_atar_filter.length > 0) {
        search_filters.atarMin = selected_atar_filter.data("minvalue");
        search_filters.atarMax = selected_atar_filter.data("maxvalue");
    } else {
        search_filters.atarMin = 0;
        search_filters.atarMax = -1;

    }
}

function updateResults() {
    if(pathways_courses_data.length > 0) {
        populateList(sortAndFilterCoursesData(pathways_courses_data));
    } else {
        getCoursesJson();
    }
}

function getCoursesJson() {
    //TODO (JD) probably need some good error handling here...
    $.ajax({
        method: "GET",
        url: '/flinders-services/courses.json/tagFilters.flinders:course/study_type/undergraduate.tagFilters.flinders:course/availability/domestic.json',
    }).done(function (data){
        pathways_courses_data = data;
        populateList(sortAndFilterCoursesData(data));

    });
}
function populateList(data) {
    //Note: Instead of doing something fancy here, we are simply blowing away all items and adding them again in the order we want.
    var results_container = $("#results_container");
    results_container.empty();
    var list_template = $("#pathways_finder_result_item_template").html();

    var template = Handlebars.compile(list_template);
    var html = template({
        courses: data
    });
    results_container.append(html);

    //Add title attributes to the links that dont have them!
    var all_pathways_options = results_container.find('.pathways_option');
    all_pathways_options.prop("title", function() {
        return $(this).text();
    });
    //set ellipsis items
    all_pathways_options.ellipsis({
        lines: 1,
        ellipClass: 'pathways-finder-results__ellipsis',
        responsive: true
    });

    initPaginator(data.length);
    initSortableHeadings();
}

function sortAndFilterCoursesData(courses) {
    courses = courses.filter(function(course) {
        var study_area_filter_bool = false;
        var atar_min_filter_bool = true;
        var atar_max_filter_bool = true;
        var atar_score_to_compare = parseFloat(course.atarCutoff);
        var current_course_tags = course.tags;
        //Go through each filter in the object
        for (var key in search_filters) {
            if(key === "studyArea") {
                var study_area = search_filters[key];
                if(study_area !== "all") {
                    var study_area_tag_prefix = "flinders:course/study_area/";
                    if(jQuery.inArray((study_area_tag_prefix+study_area), current_course_tags) !== -1) {
                        study_area_filter_bool = true;
                    }
                } else {
                    //else all
                    study_area_filter_bool = true;
                }
            }
            if(key === "atarMin") {
                var current_atar_min_value = parseFloat(search_filters[key]);
                if(current_atar_min_value > 0) {
                    atar_min_filter_bool = atar_score_to_compare >= current_atar_min_value;
                }

            }
            if(key === "atarMax") {
                var current_atar_max_value = search_filters[key];
                if(current_atar_max_value > 0) {
                    atar_max_filter_bool = atar_score_to_compare <= current_atar_max_value;
                }
            }
        }
        return study_area_filter_bool && atar_min_filter_bool && atar_max_filter_bool;
    });
    courses = courses.sort(getSortCompareFunction(sorting_method));
    return courses;
}

function initSortableHeadings() {
    var ORDER_TYPE_COURSE_NAME = "NAME";
    var ORDER_TYPE_ATAR = "ATAR";
    var order_selector_dropdown = $(".pathways-finder-results__view-selector .view_dropdown");

    var selected_chevron_class = "pathways-finder-results__order-direction-chevron--selected";
    var all_heading_chevrons = $(".pathways-finder-results__order-direction-chevron");

    $(document).off('click.pathways_heading_sort');
    $(document).off('click.pathways_chevron_sort');

    $(".pathways-finder-results__item-heading--orderable").on("click.pathways_heading_sort", function (e) {
        e.preventDefault();
        var item_heading_clicked = $(this);
        var item_heading_order_type = item_heading_clicked.data("order-type");
        if(item_heading_order_type === ORDER_TYPE_COURSE_NAME) {
            if(sorting_method === PATHWAYS_SORT_ORDER_COURSE_NAME_ASC) {
                order_selector_dropdown.val(PATHWAYS_SORT_ORDER_COURSE_NAME_DESC).trigger('change');
            } else {
                //Default to AZ if sorting method is anything but Course name -> AZ
                order_selector_dropdown.val(PATHWAYS_SORT_ORDER_COURSE_NAME_ASC).trigger('change');
            }
        } else if(item_heading_order_type === ORDER_TYPE_ATAR) {
            if(sorting_method === PATHWAYS_SORT_ORDER_ATAR_ASC) {
                order_selector_dropdown.val(PATHWAYS_SORT_ORDER_ATAR_DESC).trigger('change');
            } else {
                //Default to ATAR_asc if sorting method is anything but ATAR -> ATAR_asc
                order_selector_dropdown.val(PATHWAYS_SORT_ORDER_ATAR_ASC).trigger('change');
            }
        } else {
            //This state shouldn't happen, but suggested is a good fallback :)
            order_selector_dropdown.val("suggested").trigger('change');
        }
    });
    all_heading_chevrons.on("click.pathways_chevron_sort", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var chevron_clicked = $(this);
        var chevron_clicked_direction = chevron_clicked.data("direction");
        if(!chevron_clicked.hasClass(selected_chevron_class)) {
            order_selector_dropdown.val(chevron_clicked_direction).trigger('change');
        }
    });

    all_heading_chevrons.removeClass(selected_chevron_class);
    if(sorting_method !== "suggested") {
        all_heading_chevrons.filter('[data-direction="'+sorting_method+'"]').addClass(selected_chevron_class);
    }
}
function initPaginator(total_courses) {
    $(".pathways-finder-results__count").show();
    $(".results_count").text(total_courses);

    var pathways_paginator = $(".pathways-finder-results__paginator");
    pathways_results_page_size = parseInt(pathways_paginator.data("pagesize"));
    var current_page = pathways_paginator.data("currentpage");
    pathways_results_total_pages = Math.ceil(total_courses / pathways_results_page_size);

    pathways_paginator.data("totalpages",pathways_results_total_pages);
    $(document).off('click.paginator_prev');
    $(document).off('click.paginator_page');
    $(document).off('click.paginator_next');
    pathways_paginator.empty();

    var paginator_template = $("#pathways_finder_result_paginator_item").html();
    var template = Handlebars.compile(paginator_template);
    var html = template({
        numberOfPages: pathways_results_total_pages
    });
    pathways_paginator.append(html);

    updateResultsPages("init", 1);

    $(".paginator_prev").on("click.paginator_prev", function (e) {
        e.preventDefault();
        var paginator_button = $(this);
        if(!paginator_button.hasClass("paginator_prev--disabled")) {
            updateResultsPages("prev", 0);
        }
    });
    $(".paginator_page").on("click.paginator_page", function (e) {
        e.preventDefault();
        var paginator_button = $(this);
        var page_number = paginator_button.data("pagenumber");
        if(!paginator_button.hasClass("paginator_page--selected")) {
            updateResultsPages("jump", page_number);
        }
    });
    $(".paginator_next").on("click.paginator_next", function (e) {
        e.preventDefault();
        var paginator_button = $(this);
        if(!paginator_button.hasClass("paginator_next--disabled")) {
            updateResultsPages("next", 0);
        }
    });
}

//action = "prev" "next" or "jump"
function updateResultsPages(action, pageNumber) {
    var display_class = "pathways-finder-results__item--shown";
    var already_selected_page = $(".paginator_page.paginator_page--selected");
    var current_page_number = already_selected_page.data("pagenumber");

    var pathways_paginator = $(".pathways-finder-results__paginator");
    var current_page = pathways_paginator.data("currentpage");

    if(action === "prev") {
        var prev_page_to_select = $(".paginator_page[data-pagenumber='"+(current_page_number - 1)+"']");
        already_selected_page.removeClass("paginator_page--selected");
        prev_page_to_select.addClass("paginator_page--selected");
        updatePaginatorPrevNextButtons(prev_page_to_select.data("pagenumber"));

    } else if(action === "next") {
        var next_page_to_select = $(".paginator_page[data-pagenumber='"+(parseInt(current_page_number) + 1)+"']");
        already_selected_page.removeClass("paginator_page--selected");
        next_page_to_select.addClass("paginator_page--selected");
        updatePaginatorPrevNextButtons(next_page_to_select.data("pagenumber"));
    } else if(action === "jump") {
        var new_page_to_select = $(".paginator_page[data-pagenumber='"+pageNumber+"']");
        already_selected_page.removeClass("paginator_page--selected");
        new_page_to_select.addClass("paginator_page--selected");
        updatePaginatorPrevNextButtons(new_page_to_select.data("pagenumber"));
    } else {
        updatePaginatorPrevNextButtons(1);
    }
    var all_results_after_filters = $(".pathways-finder-results__item");
    all_results_after_filters.removeClass(display_class);
    var new_page_selected =  $(".paginator_page.paginator_page--selected").data("pagenumber");
    var results_to_display = all_results_after_filters.slice((new_page_selected-1)*pathways_results_page_size , new_page_selected*pathways_results_page_size);
    results_to_display.addClass(display_class);
    setupSelectionRankTooltips();
}
function updatePaginatorPrevNextButtons(pageNumber) {
    var prev_button = $(".paginator_prev");
    var next_button = $(".paginator_next");
    if(pageNumber === 1) {
        prev_button.addClass("paginator_prev--disabled");
    } else {
        prev_button.removeClass("paginator_prev--disabled");
    }
    if(pageNumber === pathways_results_total_pages) {
        next_button.addClass("paginator_next--disabled");
    } else {
        next_button.removeClass("paginator_next--disabled");
    }
}

function getSortCompareFunction(sort_method) {
    switch (sort_method) {
        case PATHWAYS_SORT_ORDER_COURSE_NAME_ASC:
            return function(a, b) {
                var nameA = a.name.toUpperCase();
                var nameB = b.name.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            };
        case PATHWAYS_SORT_ORDER_COURSE_NAME_DESC:
            return function(a, b) {
                var nameA = a.name.toUpperCase();
                var nameB = b.name.toUpperCase();
                if (nameB < nameA) {
                    return -1;
                }
                if (nameB > nameA) {
                    return 1;
                }
                return 0;
            };
        case PATHWAYS_SORT_ORDER_ATAR_DESC:
            return function(a, b) {
                var atar_a = a.hasOwnProperty("atarCutoff") ? a.atarCutoff : 0;
                if(!$.isNumeric(atar_a)) {
                    atar_a = 0;
                }
                var atar_b = b.hasOwnProperty("atarCutoff") ? b.atarCutoff : 0;
                if(!$.isNumeric(atar_b)) {
                    atar_b = 0;
                }

                return atar_b - atar_a;
            };
        case PATHWAYS_SORT_ORDER_ATAR_ASC:
            return function(a, b) {
                var atar_a = a.hasOwnProperty("atarCutoff") ? a.atarCutoff : 0;
                if(!$.isNumeric(atar_a)) {
                    atar_a = 0;
                }
                var atar_b = b.hasOwnProperty("atarCutoff") ? b.atarCutoff : 0;
                if(!$.isNumeric(atar_b)) {
                    atar_b = 0;
                }
                return atar_a - atar_b;
            };
        default:
            return function(a, b) {
                var nameA = a.name.toUpperCase();
                var nameB = b.name.toUpperCase();
                var a_promoted = a.hasOwnProperty("promoted") ? a.promoted : false;
                var b_promoted = b.hasOwnProperty("promoted") ? b.promoted : false;
                var a_priority = parseInt(a.priority);
                var b_priority = parseInt(b.priority);
                //If a or b priority are not numbers, treat them as 0
                if(isNaN(a_priority)) {
                    a_priority = 0;
                }
                if(isNaN(b_priority)) {
                    b_priority = 0;
                }

                //Order by: promoted (bool) = true , priority (float) high > low , name (String) A > Z
                //If both are promoted, or both are not promoted, do this
                if (a_promoted === b_promoted) {
                    if(b_priority !== a_priority) {
                        //If there is a difference in priority, return the difference.
                        return b_priority - a_priority;
                    } else {
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        return 0;
                    }
                } else {
                    //If one is promoted and the other is not
                    return a_promoted ? -1 : 1;
                }
            };
    }
}

function setupSelectionRankTooltips() {
    var all_selection_rank_tooltips = $(".atar_tooltip_icon");
    var tooltip_template = '<div class="tooltip ff_tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>';

    all_selection_rank_tooltips.on("click focus", function (e) {
        e.preventDefault();
        return false;
    });
    //Apply tooltip settings
    all_selection_rank_tooltips.tooltip({animation: true, container: '.fast_facts_tooltip_icon',placement:'top',trigger:"click hover focus", template: tooltip_template});
}

/*
 * jQuery Dynatable plugin 0.3.1
 *
 * Copyright (c) 2014 Steve Schwartz (JangoSteve)
 *
 * Dual licensed under the AGPL and Proprietary licenses:
 *   http://www.dynatable.com/license/
 *
 * Date: Tue Jan 02 2014
 */
//

(function($) {
    var defaults,
        mergeSettings,
        dt,
        Model,
        modelPrototypes = {
            dom: Dom,
            domColumns: DomColumns,
            records: Records,
            recordsCount: RecordsCount,
            processingIndicator: ProcessingIndicator,
            state: State,
            sorts: Sorts,
            sortsHeaders: SortsHeaders,
            queries: Queries,
            inputsSearch: InputsSearch,
            paginationPage: PaginationPage,
            paginationPerPage: PaginationPerPage,
            paginationLinks: PaginationLinks
        },
        utility,
        build,
        processAll,
        initModel,
        defaultRowWriter,
        defaultCellWriter,
        defaultAttributeWriter,
        defaultAttributeReader;

    //-----------------------------------------------------------------
    // Cached plugin global defaults
    //-----------------------------------------------------------------

    defaults = {
        features: {
            paginate: true,
            sort: true,
            pushState: true,
            search: true,
            recordCount: true,
            perPageSelect: true
        },
        table: {
            defaultColumnIdStyle: 'camelCase',
            columns: null,
            headRowSelector: 'thead tr', // or e.g. tr:first-child
            bodyRowSelector: 'tbody tr',
            headRowClass: null,
            copyHeaderAlignment: true,
            copyHeaderClass: false
        },
        inputs: {
            queries: null,
            sorts: null,
            multisort: ['ctrlKey', 'shiftKey', 'metaKey'],
            page: null,
            queryEvent: 'blur change',
            recordCountTarget: null,
            recordCountPlacement: 'after',
            paginationLinkTarget: null,
            paginationLinkPlacement: 'after',
            paginationClass: 'dynatable-pagination-links',
            paginationLinkClass: 'dynatable-page-link',
            paginationPrevClass: 'dynatable-page-prev',
            paginationNextClass: 'dynatable-page-next',
            paginationActiveClass: 'dynatable-active-page',
            paginationDisabledClass: 'dynatable-disabled-page',
            paginationPrev: 'Previous',
            paginationNext: 'Next',
            paginationGap: [1,2,2,1],
            searchTarget: null,
            searchPlacement: 'before',
            searchText: 'Search: ',
            perPageTarget: null,
            perPagePlacement: 'before',
            perPageText: 'Show: ',
            pageText: 'Pages: ',
            recordCountPageBoundTemplate: '{pageLowerBound} to {pageUpperBound} of',
            recordCountPageUnboundedTemplate: '{recordsShown} of',
            recordCountTotalTemplate: '{recordsQueryCount} {collectionName}',
            recordCountFilteredTemplate: ' (filtered from {recordsTotal} total records)',
            recordCountText: 'Showing',
            recordCountTextTemplate: '{text} {pageTemplate} {totalTemplate} {filteredTemplate}',
            recordCountTemplate: '<span id="dynatable-record-count-{elementId}" class="dynatable-record-count">{textTemplate}</span>',
            processingText: 'Processing...'
        },
        dataset: {
            ajax: false,
            ajaxUrl: null,
            ajaxCache: null,
            ajaxOnLoad: false,
            ajaxMethod: 'GET',
            ajaxDataType: 'json',
            totalRecordCount: null,
            queries: {},
            queryRecordCount: null,
            page: null,
            perPageDefault: 10,
            perPageOptions: [10,20,50,100],
            sorts: {},
            sortsKeys: [],
            sortTypes: {},
            records: null
        },
        writers: {
            _rowWriter: defaultRowWriter,
            _cellWriter: defaultCellWriter,
            _attributeWriter: defaultAttributeWriter
        },
        readers: {
            _rowReader: null,
            _attributeReader: defaultAttributeReader
        },
        params: {
            dynatable: 'dynatable',
            queries: 'queries',
            sorts: 'sorts',
            page: 'page',
            perPage: 'perPage',
            offset: 'offset',
            records: 'records',
            record: null,
            queryRecordCount: 'queryRecordCount',
            totalRecordCount: 'totalRecordCount'
        }
    };

    //-----------------------------------------------------------------
    // Each dynatable instance inherits from this,
    // set properties specific to instance
    //-----------------------------------------------------------------

    dt = {
        init: function(element, options) {
            this.settings = mergeSettings(options);
            this.element = element;
            this.$element = $(element);

            // All the setup that doesn't require element or options
            build.call(this);

            return this;
        },

        process: function(skipPushState) {
            processAll.call(this, skipPushState);
        }
    };

    //-----------------------------------------------------------------
    // Cached plugin global functions
    //-----------------------------------------------------------------

    mergeSettings = function(options) {
        var newOptions = $.extend(true, {}, defaults, options);

        // TODO: figure out a better way to do this.
        // Doing `extend(true)` causes any elements that are arrays
        // to merge the default and options arrays instead of overriding the defaults.
        if (options) {
            if (options.inputs) {
                if (options.inputs.multisort) {
                    newOptions.inputs.multisort = options.inputs.multisort;
                }
                if (options.inputs.paginationGap) {
                    newOptions.inputs.paginationGap = options.inputs.paginationGap;
                }
            }
            if (options.dataset && options.dataset.perPageOptions) {
                newOptions.dataset.perPageOptions = options.dataset.perPageOptions;
            }
        }

        return newOptions;
    };

    build = function() {
        this.$element.trigger('dynatable:preinit', this);

        for (model in modelPrototypes) {
            if (modelPrototypes.hasOwnProperty(model)) {
                var modelInstance = this[model] = new modelPrototypes[model](this, this.settings);
                if (modelInstance.initOnLoad()) {
                    modelInstance.init();
                }
            }
        }

        this.$element.trigger('dynatable:init', this);

        if (!this.settings.dataset.ajax || (this.settings.dataset.ajax && this.settings.dataset.ajaxOnLoad) || this.settings.features.paginate || (this.settings.features.sort && !$.isEmptyObject(this.settings.dataset.sorts))) {
            this.process();
        }
    };

    processAll = function(skipPushState) {
        var data = {};

        this.$element.trigger('dynatable:beforeProcess', data);

        if (!$.isEmptyObject(this.settings.dataset.queries)) { data[this.settings.params.queries] = this.settings.dataset.queries; }
        // TODO: Wrap this in a try/rescue block to hide the processing indicator and indicate something went wrong if error
        this.processingIndicator.show();

        if (this.settings.features.sort && !$.isEmptyObject(this.settings.dataset.sorts)) { data[this.settings.params.sorts] = this.settings.dataset.sorts; }
        if (this.settings.features.paginate && this.settings.dataset.page) {
            var page = this.settings.dataset.page,
                perPage = this.settings.dataset.perPage;
            data[this.settings.params.page] = page;
            data[this.settings.params.perPage] = perPage;
            data[this.settings.params.offset] = (page - 1) * perPage;
        }
        if (this.settings.dataset.ajaxData) { $.extend(data, this.settings.dataset.ajaxData); }

        // If ajax, sends query to ajaxUrl with queries and sorts serialized and appended in ajax data
        // otherwise, executes queries and sorts on in-page data
        if (this.settings.dataset.ajax) {
            var _this = this;
            var options = {
                type: _this.settings.dataset.ajaxMethod,
                dataType: _this.settings.dataset.ajaxDataType,
                data: data,
                error: function(xhr, error) {
                    _this.$element.trigger('dynatable:ajax:error', {xhr: xhr, error : error});
                },
                success: function(response) {
                    _this.$element.trigger('dynatable:ajax:success', response);
                    // Merge ajax results and meta-data into dynatables cached data
                    _this.records.updateFromJson(response);
                    // update table with new records
                    _this.dom.update();

                    if (!skipPushState && _this.state.initOnLoad()) {
                        _this.state.push(data);
                    }
                },
                complete: function() {
                    _this.processingIndicator.hide();
                }
            };
            // Do not pass url to `ajax` options if blank
            if (this.settings.dataset.ajaxUrl) {
                options.url = this.settings.dataset.ajaxUrl;

                // If ajaxUrl is blank, then we're using the current page URL,
                // we need to strip out any query, sort, or page data controlled by dynatable
                // that may have been in URL when page loaded, so that it doesn't conflict with
                // what's passed in with the data ajax parameter
            } else {
                options.url = utility.refreshQueryString(window.location.href, {}, this.settings);
            }
            if (this.settings.dataset.ajaxCache !== null) { options.cache = this.settings.dataset.ajaxCache; }

            $.ajax(options);
        } else {
            this.records.resetOriginal();
            this.queries.run();
            if (this.settings.features.sort) {
                this.records.sort();
            }
            if (this.settings.features.paginate) {
                this.records.paginate();
            }
            this.dom.update();
            this.processingIndicator.hide();

            if (!skipPushState && this.state.initOnLoad()) {
                this.state.push(data);
            }
        }

        this.$element.addClass('dynatable-loaded');
        this.$element.trigger('dynatable:afterProcess', data);
    };

    function defaultRowWriter(rowIndex, record, columns, cellWriter) {
        var tr = '';

        // grab the record's attribute for each column
        for (var i = 0, len = columns.length; i < len; i++) {
            tr += cellWriter(columns[i], record);
        }

        return '<tr>' + tr + '</tr>';
    };

    function defaultCellWriter(column, record) {
        var html = column.attributeWriter(record),
            td = '<td';

        if (column.hidden || column.textAlign) {
            td += ' style="';

            // keep cells for hidden column headers hidden
            if (column.hidden) {
                td += 'display: none;';
            }

            // keep cells aligned as their column headers are aligned
            if (column.textAlign) {
                td += 'text-align: ' + column.textAlign + ';';
            }

            td += '"';
        }

        if (column.cssClass) {
            td += ' class="' + column.cssClass + '"';
        }

        return td + '>' + html + '</td>';
    };

    function defaultAttributeWriter(record) {
        // `this` is the column object in settings.columns
        // TODO: automatically convert common types, such as arrays and objects, to string
        return record[this.id];
    };

    function defaultAttributeReader(cell, record) {
        return $(cell).html();
    };

    //-----------------------------------------------------------------
    // Dynatable object model prototype
    // (all object models get these default functions)
    //-----------------------------------------------------------------

    Model = {
        initOnLoad: function() {
            return true;
        },

        init: function() {}
    };

    for (model in modelPrototypes) {
        if (modelPrototypes.hasOwnProperty(model)) {
            var modelPrototype = modelPrototypes[model];
            modelPrototype.prototype = Model;
        }
    }

    //-----------------------------------------------------------------
    // Dynatable object models
    //-----------------------------------------------------------------

    function Dom(obj, settings) {
        var _this = this;

        // update table contents with new records array
        // from query (whether ajax or not)
        this.update = function() {
            var rows = '',
                columns = settings.table.columns,
                rowWriter = settings.writers._rowWriter,
                cellWriter = settings.writers._cellWriter;

            obj.$element.trigger('dynatable:beforeUpdate', rows);

            // loop through records
            for (var i = 0, len = settings.dataset.records.length; i < len; i++) {
                var record = settings.dataset.records[i],
                    tr = rowWriter(i, record, columns, cellWriter);
                rows += tr;
            }

            // Appended dynatable interactive elements
            if (settings.features.recordCount) {
                $('#dynatable-record-count-' + obj.element.id).replaceWith(obj.recordsCount.create());
            }
            if (settings.features.paginate) {
                $('#dynatable-pagination-links-' + obj.element.id).replaceWith(obj.paginationLinks.create());
                if (settings.features.perPageSelect) {
                    $('#dynatable-per-page-' + obj.element.id).val(parseInt(settings.dataset.perPage));
                }
            }

            // Sort headers functionality
            if (settings.features.sort && columns) {
                obj.sortsHeaders.removeAllArrows();
                for (var i = 0, len = columns.length; i < len; i++) {
                    var column = columns[i],
                        sortedByColumn = utility.allMatch(settings.dataset.sorts, column.sorts, function(sorts, sort) { return sort in sorts; }),
                        value = settings.dataset.sorts[column.sorts[0]];

                    if (sortedByColumn) {
                        obj.$element.find('[data-dynatable-column="' + column.id + '"]').find('.dynatable-sort-header').each(function(){
                            if (value == 1) {
                                obj.sortsHeaders.appendArrowUp($(this));
                            } else {
                                obj.sortsHeaders.appendArrowDown($(this));
                            }
                        });
                    }
                }
            }

            // Query search functionality
            if (settings.inputs.queries || settings.features.search) {
                var allQueries = settings.inputs.queries || $();
                if (settings.features.search) {
                    allQueries = allQueries.add('#dynatable-query-search-' + obj.element.id);
                }

                allQueries.each(function() {
                    var $this = $(this),
                        q = settings.dataset.queries[$this.data('dynatable-query')];
                    $this.val(q || '');
                });
            }

            obj.$element.find(settings.table.bodyRowSelector).remove();
            obj.$element.append(rows);

            obj.$element.trigger('dynatable:afterUpdate', rows);
        };
    };

    function DomColumns(obj, settings) {
        var _this = this;

        this.initOnLoad = function() {
            return obj.$element.is('table');
        };

        this.init = function() {
            settings.table.columns = [];
            this.getFromTable();
        };

        // initialize table[columns] array
        this.getFromTable = function() {
            var $columns = obj.$element.find(settings.table.headRowSelector).children('th,td');
            if ($columns.length) {
                $columns.each(function(index){
                    _this.add($(this), index, true);
                });
            } else {
                return $.error("Couldn't find any columns headers in '" + settings.table.headRowSelector + " th,td'. If your header row is different, specify the selector in the table: headRowSelector option.");
            }
        };

        this.add = function($column, position, skipAppend, skipUpdate) {
            var columns = settings.table.columns,
                label = $column.text(),
                id = $column.data('dynatable-column') || utility.normalizeText(label, settings.table.defaultColumnIdStyle),
                dataSorts = $column.data('dynatable-sorts'),
                sorts = dataSorts ? $.map(dataSorts.split(','), function(text) { return $.trim(text); }) : [id];

            // If the column id is blank, generate an id for it
            if ( !id ) {
                this.generate($column);
                id = $column.data('dynatable-column');
            }
            // Add column data to plugin instance
            columns.splice(position, 0, {
                index: position,
                label: label,
                id: id,
                attributeWriter: settings.writers[id] || settings.writers._attributeWriter,
                attributeReader: settings.readers[id] || settings.readers._attributeReader,
                sorts: sorts,
                hidden: $column.css('display') === 'none',
                textAlign: settings.table.copyHeaderAlignment && $column.css('text-align'),
                cssClass: settings.table.copyHeaderClass && $column.attr('class')
            });

            // Modify header cell
            $column
                .attr('data-dynatable-column', id)
                .addClass('dynatable-head');
            if (settings.table.headRowClass) { $column.addClass(settings.table.headRowClass); }

            // Append column header to table
            if (!skipAppend) {
                var domPosition = position + 1,
                    $sibling = obj.$element.find(settings.table.headRowSelector)
                        .children('th:nth-child(' + domPosition + '),td:nth-child(' + domPosition + ')').first(),
                    columnsAfter = columns.slice(position + 1, columns.length);

                if ($sibling.length) {
                    $sibling.before($column);
                    // sibling column doesn't yet exist (maybe this is the last column in the header row)
                } else {
                    obj.$element.find(settings.table.headRowSelector).append($column);
                }

                obj.sortsHeaders.attachOne($column.get());

                // increment the index of all columns after this one that was just inserted
                if (columnsAfter.length) {
                    for (var i = 0, len = columnsAfter.length; i < len; i++) {
                        columnsAfter[i].index += 1;
                    }
                }

                if (!skipUpdate) {
                    obj.dom.update();
                }
            }

            return dt;
        };

        this.remove = function(columnIndexOrId) {
            var columns = settings.table.columns,
                length = columns.length;

            if (typeof(columnIndexOrId) === "number") {
                var column = columns[columnIndexOrId];
                this.removeFromTable(column.id);
                this.removeFromArray(columnIndexOrId);
            } else {
                // Traverse columns array in reverse order so that subsequent indices
                // don't get messed up when we delete an item from the array in an iteration
                for (var i = columns.length - 1; i >= 0; i--) {
                    var column = columns[i];

                    if (column.id === columnIndexOrId) {
                        this.removeFromTable(columnIndexOrId);
                        this.removeFromArray(i);
                    }
                }
            }

            obj.dom.update();
        };

        this.removeFromTable = function(columnId) {
            obj.$element.find(settings.table.headRowSelector).children('[data-dynatable-column="' + columnId + '"]').first()
                .remove();
        };

        this.removeFromArray = function(index) {
            var columns = settings.table.columns,
                adjustColumns;
            columns.splice(index, 1);
            adjustColumns = columns.slice(index, columns.length);
            for (var i = 0, len = adjustColumns.length; i < len; i++) {
                adjustColumns[i].index -= 1;
            }
        };

        this.generate = function($cell) {
            var cell = $cell === undefined ? $('<th></th>') : $cell;
            return this.attachGeneratedAttributes(cell);
        };

        this.attachGeneratedAttributes = function($cell) {
            // Use increment to create unique column name that is the same each time the page is reloaded,
            // in order to avoid errors with mismatched attribute names when loading cached `dataset.records` array
            var increment = obj.$element.find(settings.table.headRowSelector).children('th[data-dynatable-generated]').length;
            return $cell
                .attr('data-dynatable-column', 'dynatable-generated-' + increment) //+ utility.randomHash(),
                .attr('data-dynatable-no-sort', 'true')
                .attr('data-dynatable-generated', increment);
        };
    };

    function Records(obj, settings) {
        var _this = this;

        this.initOnLoad = function() {
            return !settings.dataset.ajax;
        };

        this.init = function() {
            if (settings.dataset.records === null) {
                settings.dataset.records = this.getFromTable();

                if (!settings.dataset.queryRecordCount) {
                    settings.dataset.queryRecordCount = this.count();
                }

                if (!settings.dataset.totalRecordCount){
                    settings.dataset.totalRecordCount = settings.dataset.queryRecordCount;
                }
            }

            // Create cache of original full recordset (unpaginated and unqueried)
            settings.dataset.originalRecords = $.extend(true, [], settings.dataset.records);
        };

        // merge ajax response json with cached data including
        // meta-data and records
        this.updateFromJson = function(data) {
            var records;
            if (settings.params.records === "_root") {
                records = data;
            } else if (settings.params.records in data) {
                records = data[settings.params.records];
            }
            if (settings.params.record) {
                var len = records.length - 1;
                for (var i = 0; i < len; i++) {
                    records[i] = records[i][settings.params.record];
                }
            }
            if (settings.params.queryRecordCount in data) {
                settings.dataset.queryRecordCount = data[settings.params.queryRecordCount];
            }
            if (settings.params.totalRecordCount in data) {
                settings.dataset.totalRecordCount = data[settings.params.totalRecordCount];
            }
            settings.dataset.records = records;
        };

        // For really advanced sorting,
        // see http://james.padolsey.com/javascript/sorting-elements-with-jquery/
        this.sort = function() {
            var sort = [].sort,
                sorts = settings.dataset.sorts,
                sortsKeys = settings.dataset.sortsKeys,
                sortTypes = settings.dataset.sortTypes;

            var sortFunction = function(a, b) {
                var comparison;
                if ($.isEmptyObject(sorts)) {
                    comparison = obj.sorts.functions['originalPlacement'](a, b);
                } else {
                    for (var i = 0, len = sortsKeys.length; i < len; i++) {
                        var attr = sortsKeys[i],
                            direction = sorts[attr],
                            sortType = sortTypes[attr] || obj.sorts.guessType(a, b, attr);
                        comparison = obj.sorts.functions[sortType](a, b, attr, direction);
                        // Don't need to sort any further unless this sort is a tie between a and b,
                        // so break the for loop unless tied
                        if (comparison !== 0) { break; }
                    }
                }
                return comparison;
            }

            return sort.call(settings.dataset.records, sortFunction);
        };

        this.paginate = function() {
            var bounds = this.pageBounds(),
                first = bounds[0], last = bounds[1];
            settings.dataset.records = settings.dataset.records.slice(first, last);
        };

        this.resetOriginal = function() {
            settings.dataset.records = settings.dataset.originalRecords || [];
        };

        this.pageBounds = function() {
            var page = settings.dataset.page || 1,
                first = (page - 1) * settings.dataset.perPage,
                last = Math.min(first + settings.dataset.perPage, settings.dataset.queryRecordCount);
            return [first,last];
        };

        // get initial recordset to populate table
        // if ajax, call ajaxUrl
        // otherwise, initialize from in-table records
        this.getFromTable = function() {
            var records = [],
                columns = settings.table.columns,
                tableRecords = obj.$element.find(settings.table.bodyRowSelector);

            tableRecords.each(function(index){
                var record = {};
                record['dynatable-original-index'] = index;
                $(this).find('th,td').each(function(index) {
                    if (columns[index] === undefined) {
                        // Header cell didn't exist for this column, so let's generate and append
                        // a new header cell with a randomly generated name (so we can store and
                        // retrieve the contents of this column for each record)
                        obj.domColumns.add(obj.domColumns.generate(), columns.length, false, true); // don't skipAppend, do skipUpdate
                    }
                    var value = columns[index].attributeReader(this, record),
                        attr = columns[index].id;

                    // If value from table is HTML, let's get and cache the text equivalent for
                    // the default string sorting, since it rarely makes sense for sort headers
                    // to sort based on HTML tags.
                    if (typeof(value) === "string" && value.match(/\s*\<.+\>/)) {
                        if (! record['dynatable-sortable-text']) {
                            record['dynatable-sortable-text'] = {};
                        }        
                        value = value.replace(/&nbsp;/gi,' ');
                        record['dynatable-sortable-text'][attr] = $.trim($('<div></div>').html(value).text());
                    }

                    record[attr] = value;
                });
                // Allow configuration function which alters record based on attributes of
                // table row (e.g. from html5 data- attributes)
                if (typeof(settings.readers._rowReader) === "function") {
                    settings.readers._rowReader(index, this, record);
                }
                records.push(record);
            });
            return records; // 1st row is header
        };

        // count records from table
        this.count = function() {
            return settings.dataset.records.length;
        };
    };

    function RecordsCount(obj, settings) {
        this.initOnLoad = function() {
            return settings.features.recordCount;
        };

        this.init = function() {
            this.attach();
        };

        this.create = function() {
            var pageTemplate = '',
                filteredTemplate = '',
                options = {
                    elementId: obj.element.id,
                    recordsShown: obj.records.count(),
                    recordsQueryCount: settings.dataset.queryRecordCount,
                    recordsTotal: settings.dataset.totalRecordCount,
                    collectionName: settings.params.records === "_root" ? "records" : settings.params.records,
                    text: settings.inputs.recordCountText
                };

            if (settings.features.paginate) {

                // If currently displayed records are a subset (page) of the entire collection
                if (options.recordsShown < options.recordsQueryCount) {
                    var bounds = obj.records.pageBounds();
                    options.pageLowerBound = bounds[0] + 1;
                    options.pageUpperBound = bounds[1];
                    pageTemplate = settings.inputs.recordCountPageBoundTemplate;

                    // Else if currently displayed records are the entire collection
                } else if (options.recordsShown === options.recordsQueryCount) {
                    pageTemplate = settings.inputs.recordCountPageUnboundedTemplate;
                }
            }

            // If collection for table is queried subset of collection
            if (options.recordsQueryCount < options.recordsTotal) {
                filteredTemplate = settings.inputs.recordCountFilteredTemplate;
            }

            // Populate templates with options
            options.pageTemplate = utility.template(pageTemplate, options);
            options.filteredTemplate = utility.template(filteredTemplate, options);
            options.totalTemplate = utility.template(settings.inputs.recordCountTotalTemplate, options);
            options.textTemplate = utility.template(settings.inputs.recordCountTextTemplate, options);

            return utility.template(settings.inputs.recordCountTemplate, options);
        };

        this.attach = function() {
            var $target = settings.inputs.recordCountTarget ? $(settings.inputs.recordCountTarget) : obj.$element;
            $target[settings.inputs.recordCountPlacement](this.create());
        };
    };

    function ProcessingIndicator(obj, settings) {
        this.init = function() {
            this.attach();
        };

        this.create = function() {
            var $processing = $('<div></div>', {
                html: '<span>' + settings.inputs.processingText + '</span>',
                id: 'dynatable-processing-' + obj.element.id,
                'class': 'dynatable-processing',
                style: 'position: absolute; display: none;'
            });

            return $processing;
        };

        this.position = function() {
            var $processing = $('#dynatable-processing-' + obj.element.id),
                $span = $processing.children('span'),
                spanHeight = $span.outerHeight(),
                spanWidth = $span.outerWidth(),
                $covered = obj.$element,
                offset = $covered.offset(),
                height = $covered.outerHeight(), width = $covered.outerWidth();

            $processing
                .offset({left: offset.left, top: offset.top})
                .width(width)
                .height(height)
            $span
                .offset({left: offset.left + ( (width - spanWidth) / 2 ), top: offset.top + ( (height - spanHeight) / 2 )});

            return $processing;
        };

        this.attach = function() {
            obj.$element.before(this.create());
        };

        this.show = function() {
            $('#dynatable-processing-' + obj.element.id).show();
            this.position();
        };

        this.hide = function() {
            $('#dynatable-processing-' + obj.element.id).hide();
        };
    };

    function State(obj, settings) {
        this.initOnLoad = function() {
            // Check if pushState option is true, and if browser supports it
            return settings.features.pushState && history.pushState;
        };

        this.init = function() {
            window.onpopstate = function(event) {
                if (event.state && event.state.dynatable) {
                    obj.state.pop(event);
                }
            }
        };

        this.push = function(data) {
            var urlString = window.location.search,
                urlOptions,
                path,
                params,
                hash,
                newParams,
                cacheStr,
                cache,
                // replaceState on initial load, then pushState after that
                firstPush = !(window.history.state && window.history.state.dynatable),
                pushFunction = firstPush ? 'replaceState' : 'pushState';

            if (urlString && /^\?/.test(urlString)) { urlString = urlString.substring(1); }
            $.extend(urlOptions, data);

            params = utility.refreshQueryString(urlString, data, settings);
            if (params) { params = '?' + params; }
            hash = window.location.hash;
            path = window.location.pathname;

            obj.$element.trigger('dynatable:push', data);

            cache = { dynatable: { dataset: settings.dataset } };
            if (!firstPush) { cache.dynatable.scrollTop = $(window).scrollTop(); }
            cacheStr = JSON.stringify(cache);

            // Mozilla has a 640k char limit on what can be stored in pushState.
            // See "limit" in https://developer.mozilla.org/en/DOM/Manipulating_the_browser_history#The_pushState().C2.A0method
            // and "dataStr.length" in http://wine.git.sourceforge.net/git/gitweb.cgi?p=wine/wine-gecko;a=patch;h=43a11bdddc5fc1ff102278a120be66a7b90afe28
            //
            // Likewise, other browsers may have varying (undocumented) limits.
            // Also, Firefox's limit can be changed in about:config as browser.history.maxStateObjectSize
            // Since we don't know what the actual limit will be in any given situation, we'll just try caching and rescue
            // any exceptions by retrying pushState without caching the records.
            //
            // I have absolutely no idea why perPageOptions suddenly becomes an array-like object instead of an array,
            // but just recently, this started throwing an error if I don't convert it:
            // 'Uncaught Error: DATA_CLONE_ERR: DOM Exception 25'
            cache.dynatable.dataset.perPageOptions = $.makeArray(cache.dynatable.dataset.perPageOptions);

            try {
                window.history[pushFunction](cache, "Dynatable state", path + params + hash);
            } catch(error) {
                // Make cached records = null, so that `pop` will rerun process to retrieve records
                cache.dynatable.dataset.records = null;
                window.history[pushFunction](cache, "Dynatable state", path + params + hash);
            }
        };

        this.pop = function(event) {
            var data = event.state.dynatable;
            settings.dataset = data.dataset;

            if (data.scrollTop) { $(window).scrollTop(data.scrollTop); }

            // If dataset.records is cached from pushState
            if ( data.dataset.records ) {
                obj.dom.update();
            } else {
                obj.process(true);
            }
        };
    };

    function Sorts(obj, settings) {
        this.initOnLoad = function() {
            return settings.features.sort;
        };

        this.init = function() {
            var sortsUrl = window.location.search.match(new RegExp(settings.params.sorts + '[^&=]*=[^&]*', 'g'));
            if (sortsUrl) {
                settings.dataset.sorts = utility.deserialize(sortsUrl)[settings.params.sorts];
            }
            if (!settings.dataset.sortsKeys.length) {
                settings.dataset.sortsKeys = utility.keysFromObject(settings.dataset.sorts);
            }
        };

        this.add = function(attr, direction) {
            var sortsKeys = settings.dataset.sortsKeys,
                index = $.inArray(attr, sortsKeys);
            settings.dataset.sorts[attr] = direction;
            obj.$element.trigger('dynatable:sorts:added', [attr, direction]);
            if (index === -1) { sortsKeys.push(attr); }
            return dt;
        };

        this.remove = function(attr) {
            var sortsKeys = settings.dataset.sortsKeys,
                index = $.inArray(attr, sortsKeys);
            delete settings.dataset.sorts[attr];
            obj.$element.trigger('dynatable:sorts:removed', attr);
            if (index !== -1) { sortsKeys.splice(index, 1); }
            return dt;
        };

        this.clear = function() {
            settings.dataset.sorts = {};
            settings.dataset.sortsKeys.length = 0;
            obj.$element.trigger('dynatable:sorts:cleared');
        };

        // Try to intelligently guess which sort function to use
        // based on the type of attribute values.
        // Consider using something more robust than `typeof` (http://javascriptweblog.wordpress.com/2011/08/08/fixing-the-javascript-typeof-operator/)
        this.guessType = function(a, b, attr) {
            var types = {
                    string: 'string',
                    number: 'number',
                    'boolean': 'number',
                    object: 'number' // dates and null values are also objects, this works...
                },
                attrType = a[attr] ? typeof(a[attr]) : typeof(b[attr]),
                type = types[attrType] || 'number';
            return type;
        };

        // Built-in sort functions
        // (the most common use-cases I could think of)
        this.functions = {
            number: function(a, b, attr, direction) {
                return a[attr] === b[attr] ? 0 : (direction > 0 ? a[attr] - b[attr] : b[attr] - a[attr]);
            },
            string: function(a, b, attr, direction) {
                var aAttr = (a['dynatable-sortable-text'] && a['dynatable-sortable-text'][attr]) ? a['dynatable-sortable-text'][attr] : a[attr],
                    bAttr = (b['dynatable-sortable-text'] && b['dynatable-sortable-text'][attr]) ? b['dynatable-sortable-text'][attr] : b[attr],
                    comparison;
                aAttr = aAttr.toLowerCase();
                bAttr = bAttr.toLowerCase();
                comparison = aAttr === bAttr ? 0 : (direction > 0 ? aAttr > bAttr : bAttr > aAttr);
                // force false boolean value to -1, true to 1, and tie to 0
                return comparison === false ? -1 : (comparison - 0);
            },
            originalPlacement: function(a, b) {
                return a['dynatable-original-index'] - b['dynatable-original-index'];
            }
        };
    };

    // turn table headers into links which add sort to sorts array
    function SortsHeaders(obj, settings) {
        var _this = this;

        this.initOnLoad = function() {
            return settings.features.sort;
        };

        this.init = function() {
            this.attach();
        };

        this.create = function(cell) {
            var $cell = $(cell),
                $link = $('<a></a>', {
                    'class': 'dynatable-sort-header',
                    href: '#',
                    html: $cell.html()
                }),
                id = $cell.data('dynatable-column'),
                column = utility.findObjectInArray(settings.table.columns, {id: id});

            $link.bind('click', function(e) {
                _this.toggleSort(e, $link, column);
                obj.process();

                e.preventDefault();
            });

            if (this.sortedByColumn($link, column)) {
                if (this.sortedByColumnValue(column) == 1) {
                    this.appendArrowUp($link);
                } else {
                    this.appendArrowDown($link);
                }
            }

            return $link;
        };

        this.removeAll = function() {
            obj.$element.find(settings.table.headRowSelector).children('th,td').each(function(){
                _this.removeAllArrows();
                _this.removeOne(this);
            });
        };

        this.removeOne = function(cell) {
            var $cell = $(cell),
                $link = $cell.find('.dynatable-sort-header');
            if ($link.length) {
                var html = $link.html();
                $link.remove();
                $cell.html($cell.html() + html);
            }
        };

        this.attach = function() {
            obj.$element.find(settings.table.headRowSelector).children('th,td').each(function(){
                _this.attachOne(this);
            });
        };

        this.attachOne = function(cell) {
            var $cell = $(cell);
            if (!$cell.data('dynatable-no-sort')) {
                $cell.html(this.create(cell));
            }
        };

        this.appendArrowUp = function($link) {
            this.removeArrow($link);
            // CUSTOM
            $link.prepend("<span class='dynatable-arrow material-icons'>&#xE316;</span>");
            $link.parent().addClass('active');
        };

        this.appendArrowDown = function($link) {
            this.removeArrow($link);
            // CUSTOM
            $link.prepend("<span class='dynatable-arrow material-icons dynatableDown'>&#xE313;</span>");
            $link.parent().addClass('active');
        };

        this.removeArrow = function($link) {
            // Not sure why `parent()` is needed, the arrow should be inside the link from `append()` above
            $link.find('.dynatable-arrow').remove();
            $link.parent().removeClass('active');

        };

        this.removeAllArrows = function() {
            obj.$element.find('.dynatable-arrow').remove();

            // OYV CUSTOM: deactivate all
            obj.$element.find('.dynatable-sort-header').each(function(){
                $(this).parent().removeClass('active');
                // CUSTOM
                $(this).prepend("<span class='dynatable-arrow material-icons default_style'>&#xE313;</span>");
            });
//      obj.$element.find('.dynatable-sort-header').removeClass('active');
        };

        this.toggleSort = function(e, $link, column) {
            var sortedByColumn = this.sortedByColumn($link, column),
                value = this.sortedByColumnValue(column);
            // Clear existing sorts unless this is a multisort event
            if (!settings.inputs.multisort || !utility.anyMatch(e, settings.inputs.multisort, function(evt, key) { return e[key]; })) {
                this.removeAllArrows();
                obj.sorts.clear();
            }

            // If sorts for this column are already set
            if (sortedByColumn) {
                // If ascending, then make descending
                if (value == 1) {
                    for (var i = 0, len = column.sorts.length; i < len; i++) {
                        obj.sorts.add(column.sorts[i], -1);
                    }
                    this.appendArrowDown($link);
                    // If descending, remove sort
                } else {
//          for (var i = 0, len = column.sorts.length; i < len; i++) {
//            obj.sorts.remove(column.sorts[i]);
//          }
//          this.removeArrow($link);

                    // OYV CUSTOM: If descending, then make ascending
                    for (var i = 0, len = column.sorts.length; i < len; i++) {
                        obj.sorts.add(column.sorts[i], 1);
                    }
                    this.appendArrowUp($link);
                }
                // Otherwise, if not already set, set to ascending
            } else {
                for (var i = 0, len = column.sorts.length; i < len; i++) {
                    obj.sorts.add(column.sorts[i], 1);
                }
                this.appendArrowUp($link);
            }
        };

        this.sortedByColumn = function($link, column) {
            return utility.allMatch(settings.dataset.sorts, column.sorts, function(sorts, sort) { return sort in sorts; });
        };

        this.sortedByColumnValue = function(column) {
            return settings.dataset.sorts[column.sorts[0]];
        };
    };

    function Queries(obj, settings) {
        var _this = this;

        this.initOnLoad = function() {
            return settings.inputs.queries || settings.features.search;
        };

        this.init = function() {
            var queriesUrl = window.location.search.match(new RegExp(settings.params.queries + '[^&=]*=[^&]*', 'g'));

            settings.dataset.queries = queriesUrl ? utility.deserialize(queriesUrl)[settings.params.queries] : {};
            if (settings.dataset.queries === "") { settings.dataset.queries = {}; }

            if (settings.inputs.queries) {
                this.setupInputs();
            }
        };

        this.add = function(name, value) {
            // reset to first page since query will change records
            if (settings.features.paginate) {
                settings.dataset.page = 1;
            }
            settings.dataset.queries[name] = value;
            obj.$element.trigger('dynatable:queries:added', [name, value]);
            return dt;
        };

        this.remove = function(name) {
            delete settings.dataset.queries[name];
            obj.$element.trigger('dynatable:queries:removed', name);
            return dt;
        };

        this.run = function() {
            for (query in settings.dataset.queries) {
                if (settings.dataset.queries.hasOwnProperty(query)) {
                    var value = settings.dataset.queries[query];
                    if (_this.functions[query] === undefined) {
                        // Try to lazily evaluate query from column names if not explicitly defined
                        var queryColumn = utility.findObjectInArray(settings.table.columns, {id: query});
                        if (queryColumn) {
                            _this.functions[query] = function(record, queryValue) {
                                return record[query] == queryValue;
                            };
                        } else {
                            $.error("Query named '" + query + "' called, but not defined in queries.functions");
                            continue; // to skip to next query
                        }
                    }
                    // collect all records that return true for query
                    settings.dataset.records = $.map(settings.dataset.records, function(record) {
                        return _this.functions[query](record, value) ? record : null;
                    });
                }
            }
            settings.dataset.queryRecordCount = obj.records.count();
        };

        // Shortcut for performing simple query from built-in search
        this.runSearch = function(q) {
            var origQueries = $.extend({}, settings.dataset.queries);
            if (q) {
                this.add('search', q);
            } else {
                this.remove('search');
            }
            if (!utility.objectsEqual(settings.dataset.queries, origQueries)) {
                obj.process();
            }
        };

        this.setupInputs = function() {
            settings.inputs.queries.each(function() {
                var $this = $(this),
                    event = $this.data('dynatable-query-event') || settings.inputs.queryEvent,
                    query = $this.data('dynatable-query') || $this.attr('name') || this.id,
                    queryFunction = function(e) {
                        var q = $(this).val();
                        if (q === "") { q = undefined; }
                        if (q === settings.dataset.queries[query]) { return false; }
                        if (q) {
                            _this.add(query, q);
                        } else {
                            _this.remove(query);
                        }
                        obj.process();
                        e.preventDefault();
                    };

                $this
                    .attr('data-dynatable-query', query)
                    .bind(event, queryFunction)
                    .bind('keypress', function(e) {
                        if (e.which == 13) {
                            queryFunction.call(this, e);
                        }
                    });

                if (settings.dataset.queries[query]) { $this.val(decodeURIComponent(settings.dataset.queries[query])); }
            });
        };

        // Query functions for in-page querying
        // each function should take a record and a value as input
        // and output true of false as to whether the record is a match or not
        this.functions = {
            search: function(record, queryValue) {
                queryValue = makeFuzzyRegex(queryValue.toLowerCase());
                var contains = false;
                // Loop through each attribute of record
                for (attr in record) {
                    if (record.hasOwnProperty(attr)) {
                        var attrValue = record[attr];
                        if (typeof(attrValue) === "string" && attrValue.toLowerCase().match(queryValue)) {
                            contains = true;
                            // Don't need to keep searching attributes once found
                            break;
                        } else {
                            continue;
                        }
                    }
                }
                return contains;
            }
        };
    };

    function InputsSearch(obj, settings) {
        var _this = this;

        this.initOnLoad = function() {
            return settings.features.search;
        };

        this.init = function() {
            this.attach();
        };

        this.create = function() {
            var $search = $('<input />', {
                    type: 'search',
                    id: 'dynatable-query-search-' + obj.element.id,
                    'data-dynatable-query': 'search',
                    value: settings.dataset.queries.search
                }),
                $searchSpan = $('<span></span>', {
                    id: 'dynatable-search-' + obj.element.id,
                    'class': 'dynatable-search',
                    text: settings.inputs.searchText
                }).append($search);

            $search
                .bind(settings.inputs.queryEvent, function() {
                    obj.queries.runSearch($(this).val());
                })
                .bind('keypress', function(e) {
                    if (e.which == 13) {
                        obj.queries.runSearch($(this).val());
                        e.preventDefault();
                    }
                });
            return $searchSpan;
        };

        this.attach = function() {
            var $target = settings.inputs.searchTarget ? $(settings.inputs.searchTarget) : obj.$element;
            $target[settings.inputs.searchPlacement](this.create());
        };
    };

    // provide a public function for selecting page
    function PaginationPage(obj, settings) {
        this.initOnLoad = function() {
            return settings.features.paginate;
        };

        this.init = function() {
            var pageUrl = window.location.search.match(new RegExp(settings.params.page + '=([^&]*)'));
            // If page is present in URL parameters and pushState is enabled
            // (meaning that it'd be possible for dynatable to have put the
            // page parameter in the URL)
            if (pageUrl && settings.features.pushState) {
                this.set(pageUrl[1]);
            } else {
                this.set(1);
            }
        };

        this.set = function(page) {
            var newPage = parseInt(page, 10);
            settings.dataset.page = newPage;
            obj.$element.trigger('dynatable:page:set', newPage);
        }
    };

    function PaginationPerPage(obj, settings) {
        var _this = this;

        this.initOnLoad = function() {
            return settings.features.paginate;
        };

        this.init = function() {
            var perPageUrl = window.location.search.match(new RegExp(settings.params.perPage + '=([^&]*)'));

            // If perPage is present in URL parameters and pushState is enabled
            // (meaning that it'd be possible for dynatable to have put the
            // perPage parameter in the URL)
            if (perPageUrl && settings.features.pushState) {
                // Don't reset page to 1 on init, since it might override page
                // set on init from URL
                this.set(perPageUrl[1], true);
            } else {
                this.set(settings.dataset.perPageDefault, true);
            }

            if (settings.features.perPageSelect) {
                this.attach();
            }
        };

        this.create = function() {
            var $select = $('<select>', {
                id: 'dynatable-per-page-' + obj.element.id,
                'class': 'dynatable-per-page-select'
            });

            for (var i = 0, len = settings.dataset.perPageOptions.length; i < len; i++) {
                var number = settings.dataset.perPageOptions[i],
                    selected = settings.dataset.perPage == number ? 'selected="selected"' : '';
                $select.append('<option value="' + number + '" ' + selected + '>' + number + '</option>');
            }

            $select.bind('change', function(e) {
                _this.set($(this).val());
                obj.process();
            });

            return $('<span />', {
                'class': 'dynatable-per-page'
            }).append("<span class='dynatable-per-page-label'>" + settings.inputs.perPageText + "</span>").append($select);
        };

        this.attach = function() {
            var $target = settings.inputs.perPageTarget ? $(settings.inputs.perPageTarget) : obj.$element;
            $target[settings.inputs.perPagePlacement](this.create());
        };

        this.set = function(number, skipResetPage) {
            var newPerPage = parseInt(number);
            if (!skipResetPage) { obj.paginationPage.set(1); }
            settings.dataset.perPage = newPerPage;
            obj.$element.trigger('dynatable:perPage:set', newPerPage);
        };
    };

    // pagination links which update dataset.page attribute
    function PaginationLinks(obj, settings) {
        var _this = this;

        this.initOnLoad = function() {
            return settings.features.paginate;
        };

        this.init = function() {
            this.attach();
        };

        this.create = function() {
            var pageLinks = '<ul id="' + 'dynatable-pagination-links-' + obj.element.id + '" class="' + settings.inputs.paginationClass + '">',
                pageLinkClass = settings.inputs.paginationLinkClass,
                activePageClass = settings.inputs.paginationActiveClass,
                disabledPageClass = settings.inputs.paginationDisabledClass,
                pages = Math.ceil(settings.dataset.queryRecordCount / settings.dataset.perPage),
                page = settings.dataset.page,
                breaks = [
                    settings.inputs.paginationGap[0],
                    settings.dataset.page - settings.inputs.paginationGap[1],
                    settings.dataset.page + settings.inputs.paginationGap[2],
                    (pages + 1) - settings.inputs.paginationGap[3]
                ];

            pageLinks += '<li><span>' + settings.inputs.pageText + '</span></li>';

            for (var i = 1; i <= pages; i++) {
                if ( (i > breaks[0] && i < breaks[1]) || (i > breaks[2] && i < breaks[3])) {
                    // skip to next iteration in loop
                    continue;
                } else {
                    var li = obj.paginationLinks.buildLink(i, i, pageLinkClass, page == i, activePageClass),
                        breakIndex,
                        nextBreak;

                    // If i is not between one of the following
                    // (1 + (settings.paginationGap[0]))
                    // (page - settings.paginationGap[1])
                    // (page + settings.paginationGap[2])
                    // (pages - settings.paginationGap[3])
                    breakIndex = $.inArray(i, breaks);
                    nextBreak = breaks[breakIndex + 1];
                    if (breakIndex > 0 && i !== 1 && nextBreak && nextBreak > (i + 1)) {
                        var ellip = '<li><span class="dynatable-page-break">&hellip;</span></li>';
                        li = breakIndex < 2 ? ellip + li : li + ellip;
                    }

                    if (settings.inputs.paginationPrev && i === 1) {
                        var prevLi = obj.paginationLinks.buildLink(page - 1, settings.inputs.paginationPrev, pageLinkClass + ' ' + settings.inputs.paginationPrevClass, page === 1, disabledPageClass);
                        li = prevLi + li;
                    }
                    if (settings.inputs.paginationNext && i === pages) {
                        var nextLi = obj.paginationLinks.buildLink(page + 1, settings.inputs.paginationNext, pageLinkClass + ' ' + settings.inputs.paginationNextClass, page === pages, disabledPageClass);
                        li += nextLi;
                    }

                    pageLinks += li;
                }
            }

            pageLinks += '</ul>';

            // only bind page handler to non-active and non-disabled page links
            var selector = '#dynatable-pagination-links-' + obj.element.id + ' a.' + pageLinkClass + ':not(.' + activePageClass + ',.' + disabledPageClass + ')';
            // kill any existing delegated-bindings so they don't stack up
            $(document).undelegate(selector, 'click.dynatable');
            $(document).delegate(selector, 'click.dynatable', function(e) {
                $this = $(this);
                $this.closest(settings.inputs.paginationClass).find('.' + activePageClass).removeClass(activePageClass);
                $this.addClass(activePageClass);

                obj.paginationPage.set($this.data('dynatable-page'));
                obj.process();
                e.preventDefault();
            });

            return pageLinks;
        };

        this.buildLink = function(page, label, linkClass, conditional, conditionalClass) {
            var link = '<a data-dynatable-page=' + page + ' class="' + linkClass,
                li = '<li';

            if (conditional) {
                link += ' ' + conditionalClass;
                li += ' class="' + conditionalClass + '"';
            }

            link += '">' + label + '</a>';
            li += '>' + link + '</li>';

            return li;
        };

        this.attach = function() {
            // append page links *after* delegate-event-binding so it doesn't need to
            // find and select all page links to bind event
            var $target = settings.inputs.paginationLinkTarget ? $(settings.inputs.paginationLinkTarget) : obj.$element;
            $target[settings.inputs.paginationLinkPlacement](obj.paginationLinks.create());
        };
    };

    utility = dt.utility = {
        normalizeText: function(text, style) {
            text = this.textTransform[style](text);
            return text;
        },
        textTransform: {
            trimDash: function(text) {
                return text.replace(/^\s+|\s+$/g, "").replace(/\s+/g, "-");
            },
            camelCase: function(text) {
                text = this.trimDash(text);
                return text
                    .replace(/(\-[a-zA-Z])/g, function($1){return $1.toUpperCase().replace('-','');})
                    .replace(/([A-Z])([A-Z]+)/g, function($1,$2,$3){return $2 + $3.toLowerCase();})
                    .replace(/^[A-Z]/, function($1){return $1.toLowerCase();});
            },
            dashed: function(text) {
                text = this.trimDash(text);
                return this.lowercase(text);
            },
            underscore: function(text) {
                text = this.trimDash(text);
                return this.lowercase(text.replace(/(-)/g, '_'));
            },
            lowercase: function(text) {
                return text.replace(/([A-Z])/g, function($1){return $1.toLowerCase();});
            }
        },
        // Deserialize params in URL to object
        // see http://stackoverflow.com/questions/1131630/javascript-jquery-param-inverse-function/3401265#3401265
        deserialize: function(query) {
            if (!query) return {};
            // modified to accept an array of partial URL strings
            if (typeof(query) === "object") { query = query.join('&'); }

            var hash = {},
                vars = query.split("&");

            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("="),
                    k = decodeURIComponent(pair[0]),
                    v, m;

                if (!pair[1]) { continue };
                v = decodeURIComponent(pair[1].replace(/\+/g, ' '));

                // modified to parse multi-level parameters (e.g. "hi[there][dude]=whatsup" => hi: {there: {dude: "whatsup"}})
                while (m = k.match(/([^&=]+)\[([^&=]+)\]$/)) {
                    var origV = v;
                    k = m[1];
                    v = {};

                    // If nested param ends in '][', then the regex above erroneously included half of a trailing '[]',
                    // which indicates the end-value is part of an array
                    if (m[2].substr(m[2].length-2) == '][') { // must use substr for IE to understand it
                        v[m[2].substr(0,m[2].length-2)] = [origV];
                    } else {
                        v[m[2]] = origV;
                    }
                }

                // If it is the first entry with this name
                if (typeof hash[k] === "undefined") {
                    if (k.substr(k.length-2) != '[]') { // not end with []. cannot use negative index as IE doesn't understand it
                        hash[k] = v;
                    } else {
                        hash[k] = [v];
                    }
                    // If subsequent entry with this name and not array
                } else if (typeof hash[k] === "string") {
                    hash[k] = v;  // replace it
                    // modified to add support for objects
                } else if (typeof hash[k] === "object") {
                    hash[k] = $.extend({}, hash[k], v);
                    // If subsequent entry with this name and is array
                } else {
                    hash[k].push(v);
                }
            }
            return hash;
        },
        refreshQueryString: function(urlString, data, settings) {
            var _this = this,
                queryString = urlString.split('?'),
                path = queryString.shift(),
                urlOptions;

            urlOptions = this.deserialize(urlString);

            // Loop through each dynatable param and update the URL with it
            for (attr in settings.params) {
                if (settings.params.hasOwnProperty(attr)) {
                    var label = settings.params[attr];
                    // Skip over parameters matching attributes for disabled features (i.e. leave them untouched),
                    // because if the feature is turned off, then parameter name is a coincidence and it's unrelated to dynatable.
                    if (
                        (!settings.features.sort && attr == "sorts") ||
                        (!settings.features.paginate && _this.anyMatch(attr, ["page", "perPage", "offset"], function(attr, param) { return attr == param; }))
                    ) {
                        continue;
                    }

                    // Delete page and offset from url params if on page 1 (default)
                    if ((attr === "page" || attr === "offset") && data["page"] === 1) {
                        if (urlOptions[label]) {
                            delete urlOptions[label];
                        }
                        continue;
                    }

                    // Delete perPage from url params if default perPage value
                    if (attr === "perPage" && data[label] == settings.dataset.perPageDefault) {
                        if (urlOptions[label]) {
                            delete urlOptions[label];
                        }
                        continue;
                    }

                    // For queries, we're going to handle each possible query parameter individually here instead of
                    // handling the entire queries object below, since we need to make sure that this is a query controlled by dynatable.
                    if (attr == "queries" && data[label]) {
                        var queries = settings.inputs.queries || [],
                            inputQueries = $.makeArray(queries.map(function() { return $(this).attr('name') }));

                        if (settings.features.search) { inputQueries.push('search'); }

                        for (var i = 0, len = inputQueries.length; i < len; i++) {
                            var attr = inputQueries[i];
                            if (data[label][attr]) {
                                if (typeof urlOptions[label] === 'undefined') { urlOptions[label] = {}; }
                                urlOptions[label][attr] = data[label][attr];
                            } else {
                                if (urlOptions && urlOptions[label] && urlOptions[label][attr]) { delete urlOptions[label][attr]; }
                            }
                        }
                        continue;
                    }

                    // If we haven't returned true by now, then we actually want to update the parameter in the URL
                    if (data[label]) {
                        urlOptions[label] = data[label];
                    } else {
                        delete urlOptions[label];
                    }
                }
            }
            return $.param(urlOptions);
        },
        // Get array of keys from object
        // see http://stackoverflow.com/questions/208016/how-to-list-the-properties-of-a-javascript-object/208020#208020
        keysFromObject: function(obj){
            var keys = [];
            for (var key in obj){
                keys.push(key);
            }
            return keys;
        },
        // Find an object in an array of objects by attributes.
        // E.g. find object with {id: 'hi', name: 'there'} in an array of objects
        findObjectInArray: function(array, objectAttr) {
            var _this = this,
                foundObject;
            for (var i = 0, len = array.length; i < len; i++) {
                var item = array[i];
                // For each object in array, test to make sure all attributes in objectAttr match
                if (_this.allMatch(item, objectAttr, function(item, key, value) { return item[key] == value; })) {
                    foundObject = item;
                    break;
                }
            }
            return foundObject;
        },
        // Return true if supplied test function passes for ALL items in an array
        allMatch: function(item, arrayOrObject, test) {
            // start off with true result by default
            var match = true,
                isArray = $.isArray(arrayOrObject);
            // Loop through all items in array
            $.each(arrayOrObject, function(key, value) {
                var result = isArray ? test(item, value) : test(item, key, value);
                // If a single item tests false, go ahead and break the array by returning false
                // and return false as result,
                // otherwise, continue with next iteration in loop
                // (if we make it through all iterations without overriding match with false,
                // then we can return the true result we started with by default)
                if (!result) { return match = false; }
            });
            return match;
        },
        // Return true if supplied test function passes for ANY items in an array
        anyMatch: function(item, arrayOrObject, test) {
            var match = false,
                isArray = $.isArray(arrayOrObject);

            $.each(arrayOrObject, function(key, value) {
                var result = isArray ? test(item, value) : test(item, key, value);
                if (result) {
                    // As soon as a match is found, set match to true, and return false to stop the `$.each` loop
                    match = true;
                    return false;
                }
            });
            return match;
        },
        // Return true if two objects are equal
        // (i.e. have the same attributes and attribute values)
        objectsEqual: function(a, b) {
            for (attr in a) {
                if (a.hasOwnProperty(attr)) {
                    if (!b.hasOwnProperty(attr) || a[attr] !== b[attr]) {
                        return false;
                    }
                }
            }
            for (attr in b) {
                if (b.hasOwnProperty(attr) && !a.hasOwnProperty(attr)) {
                    return false;
                }
            }
            return true;
        },
        // Taken from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/105074#105074
        randomHash: function() {
            return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
        },
        // Adapted from http://stackoverflow.com/questions/377961/efficient-javascript-string-replacement/378001#378001
        template: function(str, data) {
            return str.replace(/{(\w*)}/g, function(match, key) {
                return data.hasOwnProperty(key) ? data[key] : "";
            });
        }
    };

    //-----------------------------------------------------------------
    // Build the dynatable plugin
    //-----------------------------------------------------------------

    // Object.create support test, and fallback for browsers without it
    if ( typeof Object.create !== "function" ) {
        Object.create = function (o) {
            function F() {}
            F.prototype = o;
            return new F();
        };
    }

    //-----------------------------------------------------------------
    // Global dynatable plugin setting defaults
    //-----------------------------------------------------------------

    $.dynatableSetup = function(options) {
        defaults = mergeSettings(options);
    };

    // Create dynatable plugin based on a defined object
    $.dynatable = function( object ) {
        $.fn['dynatable'] = function( options ) {
            return this.each(function() {
                if ( ! $.data( this, 'dynatable' ) ) {
                    $.data( this, 'dynatable', Object.create(object).init(this, options) );
                }
            });
        };
    };

    // WTP-260 Improved Search - Partial Matching
    function makeFuzzyRegex(string) {
        string = string.split(" ");
        var stringArray = new Array();
        for(var i =0; i < string.length; i++){
            stringArray.push(string[i]);
            if(i != string.length-1){
                stringArray.push(" ");
            }
            return stringArray[i];
        }
    }

    $.dynatable(dt);

})(jQuery);

if ( ! Modernizr.objectfit ) {
    $('.component_section_featured_component .col-md-4 p:first-child').each(function () {
        var $container = $(this),
            imgUrl = $container.find('img').prop('src');
        if (imgUrl) {
            $container
                .css('backgroundImage', 'url(' + imgUrl + ')')
                .addClass('compat-object-fit');
        }
    });
}
$(function () {
    var $breadcrumbtail = $('.js-breadcrumb-tail');
    var navigation_available = $(".navigation-global");
    var $window = $(window);
    var widthMobile = 992;

    //JD - This code only needs to run if the FAN protected indicator is present, so maybe one fewer binding to window scrolling is a good idea.
    if($breadcrumbtail.length && navigation_available.length) {
        //JD - on mobile, default to not visible and only show if a header is actually present, if there is no header there isn't really a correct place to put it!
        $(".breadcrumb-tail-panel").addClass("breadcrumb-tail-panel--visible");

        $window.scroll(function () {
            var y = $(this).scrollTop();

            var headerOffsetTop = $(this).getHeaderTopOffset();

            if ($window.width() > widthMobile) {
                if (y > headerOffsetTop) {
                    $breadcrumbtail.addClass('breadcrumb-tail--fixed');
                } else {
                    $breadcrumbtail.removeClass('breadcrumb-tail--fixed');
                }
            }
        });

        $window.scroll();
    }

});

//Basic search pre-submit function
function basicSearchOnSubmit(component_id) {
    var basic_search_form = $("#basic_search_form"+component_id);
    var basic_search_query_input = basic_search_form.find("#basic_search_input"+component_id);
    var initial_query_value = basic_search_query_input.val();
    var query_string = "";
    var query_prefix = basic_search_query_input.data("query-prefix");
    var query_suffix = basic_search_query_input.data("query-suffix");

    if(initial_query_value) {
        query_string = initial_query_value;
        if(query_prefix) {
            query_string = query_prefix + query_string;
        }
        if(query_suffix) {
            query_string = query_string + query_suffix;
        }
        basic_search_query_input.val(query_string.trim());
    }

    basic_search_query_input.val(query_string.trim());
    //Clear the prefix and suffix, ensure the value is what the user typed
    setTimeout(function(){
        basic_search_query_input.val(initial_query_value);
        },100);
}

//Sajari search code below
var sajariSetupHasRun = false;
function sajariSetup() {
    if(!sajariSetupHasRun) {
        function setup(c,a,f){function g(){var a=[],b=function(){a.push(arguments)};b.arr=a;c.sajari=c.sajari||{};c.sajari.ui=c.sajari.ui||[];c.sajari.ui.push(b);return b}var d=a.createElement("link");d.href=f;d.as="script";d.rel="preload";d.crossorigin=!0;var e=a.createElement("script");e.async=!0;e.src=f;a.head.appendChild(d);a.head.appendChild(e);a=g();a.init=function(a){var b=g();b(a);return b};return a};
        window.sajari = setup(window, document, "//cdn.sajari.net/js/integrations/website-search-1.4.js");
        sajariSetupHasRun = true;
    }
}
//This function returns a query string parameter value when provided the parameter
var getUrlParam = function(e){var t = new RegExp("[?&]" + e.replace(/[\[\]]/g, "\\$&") + "(=([^&#]*)|&|#|$)"),a = t.exec(window.location.href);return a && a[2] ? decodeURIComponent(a[2].replace(/\+/g, " ")) : ""};


function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        return uri + separator + key + "=" + value;
    }
}

$(".append_query_string").on("click", function (e) {
    var button_clicked = $(this);
    var button_href = button_clicked.attr("href");
    var query_parameter_to_append = button_clicked.data("queryparameter");
    var query_parameter_to_append_alias = button_clicked.data("queryparameteralias");
    var query_parameter_value = getUrlParam(query_parameter_to_append);

    if(query_parameter_to_append_alias && query_parameter_to_append_alias.length > 0) {
        button_clicked.attr("href", updateQueryStringParameter(button_href, query_parameter_to_append_alias, query_parameter_value));
    } else {
        button_clicked.attr("href", updateQueryStringParameter(button_href, query_parameter_to_append, query_parameter_value));
    }
});



function initSajariSearch(settings, targetUrl) {
    sajariSetup();
    var tab_filters = {};
    var base_filter = "";

    if(settings.baseFilter.baseFilterType === "yes") {
        base_filter = settings.baseFilter.baseFilterField + settings.baseFilter.baseFilterOperator + "'" + settings.baseFilter.baseFilterValue + "'";
    } else if(settings.baseFilter.baseFilterType === "custom") {
        base_filter = settings.baseFilter.baseFilterCustomString;
    }
    if(settings.tabs.length > 0) {

        var tabs_array = [];
        for (var i = 0; i < settings.tabs.length; i++) {
            var current_tab = settings.tabs[i];
            var current_tab_filter = "";
            if(i === 0) {
                tab_filters.defaultTab = current_tab.filterTabTitle;
            }

            if(current_tab.filterTabCustomString.length > 0) {
                current_tab_filter = current_tab.filterTabCustomString;
            } else if(current_tab.filterTabField !== "none") {
                current_tab_filter = current_tab.filterTabField + current_tab.filterTabOperator + "'" +current_tab.filterTabValue + "'";
            }

            tabs_array.push({
                title:current_tab.filterTabTitle,
                filter:current_tab_filter})
        }
        tab_filters.tabs = tabs_array;
    }

    var searchInterface = sajari.init({
        mode: settings.mode,
        project: settings.project, // Set this to your project.
        collection: settings.collection, // Set this to your collection.
        pipeline: settings.pipeline,     // Set the search pipeline.
        instantPipeline: settings.instantPipeline, // Set the instant pipeline.
        inputMode: settings.inputMode,
        attachSearchBox: document.getElementById(settings.attachSearchBoxId), // DOM element to render search box.
        attachSearchResponse: document.getElementById(settings.attachSearchResponseId), // DOM element to render search results.
        inputPlaceholder: settings.inputPlaceholder, // Placeholder text for the search box.
        inputAutoFocus: settings.inputAutoFocus, // Focus the input element on render.
        maxSuggestions: settings.maxSuggestions, // Maximum number of suggestions to show.
        results: {"showImages": settings.results.showImages }, // Configure the results.
        values: {"q.override": true, "resultsPerPage": settings.values.resultsPerPage,"q": getUrlParam("q"), "filter":base_filter}, // Set default values.
        tabFilters: tab_filters,
        styling: {}
    });

    if (targetUrl) {
        searchInterface("sub", "pipeline.search-sent", function(event, values) {
            window.location = targetUrl + "?q=" + encodeURIComponent(values.q);
        });
    }

}

//TODO(JD) - consolidate the sajari setup portion of this code, abstract the Find and expert specific parts.
function initFindAnExpert(settings) {

    var placeholder_search_value = "";
    var q_value_is_null = false;

    var filter_settings = {};
    if(settings.flindersSearchType === "find_an_expert") {
        filter_settings = settings.findAnExpertSettings.filterSettings;
    }
    var search_filters = {researcher:false,supervisor:false,mediaexpert:false};

    //The following 3 lines of code come from the Sajari site integration code generation, which is why it is minified. The structure of "searchInterface()" works for 1.4 and needs to be changed for 1.2
    var getUrlParam = function (e) { var t = new RegExp("[?&]" + e.replace(/[\[\]]/g, "\\$&") + "(=([^&#]*)|&|#|$)"), a = t.exec(window.location.href); return a && a[2] ? decodeURIComponent(a[2].replace(/\+/g, " ")) : "" };
    var setup = function (w, d, x, a, e, s, c, r) { s = []; var b = function () { s.push(arguments); }, q = "ui"; b.arr = s; w[a] = w[a] || []; w[a][q] = w[a][q] || []; w[a][q].push(b); c = d.createElement(x); c.async = 1; c.src = e; r = d.getElementsByTagName(x)[0]; r.parentNode.insertBefore(c, r); return b; };
    var searchInterface = setup(window, document, "script", "sajari", "//cdn.sajari.net/js/integrations/website-search-1.4.js");

    searchInterface({
        mode: settings.mode,
        project: settings.project, // Set this to your project.
        collection: settings.collection, // Set this to your collection.
        pipeline: settings.pipeline,     // Set the search pipeline.
        instantPipeline: settings.instantPipeline, // Set the instant pipeline.

        attachSearchBox: document.getElementById(settings.attachSearchBoxId), // DOM element to render search box.
        attachSearchResponse: document.getElementById(settings.attachSearchResponseId), // DOM element to render search results.

        inputMode: settings.inputMode,
        inputPlaceholder: settings.inputPlaceholder, // Placeholder text for the search box.
        inputAutoFocus: settings.inputAutoFocus, // Focus the input element on render.
        maxSuggestions: settings.maxSuggestions, // Maximum number of suggestions to show.
        results: { "showImages": settings.results.showImages}, // Configure the results.
        values: {"q.override": true, "resultsPerPage": settings.values.resultsPerPage, "q": getUrlParam("q"), "filter" : getSearchFilterString()}, // Set default values.
        updateQueryStringParam : true,
        styling: {
            theme: {
                layout: { type: "list" }
            }
        }
    });

    //Checkbox bindings
    $('#researcher_filter').on('change', function(){
        search_filters.researcher = $(this).is(":checked");
        updateSearchFilters();
    });
    $('#supervisor_filter').on('change', function(){
        search_filters.supervisor = $(this).is(":checked");
        updateSearchFilters();
    });
    $('#media_expert_filter').on('change', function(){
        search_filters.mediaexpert = $(this).is(":checked");
        updateSearchFilters();
    });

    //this function is checking if the element is ***partially*** visible
    //We use this to check if the results are not visible but the search box is.
    //NOTE(JD): This could be more general for use elsewhere, but there is a jquery plugin that does this and a bit more too...
    function checkIfElementIsVisible(element_container) {
        var top_of_element = element_container.offset().top;
        var bottom_of_element = top_of_element + element_container.outerHeight();

        var viewport_top = $(window).scrollTop();
        var viewport_bottom = viewport_top + $(window).height();

        return !(top_of_element > viewport_bottom || bottom_of_element < viewport_top);
    }

    //This is capturing empty searches, so the filter triggered searches can be aware of that.
    searchInterface("sub", "pipeline.values-updated", function(eventName, values) {
        if(values.hasOwnProperty("q")) {
            q_value_is_null = values.q == null;
        }
    });

    //The instantPipeline is the pipeline used to get suggestions
    //We are hooking into this to ensure the results when clicking a filter search against a real team, and correctly update the querystring when doing so.
    searchInterface("sub", "instantPipeline.response-updated", function(eventName, values) {
        if(settings.inputMode === "suggestions") {
            if((typeof values.values === "undefined" && typeof values.queryValues === "undefined")) {
                placeholder_search_value = "";
            } else {
                if(values.getValues().has("q")) {
                    var response_value = values.getValues().get("q");
                    if(response_value == null) {
                        placeholder_search_value = "";
                    } else {
                        placeholder_search_value = response_value;
                    }
                } else if(values.getQueryValues().has("q")) {
                    var current_query_value = values.getQueryValues().get("q");
                    if(current_query_value == null) {
                        placeholder_search_value = "";
                    } else {
                        placeholder_search_value = current_query_value;
                    }
                }
            }
        }
    });

    //Used to format the search results visually
    searchInterface("sub", "pipeline.response-updated", function(eventName, response) {
        //If the search box is visible but the search is not, when results are displayed - scroll the user to the location slowly.
        //Even if it is empty
        var main_results_container = $("#"+settings.attachSearchResponseId);
        var main_search_container = $("#"+settings.attachSearchBoxId);
        if(!checkIfElementIsVisible(main_results_container) && checkIfElementIsVisible(main_search_container)) {
            $.scrollTo(main_search_container.offset().top-200, 1500, 'easeInOutExpo');
        }

        //When the search is emptied (e.g. text deleted) in suggestions mode, the q value is null, so the filters trigger a search using it. We are watching for that and making sure the filters always search with an empty string.
        //Sajari handles this for their inputs (search box enter and search icon button) by not displaying any results, but a manual search publish from our code does not get the same smarts.
        if(settings.inputMode === "suggestions") {
            if(typeof response.values === "undefined" && typeof response.queryValues === "undefined") {
                placeholder_search_value = "";
                q_value_is_null = true;
            } else if(response.getQueryValues().has("q")) {
                var current_query_value = response.getQueryValues().get("q");
                if(current_query_value == null) {
                    placeholder_search_value = "";
                } else {
                    placeholder_search_value = current_query_value;
                }
            }
        }

        if (response.isEmpty()) {
            return;
        }
        if (response.isError()) {
            console.log("Sajari search error:", response.getError());
        } else {

            var results_container = $(".results_container");
            var all_results = results_container.find(".sj-results__result");
            var sj_paginator = results_container.find(".sj-paginator");
            all_results.each(function () {
                var current_result_item = $(this);

                //Select and mutate title
                var result_title = current_result_item.find(".sj-results__result__title > h3");
                var result_title_text = result_title.text();
                result_title_text = result_title_text.replace(" - Flinders University", "");
                result_title.text(result_title_text);
                //select and mutate description
                var result_description = current_result_item.find(".sj-results__result__description:not(.result_desc_decoded)");
                if(result_description.length > 0) {
                    var result_description_html = result_description.html();
                    //Fun jquery way to decode !
                    var decode = $('<div />').html(result_description_html).text();
                    decode = decode.replace(" | ", "<br>");
                    result_description.html(decode);
                    //Flag the element as already decoded, so we don't bother decoding a second time.
                    result_description.addClass("result_desc_decoded");
                }
            });
            //fade in all the results to obscure the mutation
            all_results.fadeIn();
            sj_paginator.addClass("show_paginator");

        }
    });

    function getSearchFilterString() {
        var base_filter_string = settings.values.baseFilter;
        var filter_string = "";
        var current_query_lower = getUrlParam("q").toLowerCase();
        var use_strict_filters = false;
        var researcher_locked = false;
        var supervisor_locked = false;
        var media_expert_locked = false;
        var filter_operator = "AND";
        var additionalFilters = [];

        if(!jQuery.isEmptyObject(filter_settings)) {
            use_strict_filters = filter_settings.useStrictFilters;
            researcher_locked = filter_settings.researcherFilter.isLocked;
            supervisor_locked = filter_settings.supervisorFilter.isLocked;
            media_expert_locked = filter_settings.mediaExpertFilter.isLocked;
            filter_operator = filter_settings.filterOperator;
        }

        if(search_filters.researcher || researcher_locked) {
            if(use_strict_filters) {
                additionalFilters.push("researcher='true' AND research_expertise~'"+current_query_lower+"'");
            } else {
                additionalFilters.push("researcher='true'");
            }
        }
        if(search_filters.supervisor || supervisor_locked) {
            if(use_strict_filters) {
                additionalFilters.push("supervisor='true' AND supervisory_interests~'"+current_query_lower+"'");
            } else {
                additionalFilters.push("supervisor='true'");
            }
        }
        if(search_filters.mediaexpert || media_expert_locked) {
            if(use_strict_filters) {
                additionalFilters.push("mediaexpert='true' AND (media_expertise~'"+current_query_lower+"' OR media_interests~'"+current_query_lower+"')");
            } else {
                additionalFilters.push("mediaexpert='true'");
            }
        }
        if(additionalFilters.length > 0) {
            filter_string += base_filter_string +" AND ("+additionalFilters.join(" "+filter_operator+" ")+")";
        } else {
            filter_string = base_filter_string;
        }
        return filter_string;
    }

    function updateSearchFilters() {

        //NOTE: JD - this code could be more concise, but have chosen to be verbose because:
        //suggestions mode and typeahead mode have several overlaps, but here it is important to keep them separate because the behave differently, and different hacks for each might need to be applied.
        if(settings.inputMode === "suggestions") {
            if(q_value_is_null) {
                searchInterface("pub", "pipeline.values-set", { "q": "", filter: getSearchFilterString() });
            } else if(placeholder_search_value !== getUrlParam("q")) {
                searchInterface("pub", "pipeline.values-set", { "q": placeholder_search_value, filter: getSearchFilterString() });
            } else {
                searchInterface("pub", "pipeline.values-set", { filter: getSearchFilterString() });
            }
        } else if (settings.inputMode === "typeahead") {
            if(q_value_is_null) {
                searchInterface("pub", "pipeline.values-set", { "q": "", filter: getSearchFilterString() });
            } else {
                searchInterface("pub", "pipeline.values-set", { filter: getSearchFilterString() });
            }
        }
        searchInterface("pub", "pipeline.search-send");
    }
}

function initQuickSearch(tags, tag_operator, quick_search_id) {

    var course_api_url = getQuickSearchUrl(tags, tag_operator);

    $(document).ready(function() {
        $.ajax({
            method: "GET",
            url: course_api_url
        }).done(function (data){
            populateQuicksearchDropdown(data, quick_search_id);
        });
    });
}

function getQuickSearchUrl(tags, operator) {
    var tag_filters = tags.split(",");
    var courses_api_url = "/flinders-services/courses.json";
    var API_TAG_FILTERS_PARAMETER = "tagFilters.";
    var API_TAG_FILTERS_OPERATOR_PARAMETER = "tagFiltersOperator.";
    var suffix = "";
    if(tags !== "" && tag_filters.length > 0) {
        for (var i = 0; i < tag_filters.length; i++) {
            suffix+=API_TAG_FILTERS_PARAMETER + tag_filters[i]+".";
        }
        suffix += API_TAG_FILTERS_OPERATOR_PARAMETER + operator;
    }

    return courses_api_url+(suffix?("/"+suffix  + ".json"):"");
}

function populateQuicksearchDropdown(data, quick_search_id) {
    //TODO: Investigate using tags to define "known groups" so data can be grouped by something other than study type
    var STUDY_TYPE_PROPERTY = "studyTypes";
    var SHOW_RECENT_GROUP_NAME = "Recently viewed";
    var SHOW_RECENT_GROUP_KEY = "recentlyViewed";
    var dropdown_data = [];

    var course_groups = ["Undergraduate","Major","Honours","Graduate","Postgraduate","Research higher degree"];
    var non_course_groups = [];
    // var found_groups = [];
    var the_select_box = $("#"+quick_search_id);
    var select_box_parent = the_select_box.closest(".quicksearch");
    var midyear_svg = select_box_parent.find("#"+quick_search_id+"__midyear_icon");
    var show_satac_codes = (select_box_parent.data("show-satac-codes") === "yes");
    var show_cricos_codes = (select_box_parent.data("show-cricos-codes") === "yes");

    var show_recent = (select_box_parent.data("show-recent-items") === "yes");
    var recent_items_limit = parseInt(select_box_parent.data("recent-items-limit"));

    //Group data by study area
    //TODO: Might need to make this more generic if we wish to do custom groupings
    var grouped_courses = data.reduce(function (accumulator, course) {
        var course_study_types = course[STUDY_TYPE_PROPERTY];
        for(var i = 0; i < course_study_types.length; i++) {
            var key = course_study_types[i];
            if (!accumulator[key]) {
                accumulator[key] = [];
            }
            var group_id_to_append = key.replace(/\s+/g, '_').toLowerCase(); //Note: this converts "Research higher degree" to "research_higher_degree"
            accumulator[key].push(convertCourseObjectToSelect2(course, show_satac_codes, show_cricos_codes, group_id_to_append));
        }
        return accumulator;
    }, {});

    //Add the grouped courses data to the select2 data format
    for(var i = 0; i < course_groups.length; i++) {
        var current_group = course_groups[i];
        var group_object = {"text":"","children":[]};
        var current_group_courses = grouped_courses[current_group];
        group_object.text = current_group;
        if(current_group_courses != null && current_group_courses.length > 0) {
            group_object.children = current_group_courses;
            dropdown_data.push(group_object);
        }
    }

    if(show_recent) {
        non_course_groups.push(SHOW_RECENT_GROUP_NAME);
        var show_recent_group = loadSelect2ItemsFromLocalStorage(SHOW_RECENT_GROUP_NAME, SHOW_RECENT_GROUP_KEY, recent_items_limit);

        if(show_recent_group.children.length > 0) {
            dropdown_data.unshift(show_recent_group);
        }
    }

    //Init select2
    var placeholder_text = select_box_parent.data("placeholder-text");
    var max_height_class = select_box_parent.data("max-height-pixel-value");
    //TODO: Allow max results per category/group setting
    //var max_results_per_group = select_box_parent.data("max-results-per-category");
    var show_midyear_indicator = (select_box_parent.data("show-midyear-indicator") === "yes");

    var select2options = {
        width: '100%',
        placeholder: placeholder_text,
        theme: 'flinders',
        data: dropdown_data,
        allowClear: true,
        maximumSelectionLength: 1,
        dropdownCssClass: max_height_class,
        dropdownAutoWidth: false,
        escapeMarkup: function(markup) {
            return markup;
        },
        templateResult: function (item) {
            // No need to template the searching text
            if (item.loading) {
                return item.text;
            }
            var term = query.term || '';
            return markMatch(item, term, show_midyear_indicator, midyear_svg);
        },
        language: {
            searching: function (params) {
                query = params;
                return 'Searching…';
            },
            "noResults": function(){
                var term = query.term || '';

                return "No results found, try using our <a href='/search?q="+term+"'>website search</a>.";
            }
        }
    };
    renderSelect2Dropdown(the_select_box, select2options);

    //Note: these events are only defined once

    //Unbind mousewheel event, which allows the results to be scrolled
    the_select_box.on("select2:open", function(e) {
        var results_container = $("#select2-"+quick_search_id+"-results");
        results_container.off("mousewheel");
    });

    //Define what the url will be when a user clicks on an item
    var querystring_parameter = select_box_parent.data("query-parameter");
    var querystring_value = select_box_parent.data("query-value");
    var open_in_new_tab = (select_box_parent.data("open-in-new-tab") === "yes");

    the_select_box.on('select2:select', function (e) {
        var item_selected = e.params.data;
        var item_link = item_selected.strLink;
        if(querystring_parameter != null && querystring_value != null) {
            item_link = updateQueryStringParameter(item_link, querystring_parameter, querystring_value);
        }
        the_select_box.val(null).trigger('change'); //this line clears the selection from the input area

        if(show_recent) {
            saveSelect2ItemToLocalStorage(item_selected, SHOW_RECENT_GROUP_KEY);

            var show_recent_group = loadSelect2ItemsFromLocalStorage(SHOW_RECENT_GROUP_NAME, SHOW_RECENT_GROUP_KEY, recent_items_limit);

            if(show_recent_group.children.length > 0) {
                //Remove old recently viewed group
                dropdown_data = dropdown_data.filter(function( obj ) {
                    return obj.text !== SHOW_RECENT_GROUP_NAME;
                });
                dropdown_data.unshift(show_recent_group);

                select2options.data = dropdown_data;
                renderSelect2Dropdown(the_select_box, select2options);
                the_select_box.trigger('change');
            }
        }

        if(open_in_new_tab) {
            window.open(item_link, '_blank');
        } else {
            window.location = item_link;
        }
    });

    the_select_box.on('select2:opening', function (e) {
        var MIN_DROPDOWN_HEIGHT = 150;
        var SCROLL_DURATION = 500;

        var viewport_top = $(window).scrollTop();
        var selectbox_offset = the_select_box.offset().top;
        if(selectbox_offset - viewport_top > MIN_DROPDOWN_HEIGHT) {
            $.scrollTo(the_select_box.offset().top-MIN_DROPDOWN_HEIGHT, SCROLL_DURATION, {easing:'easeInOutExpo'});
        }
    });


    //TODO(JD): Perhaps we should decide on something more meaningful for this to do?
    select_box_parent.find(".quicksearch_icon").on("click", function(e) {
        e.preventDefault();
        the_select_box.select2('open');
    });
}

function renderSelect2Dropdown(base_element, select2options) {
    base_element.empty();
    base_element.select2(select2options);
    base_element.closest(".quicksearch").fadeIn();
}

//Persist recent selections into localStorage
function saveSelect2ItemToLocalStorage(item, group) {
    var MAX_GROUP_SIZE = 25; //NOTE: This could be any number within reason, 25 seems like a reasonable maximum to keep the size on the small side.
    var item_id_prefix = group+"_";
    var selected_item_id = item.id;
    //Check if it already has the prefix, probably because they clicked on an item in the recently viewed list.
    var has_prefix = selected_item_id.indexOf(item_id_prefix) === 0; //Specifically that the ID *starts* with the prefix, we don't care if it randomly occurs

    if(!has_prefix) {
        item.id = item_id_prefix + selected_item_id;
    }
    item.selected = false; //We have to set the item to not selected otherwise select2 will think it is selected!!

    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.quickSearchData = Object.assign({}, userProfile.quickSearchData);
    var quickSearchData = userProfile.quickSearchData;

    if(quickSearchData[group]) {
        //Filter out items with the same ID
        quickSearchData[group] = quickSearchData[group].filter(function( obj ) {
            return obj.id !== item.id;
        });
        quickSearchData[group].unshift(item);
        //Prevent the array of items from getting too big
        if(quickSearchData[group].length > MAX_GROUP_SIZE) {
            quickSearchData[group].length = MAX_GROUP_SIZE;
        }
    } else {
        quickSearchData[group] = [item];
    }

    setLocalStorageObject('userProfile', userProfile);
}

//Function will return items in the "group" format that select2 expects
function loadSelect2ItemsFromLocalStorage(group_name, group_key, limit) {
    //NOTE: Limit is only the display limit, the limit with regards to data storage is defined in code, not a component config.
    if(!limit) {
        limit = 5;
    }
    var group_object = {"text":group_name,"children":[]};
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.quickSearchData = Object.assign({}, userProfile.quickSearchData);
    var quickSearchData = userProfile.quickSearchData;

    if(quickSearchData.hasOwnProperty(group_key)) {
        var group_items = userProfile.quickSearchData[group_key];

        if(group_items.length > 0) {
            if(limit) {
                group_object.children = group_items.splice(0, limit);
            } else {
                group_object.children = group_items;
            }
        }
    }

    return group_object;
}

//Select2 is fairly strict with its data structure.
function convertCourseObjectToSelect2(course, show_satac_codes, show_cricos_codes, group_id) {

    var converted_course_object = {"id":"","text":"","strLink":"","satac":"","cricos":"","midyear":""};
    var course_text = course.name;
    var satac_code = course.hasOwnProperty("satacCode") ? course.satacCode : "";
    var cricos_code = course.hasOwnProperty("cricosCode") ? course.cricosCode : "";
    var codes = [];

    converted_course_object["id"] = course.id.toString() + "_"+group_id;
    converted_course_object["strLink"] = course.strLink;
    converted_course_object["midyear"] = course.hasOwnProperty("midYearEntry") ? course.midYearEntry : false;

    if(show_satac_codes && satac_code) {
        converted_course_object["satac"] = satac_code;
        codes.push("SATAC: "+satac_code);
    }
    if(show_cricos_codes && cricos_code) {
        converted_course_object["cricos"] = cricos_code;
        codes.push("CRICOS: "+cricos_code);
    }
    if(codes.length > 0) {
        course_text += " — "+codes.join(", ");
    }
    converted_course_object["text"] = course_text;

    return converted_course_object;
}

//New version of select 2 does not make visually indicating the matches in the search results as obvious
//Note(JD): this only wraps the *first* matching term, not all matching terms. This provides almost all of the benefits with a greatly improved performance.
//TODO: Investigate methods of multi-highlighting that does not hurt performance with 400+ results.
function markMatch (item, term, show_midyear_indicator, midyear_svg) {
    var item_text = item.text;
    var $result = $('<span></span>');
    var midyear_icon = midyear_svg.html();
    var match = item_text.toUpperCase().indexOf(term.toUpperCase());

    if(match !== -1) {
        $result.html(item_text.substring(0, match)); //Append first part, before the match
        var $match = $('<mark class="select2-rendered__match"></mark>'); //Define the match wrapping class
        $match.html(item_text.substring(match, match + term.length)); //Insert the matching text into the wrapping class
        $result.append($match); //Append the wrapped term to the pre-term string
        $result.append(item_text.substring(match + term.length)); //Append everything after the match to the term.

    } else {
        $result.html(item_text);
    }

    if(show_midyear_indicator && item.midyear) {
        $result.append(midyear_icon);
    }

    return $result;
}

$(function () {
    var PRINT_ONLY = "print-only";
    var NOT_FULL_ON_PRINT = "not-full-on-print";

    var handleImages = function () {
        $(".section a:has(img)").each(function () {
            var spanPrintTemplate = "<span class='print-only' style='display: none;'></span>";

            var img = $(this).find("img");
            var altText = img.attr("alt");

            var printSpan = $(spanPrintTemplate).text(altText);
            $(this).append(printSpan);
        });
    };

    var handleColumnsOfImages = function(){
        var rows = $(".img-fluid").parents(".row");

        //Only applies if more than one image on the same row and there is no accordion
        rows.each(function () {
            if($(this).find("img").length > 1 && $(this).has(".accordion").length === 0)
                $(this).children().addClass(NOT_FULL_ON_PRINT);

        });
    };

    var handleTitle = function () {
        var headerComponent = $(".header_image_component");

        headerComponent.find("p").each(function () {
            if ($(this).html()) {
                headerComponent.addClass(PRINT_ONLY);
            }
        });
    };

    var handleReadMoreButton = function () {
        $(".read_more").addClass(PRINT_ONLY);
    };

    //The deepest column should be marked in other to apply specific css rules for those columns
    var markDeepestColumns = function(){
        $(".component_section").deepest(".row").children().addClass("deepest-column");
    };

    //Columns which doesn't have image (mainly text) should be breakable
    var markNoImageColumns = function(){
        $(".deepest-column").not(":has(img)").addClass("no-image-column");
    };

    var preparePage = function () {
        handleColumnsOfImages();
        handleImages();
        handleTitle();
        handleReadMoreButton();
        markDeepestColumns();
        markNoImageColumns();
    };

    var init = function () {
        preparePage();
    }

    init();
});



//Note: This is a placeholder file and not yet part of the grunt build
//This file will handle all functions that deal with cookies, localStorage and similar

var custom_application_cookies = {}; //todo- store cookie function type like "functional, marketing etc
var custom_application_local_storage_keys = {}; //Note: probably should have information about the "type" of local storage, much like cookies it is subject to the same guidelines.

var cookie_whitelist;
var cookie_blacklist;

//TODO - cookies to change to localstorage
// var cookie_expire_int = 90;
// var dom_int_tooltip_cookie_name = "tooltip_closed";
// var geo_location_cookie_name = '9k8KDFG23jIT5BNmwd83jflp28fj';
// var location_cookie_name = 'L923DF8dff830dfj2ft3f82mvhao4';

function getCookieByName(cookieName) {
    //TODO
}

function ZZsetCookie(cookieName, cookieValue, expiry) {
    //TODO
}

function deleteCookieByName(cookieName) {
    //TODO
}

//Function to check if local storage is available, to be extended if the future requires a different check...
function isLocalStorageSupported() {
    return window.localStorage;
}
//Function to check if cookies are available, to be extended if the future requires a different check...
function areCookiesEnabled() {
    try {
        document.cookie = 'cookietest=1';
        var cookiesEnabled = document.cookie.indexOf('cookietest=') !== -1;
        document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
        return cookiesEnabled;
    } catch (e) {
        return false;
    }
}
//A function to migrate our custom application cookies to localStorage
function syncCookiesIntoLocalStorage() {
    //TODO - if localStorage is supported, find any pre-defined cookies and move them into it. Then delete those cookies
    //Might need to call this in functions that call "setCookie"
    if(isLocalStorageSupported()) {
        //TODO
    }
}


//NOTE: Some private browsers (Notably Safari on iOS) will throw exceptions when trying to setItem()
//so we should wrap all the functions in a try-catch instead of directly caling window.localstorage.setItem();
function setLocalStorageObject(key, object){
    //TODO(Christof): should this maybe return the object actually stored (or undefined if not stored)?
    try{
        if(isLocalStorageSupported()){
            localStorage.setItem(key, JSON.stringify(object));
            return true;
        }
    } catch(error) {
        console.error("Browser has thrown an error when trying to save to local storage :(", error);
    }
    return false;
}

function getLocalStorageObject(key){
    try{
        if(isLocalStorageSupported()){
             var retrievedObject = localStorage.getItem(key);
             return JSON.parse(retrievedObject);
        }
    } catch (error){
        console.error("Browser has thrown an error when trying to retrieve from local storage :(", error);
    }
    return;
}

function countsAsUTMField(name){
    return name.indexOf('utm_') === 0;
}

var MAX_UTM_TIMESTAMP_AGE = 60 * 60 *1000;//1hour

function __saveUTMToLocalStorage(){
    var queryString = window.location.search;

    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.utmCampaignData = Object.assign({}, userProfile.utmCampaignData);
    var utmCampaignData = userProfile.utmCampaignData;


    var urlParams = new CustomURLSearchParams(queryString);
    var currentCampaignData = {};
    var campaignKey = "";
    urlParams.forEach(function(value, key){
        if(countsAsUTMField(key)){
            currentCampaignData[key]=value;
            campaignKey += key+"_"+value;
        }
    });

    if(campaignKey){
        var currentTime = (new Date()).getTime();
        var recent = false;
        if(utmCampaignData[campaignKey]){
            for(var tindex = 0; tindex <  utmCampaignData[campaignKey].time.length; tindex++){
                if(utmCampaignData[campaignKey] && (currentTime - utmCampaignData[campaignKey].time[tindex] < MAX_UTM_TIMESTAMP_AGE )){
                    recent = true;
                }
            }
            if(!recent){
                utmCampaignData[campaignKey].time.push(currentTime);
            }
        }else{
            utmCampaignData[campaignKey] = {time: [currentTime], data:currentCampaignData};
        }
    }
    setLocalStorageObject('userProfile', userProfile);
}

function toTimeStampString(timestamp){
    var date =new Date(timestamp);
    var h = date.getHours();
    var m = date.getMinutes();
    if(h<10){
        h= "0"+h;
    }
    if(m<10){
        m="0"+m;
    }
    return date.toLocaleDateString("en-AU")+ " "+h+":"+m;
}

function __popUTMFromLocalStorage(){
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));

    var additionalProps = {timeStamp:""};

    //setup all keys we'll encounter
     for(var cindex in userProfile.utmCampaignData){
            var cdata = userProfile.utmCampaignData[cindex].data;
            for(var key in cdata){
                additionalProps[key] = "";
            }
     }

    for(var cindex in userProfile.utmCampaignData){
        var cdata = userProfile.utmCampaignData[cindex].data;
        for(var tindex =0;tindex < userProfile.utmCampaignData[cindex].time.length; tindex++){
            var ctime = toTimeStampString(userProfile.utmCampaignData[cindex].time[tindex]);

            additionalProps['timeStamp'] += ctime;

            for(var key in cdata){
                additionalProps[key] += cdata[key];
            }

            //ensure all keys have a (potentially empty!) value, this is so that all sets of values match up,
            //e.g. if utm_campaign doesn't exist for a link, the fields will still line up when comma separated
            for(var key in additionalProps){
                additionalProps[key] += ',';
            }
        }
    }

    for(var key in additionalProps){
        //remove trailing commas
        additionalProps[key] = additionalProps[key].slice(0,-1);
    }

    for(var index = 0 ; index < jotforms_to_update.length; index++){
        if(jotforms_to_update[index].utm_update){
  		    jotforms_to_update[index].props = Object.assign(jotforms_to_update[index].props,additionalProps);
  		}
  	}
    fixJotformPrepops();
}

function __saveUTMToCookies(){
    //TODO: actually implement this if we decide we want to fall back to it?
    console.error("cookies for UTM campaign tracking not yet supported!");
}

function __popUTMFromCookies(){
    //TODO: actually implement this if we decide we want to fall back to it?
    console.error("cookies for UTM campaign tracking not yet supported!");
}


var saveUTMData = function(){console.error("saveUTMData called before we've figured out whether to use localstorage or cookies!");};
var populateUTMData = function(){console.error("populateUTMData called before we've figured out whether to use localstorage or cookies!");};

$(function(){
    if(typeof window.CustomURLSearchParams === 'undefined'){
        window.CustomURLSearchParams = function(querystring){
            this.data = {};
            if(querystring.indexOf('?') == 0){
                querystring = querystring.slice(1);
            }
            var vars = querystring.split("&");
            for (var i=0;i<vars.length;i++) {
                var pair = vars[i].split("=");
                this.data[pair[0]] = decodeURIComponent(pair[1]);
            }
        };

        window.CustomURLSearchParams.prototype.forEach = function(func){
            for(var index in this.data){
                func(this.data[index], index);
            }
        }
    }

    if(isLocalStorageSupported()){
        saveUTMData = __saveUTMToLocalStorage;
        populateUTMData = __popUTMFromLocalStorage;
    }
    else if(areCookiesEnabled()){
        saveUTMData = __saveUTMToCookies;
        populateUTMData = __popUTMFromCookies;
    }
    else{
        saveUTMData = function(){console.log("Not saving UTM data as both local storage or cookies are unavailable.");};
        populateUTMData = function(){console.log("Not populating UTM data as bot local storage or cookies are unavailable.");};
    }
    //NOTE(Christof): we want to guarantee that the population runs after the save - this matters if the campaign
    //                link goes directly to the page with the form on it, as we plan to be using the cache for pages with utm_* query strings
    //                probably the querystring prepopulation code for jotforms will need to be rewritten then anyway?? ¯\_(ツ)_/¯
    RegisterPostGDPRHook(function(){saveUTMData(); populateUTMData();});


    //This is simply to separate the UTM specific functions from the user history functions
    RegisterPostGDPRHook(function(){populateUserProfileHistory();});

});

function PageVisit(pageUrl, pageTitle, tags, time) {
    this.url = pageUrl;
    this.title = pageTitle;
    this.tags = tags;
    this.time = time;
}

function populateUserProfileHistory() {
    var MAX_USER_PROFILE_HISTORY_SIZE = 100;
    var PAGE_VISITS_KEY = "pageVisits";
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.history = Object.assign({}, userProfile.history);
    var history = userProfile.history;

    var page_url = window.location.href;
    var clean_page_title = $("meta[property='page_title_clean']").prop("content");
    var page_title =  clean_page_title ? clean_page_title : document.title;
    var page_content_tags = getPageContentTags();
    var current_time = (new Date()).getTime();

    var current_page = new PageVisit(page_url, page_title, page_content_tags, current_time);

    if(history[PAGE_VISITS_KEY]) {
        history[PAGE_VISITS_KEY].unshift(current_page);
        //Prevent the array from getting too big
        if(history[PAGE_VISITS_KEY].length > MAX_USER_PROFILE_HISTORY_SIZE) {
            history[PAGE_VISITS_KEY].length = MAX_USER_PROFILE_HISTORY_SIZE;
        }
    } else {
        history[PAGE_VISITS_KEY] = [current_page];
    }
    setLocalStorageObject('userProfile', userProfile);
}

function getContentAffinitiesFromUserProfileHistory() {
    //Placeholder
}

function getUserProfileContentTags() {
    var questionnaire_tags = getUserProfileQuestionnaireTags();
    var user_profile_content_tags = [];
    if(questionnaire_tags) {
        for(var key in questionnaire_tags) {
            user_profile_content_tags.push(questionnaire_tags[key].path);
        }
    }
    return user_profile_content_tags;
}

function getUserProfileQuestionnaireTags() {
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.questionnaireTags = Object.assign({}, userProfile.questionnaireTags);
    return userProfile.questionnaireTags;
}

function saveUserProfileQuestionnaireTags(userContentTags) {
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.questionnaireTags = Object.assign({}, userProfile.questionnaireTags);
    userProfile.questionnaireTags = userContentTags;
    setLocalStorageObject('userProfile', userProfile);
}

function getUserProfileSystemLinks() {
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.systemLinks = Object.assign({}, userProfile.systemLinks);
    return userProfile.systemLinks;
}

function saveUserProfileSystemLinks(systemLinks) {
    var userProfile = Object.assign({},getLocalStorageObject('userProfile'));
    userProfile.systemLinks = Object.assign({}, userProfile.systemLinks);
    userProfile.systemLinks = systemLinks;
    setLocalStorageObject('userProfile', userProfile);
}

//Returns an array of content tags or an empty array if none
function getPageContentTags() {
    //Note(JD): Specifically this returns an array wrapped in a jquery object without the "get()" on the end, we want a simple array because we are sticking this in local storage!
    return $("meta[property=content_tag]").map(function () {
        return $(this).prop("content");
    }).get();
}

$(document).ready(function () {
    initQuestionnaires();
    displaySectionsBasedOnUserProfileContentTags();
});

function initQuestionnaires() {
    //Prepop needs to happen before we bind events, otherwise we might bind an event to an input, then update that input, causing the event to trigger
    prePopQuestionsFromUserContentTags();

    $(".js-questionnaire-save-button").on("click", function (e) {
        updateUserContentTags($(this));
        displaySectionsBasedOnUserProfileContentTags();
    });

    $(".js-questionnaire-question-select").change(function() {
        var parent_questionnaire_container = $(this).closest(".js-questionnaire-container");
        var questionnaire_update_method = parent_questionnaire_container.data("update-method");
        if(questionnaire_update_method === "auto") {
            updateUserContentTags($(this));
            displaySectionsBasedOnUserProfileContentTags();
        }
    });

    $(".js-questionnaire-cancel").on("click", function (e) {
        e.preventDefault();
        saveUserProfileQuestionnaireTags([]);
        displaySectionsBasedOnUserProfileContentTags();
    });
}

function prePopQuestionsFromUserContentTags() {
    var user_profile_content_tags = getUserProfileQuestionnaireTags();
    var all_questions_on_page = $(".js-question-container");
    if(user_profile_content_tags && all_questions_on_page.length) {
        for(var key in user_profile_content_tags) {
            var content_tag_id = key;
            var content_tag_path = user_profile_content_tags[key].path;
            var matching_questions = all_questions_on_page.filter("[data-question-id='"+content_tag_id+"']");
            //Shouldn't be more than one of the same id...but ya never know...
            matching_questions.each(function(){
                var current_question = $(this);
                if(current_question.data("question-type") === "select") {
                    var current_question_element_id = current_question.data("question-unique-id");
                    $("#"+current_question_element_id).val(content_tag_path).change();
                }
            });
        }
    }
}

function UserProfileContentTag(tagPath, tagTitle, questionType, profileType) {
    this.path = tagPath;
    this.title = tagTitle;
    this.questionType = questionType;
    this.type = profileType;
}

function updateUserContentTags(triggering_element) {
    var user_profile_content_tags = getUserProfileQuestionnaireTags();
    var parent_questionnaire_container = triggering_element.closest(".js-questionnaire-container");
    var parent_questionnaire_type = parent_questionnaire_container.data("profile-type");
    var questions = parent_questionnaire_container.find(".js-question-container");
    questions.each(function (index) {
        var current_question = $(this);
        var current_question_type = current_question.data("question-type");
        var current_question_id = current_question.data("question-id");
        var current_question_element_id = current_question.data("question-unique-id");
        var current_question_answer_text = "";
        var current_question_answer_value = "";

        //NOTE(JD) - If we plan to support several different types of question, then the selectors might be quite different.
        if(current_question_type === "select") {
            var current_question_selected_option = $("#"+current_question_element_id).find("option:selected");
            current_question_answer_text = current_question_selected_option.text().trim();
            current_question_answer_value = current_question_selected_option.val();
        }

        if(current_question_id) {
            if(current_question_answer_value) {
                user_profile_content_tags[current_question_id] = new UserProfileContentTag(current_question_answer_value, current_question_answer_text, current_question_type, parent_questionnaire_type);
            } else {
                delete user_profile_content_tags[current_question_id];
            }
        }
    });
    saveUserProfileQuestionnaireTags(user_profile_content_tags);
}

function displaySectionsBasedOnUserProfileContentTags() {
    var NO_TAGS_MODE = "noTags";
    var MATCH_TAGS_MODE = "matchTags";
    var EXCLUDE_TAGS_MODE = "excludeTags";
    var user_content_tags = getUserProfileContentTags();
    var is_authoring = $('.aem_author_mode').length > 0;
    var all_content_tag_sections = $(".content_tag_section");
    if(is_authoring) {
        all_content_tag_sections.show();
    } else {
        all_content_tag_sections.each(function (index) {
            var current_section = $(this);
            var current_section_content_tag_mode = current_section.data("content-tag-mode");
            var current_section_content_tags = current_section.data("content-tags");

            switch (current_section_content_tag_mode) {
                case NO_TAGS_MODE:
                    if(user_content_tags.length === 0) {
                        current_section.fadeIn();
                    } else {
                        current_section.hide();
                    }
                    break;
                case MATCH_TAGS_MODE:
                    current_section_content_tags = current_section_content_tags.split(",");
                    if(user_content_tags.length) {
                        var tag_match_found = false;
                        for (var i = 0; i < user_content_tags.length; i++) {
                            if (current_section_content_tags.indexOf(user_content_tags[i]) !== -1) {
                                tag_match_found = true;
                                break;
                            }
                        }

                        if (tag_match_found) {
                            current_section.fadeIn();
                        } else {
                            current_section.hide();
                        }
                    } else {
                        current_section.hide();
                    }
                    break;
                case EXCLUDE_TAGS_MODE:
                    current_section_content_tags = current_section_content_tags.split(",");
                    if(user_content_tags.length) {
                        //We want to check to make sure the user (does not) have any matching tags
                        var exclude_tag_match_found = false;
                        for (var i = 0; i < user_content_tags.length; i++) {
                            if (current_section_content_tags.indexOf(user_content_tags[i]) !== -1) {
                                exclude_tag_match_found = true;
                                break;
                            }
                        }

                        if(exclude_tag_match_found) {
                            current_section.hide();
                        } else {
                            current_section.fadeIn();
                        }
                    } else {
                        current_section.hide();
                    }
                    break;
                default:
                    current_section.hide();
                    console.log('WARNING: NO MATCH FOR MODE',current_section_content_tag_mode,"section",current_section);
            }
        });
    }
}

var EDIT_MODE_CLASS = "system-links--edit";
var HIDDEN_ITEMS_EXPANDED_CLASS = "system-links__hidden-items--expanded";

var system_links_init_run = false;

function initSystemLinksComponents() {
    var is_authoring = $('.aem_author_mode').length > 0;

    if(!system_links_init_run && !is_authoring) {
        try {
            loadAndDisplaySystemLinks();
            bindSystemLinksEvents();
            //Set run toggle
            system_links_init_run = true;
        } catch (e) {
            console.error("Error when trying to init system links components!",e);
        }
    }
}
function loadAndDisplaySystemLinks() {
    var all_system_links_components = $(".system-links");
    all_system_links_components.each(function ()  {
        var current_system_link_component = $(this);
        loadSystemLinksOrder(current_system_link_component);

        var current_system_link_component_items = current_system_link_component.find(".system-links__item");

        //Fade the items in *this* system links component one after another
        fadeToRecursive(150, 1, $.makeArray(current_system_link_component_items));
    });
}

function bindSystemLinksEvents() {
    $(".system-links__show-hidden-button").on("click", function (event) {
        event.preventDefault();
        var show_hidden_button_clicked = $(this);
        var show_hidden_button_clicked_icon = show_hidden_button_clicked.find(".system-links__show-hidden-button-icon");
        var parent_system_links_component = show_hidden_button_clicked.closest(".system-links");
        var hidden_items_container = parent_system_links_component.find(".system-links__hidden-items");
        if(parent_system_links_component.hasClass(EDIT_MODE_CLASS)) {
            //is in edit mode so don't expand or collapse - also the expend/collapse thing will be hidden.
            return;
        }
        if (hidden_items_container.hasClass(HIDDEN_ITEMS_EXPANDED_CLASS)) {
            //collapse hidden items
            hidden_items_container.removeClass(HIDDEN_ITEMS_EXPANDED_CLASS);
            hidden_items_container.slideUp();
            show_hidden_button_clicked_icon.switchClass("fa-chevron-up","fa-chevron-down");
            show_hidden_button_clicked.find(".system-links__show-hidden-button-text").text(show_hidden_button_clicked.data("expand-text"));
        } else {
            //expand hidden items
            hidden_items_container.addClass(HIDDEN_ITEMS_EXPANDED_CLASS);
            hidden_items_container.slideDown();
            show_hidden_button_clicked_icon.switchClass("fa-chevron-down", "fa-chevron-up");
            show_hidden_button_clicked.find(".system-links__show-hidden-button-text").text(show_hidden_button_clicked.data("collapse-text"));
        }
    });

    $(".system-links__configure-button").on("click", function (event) {
        event.preventDefault();
        var system_links_component = $(this).closest(".system-links");
        var system_links_item_containers = system_links_component.find(".system-links__items-container");
        var all_system_links = system_links_component.find(".system-links__item");

        if (system_links_component.hasClass(EDIT_MODE_CLASS)) {
            //cancel edit mode
            system_links_component.removeClass(EDIT_MODE_CLASS);
            // disable sorting
            system_links_item_containers
                .sortable({
                    disabled: true
                })
                .enableSelection();
            //so they can be scrolled against on mobile..
            all_system_links.removeClass("ui-sortable-handle");
            //disable keyboard shortcuts
            all_system_links.off("keydown.move_link");
        } else {
            //start edit mode
            system_links_component.addClass(EDIT_MODE_CLASS);
            //enable sorting
            system_links_item_containers
                .sortable({
                    disabled: false,
                    connectWith: ".system-links__items-container",
                    items: ".system-links__item",
                    update: function (event, ui) {
                        saveSystemLinksOrder(system_links_component);
                    }
                })
                .disableSelection();

            //enable keyboard shortcuts
            all_system_links.on("keydown.move_link", function (event) {
                var current_link_item = $(this);
                var parent_container_type = current_link_item.closest(".system-links__items-container").data("container-type");
                var new_item_loc = current_link_item;
                // left or up
                if (event.keyCode == 37 || event.keyCode == 38) {
                    if (current_link_item.prev(".system-links__item").length === 0) {
                        if (parent_container_type === "hidden") {
                            var visible_last_item = system_links_component.find(".system-links__visible-items .system-links__item").last();
                            new_item_loc = current_link_item.insertAfter(visible_last_item);
                        }
                    } else {
                        new_item_loc = current_link_item.insertBefore(current_link_item.prev());
                    }
                    saveSystemLinksOrder(system_links_component);
                }
                // right or down
                if (event.keyCode == 39 || event.keyCode == 40) {
                    if (current_link_item.next(".system-links__item").length === 0) {
                        //At the end of the container, only move if is the visible container to the hidden container
                        if (parent_container_type === "visible") {
                            var hidden_first_item = system_links_component.find(".system-links__hidden-items .system-links__item").first();
                            new_item_loc = current_link_item.insertBefore(hidden_first_item);
                        }
                    } else {
                        new_item_loc = current_link_item.insertAfter(current_link_item.next());
                    }
                    saveSystemLinksOrder(system_links_component);
                }
                new_item_loc.find(".system-links__item-link").focus();
            });
        }
    });
}

function loadSystemLinksOrder(system_link_component) {
    var local_storage_system_links = getUserProfileSystemLinks();
    var system_link_component_id = system_link_component.find(".js-system-link-id").val();
    if(local_storage_system_links.hasOwnProperty(system_link_component_id)) {
        //Get system links object from local storage
        var saved_system_links = local_storage_system_links[system_link_component_id];
        var sync_local_storage = false;
        if(saved_system_links.hasOwnProperty("visible_items") && saved_system_links.visible_items.length > 0) {
            saved_system_links.visible_items = sortSystemLinksById(saved_system_links.visible_items, system_link_component, system_link_component.find(".system-links__visible-items"));
            sync_local_storage = true;
        }
        if(saved_system_links.hasOwnProperty("hidden_items") && saved_system_links.hidden_items.length > 0) {
            saved_system_links.hidden_items = sortSystemLinksById(saved_system_links.hidden_items, system_link_component, system_link_component.find(".system-links__hidden-items"));
            sync_local_storage = true;
        }

        if(sync_local_storage) {
            //We could do array comparisons and fancy filtering - but it is much more simple to replace with id's we know match valid elements after a load.
            //We could call saveSystemLinksOrder(system_link_component) after a load, but then we will miss the opportunity to highlight items that might be new in the future
            saveUserProfileSystemLinks(local_storage_system_links);
        }
    }
}

//NOTE(JD) - I didn't end up using my utility function sortDomElementsById() because I needed to go up one level as the ID's are attached to a child of the object I want to move.
function sortSystemLinksById(array_of_ids, system_link_component, item_container) {
    var valid_ids = [];
    while (array_of_ids.length) {
        var system_link_item_id = array_of_ids.pop();
        var system_link_item = system_link_component.find("#" + system_link_item_id).closest(".system-links__item");
        if(system_link_item.length > 0) {
            item_container.prepend(system_link_item);
            //collect ID's that actually match an element, return them to clean-up any ID's that might be stale
            valid_ids.unshift(system_link_item_id);
        }
    }
    return valid_ids;
}

//Save the user-defined order of the system links
function saveSystemLinksOrder(system_link_component) {
    var local_storage_system_links = getUserProfileSystemLinks();
    var system_link_component_id = system_link_component.find(".js-system-link-id").val();
    var visible_item_ids = system_link_component.find(".system-links__visible-items .system-links__item-link")
        .map(function () {
            return this.id;
        })
        .get();
    var hidden_item_ids = system_link_component.find(".system-links__hidden-items .system-links__item-link")
        .map(function () {
            return this.id;
        })
        .get();

    local_storage_system_links[system_link_component_id] = {
        visible_items: visible_item_ids,
        hidden_items: hidden_item_ids
    };

    saveUserProfileSystemLinks(local_storage_system_links);
}


/**
 * Data can often be a complicated mix of numbers and letters (file names
 * are a common example) and sorting them in a natural manner is quite a
 * difficult problem.
 *
 * Fortunately a deal of work has already been done in this area by other
 * authors - the following plug-in uses the [naturalSort() function by Jim
 * Palmer](http://www.overset.com/2008/09/01/javascript-natural-sort-algorithm-with-unicode-support) to provide natural sorting in DataTables.
 *
 *  @name Natural sorting
 *  @summary Sort data with a mix of numbers and letters _naturally_.
 *  @author [Jim Palmer](http://www.overset.com/2008/09/01/javascript-natural-sort-algorithm-with-unicode-support)
 *  @author [Michael Buehler] (https://github.com/AnimusMachina)
 *
 *  @example
 *    $('#example').dataTable( {
 *       columnDefs: [
 *         { type: 'natural', targets: 0 }
 *       ]
 *    } );
 *
 *    Html can be stripped from sorting by using 'natural-nohtml' such as
 *
 *    $('#example').dataTable( {
 *       columnDefs: [
 *    	   { type: 'natural-nohtml', targets: 0 }
 *       ]
 *    } );
 *
 */
/*
 * Sourced from Datatables GitHub Repository:
 * https://github.com/DataTables/Plugins/blob/master/sorting/natural.js
 *
 * More information:
 * https://datatables.net/plug-ins/sorting/natural
 */

(function() {

/*
 * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
 * Author: Jim Palmer (based on chunking idea from Dave Koelle)
 * Contributors: Mike Grier (mgrier.com), Clint Priest, Kyle Adams, guillermo
 * See: http://js-naturalsort.googlecode.com/svn/trunk/naturalSort.js
 */
function naturalSort (a, b, html) {
	var re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?%?$|^0x[0-9a-f]+$|[0-9]+)/gi,
		sre = /(^[ ]*|[ ]*$)/g,
		dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
		hre = /^0x[0-9a-f]+$/i,
		ore = /^0/,
		htmre = /(<([^>]+)>)/ig,
		// convert all to strings and trim()
		x = a.toString().replace(sre, '') || '',
		y = b.toString().replace(sre, '') || '';
		// remove html from strings if desired
		if (!html) {
			x = x.replace(htmre, '');
			y = y.replace(htmre, '');
		}
		// chunk/tokenize
	var	xN = x.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0'),
		yN = y.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0'),
		// numeric, hex or date detection
		xD = parseInt(x.match(hre), 10) || (xN.length !== 1 && x.match(dre) && Date.parse(x)),
		yD = parseInt(y.match(hre), 10) || xD && y.match(dre) && Date.parse(y) || null;

	// first try and sort Hex codes or Dates
	if (yD) {
		if ( xD < yD ) {
			return -1;
		}
		else if ( xD > yD )	{
			return 1;
		}
	}

	// natural sorting through split numeric strings and default strings
	for(var cLoc=0, numS=Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
		// find floats not starting with '0', string or 0 if not defined (Clint Priest)
		var oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc], 10) || xN[cLoc] || 0;
		var oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc], 10) || yN[cLoc] || 0;
		// handle numeric vs string comparison - number < string - (Kyle Adams)
		if (isNaN(oFxNcL) !== isNaN(oFyNcL)) {
			return (isNaN(oFxNcL)) ? 1 : -1;
		}
		// rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
		else if (typeof oFxNcL !== typeof oFyNcL) {
			oFxNcL += '';
			oFyNcL += '';
		}
		if (oFxNcL < oFyNcL) {
			return -1;
		}
		if (oFxNcL > oFyNcL) {
			return 1;
		}
	}
	return 0;
}

jQuery.extend( jQuery.fn.dataTableExt.oSort, {
	"natural-asc": function ( a, b ) {
		return naturalSort(a,b,true);
	},

	"natural-desc": function ( a, b ) {
		return naturalSort(a,b,true) * -1;
	},

	"natural-nohtml-asc": function( a, b ) {
		return naturalSort(a,b,false);
	},

	"natural-nohtml-desc": function( a, b ) {
		return naturalSort(a,b,false) * -1;
	},

	"natural-ci-asc": function( a, b ) {
		a = a.toString().toLowerCase();
		b = b.toString().toLowerCase();

		return naturalSort(a,b,true);
	},

	"natural-ci-desc": function( a, b ) {
		a = a.toString().toLowerCase();
		b = b.toString().toLowerCase();

		return naturalSort(a,b,true) * -1;
	}
} );

}());



	const hamburger = document.querySelector(".mobile-menu__hamburger");
	const navMenu = document.querySelector(".mobile-menu__nav-menu");
	const navLink = document.querySelectorAll(".mobile-menu__nav-link");

	var clickCount = 0;

if(hamburger)
{
	hamburger.addEventListener("click", mobileMenu);


	for (i = 0; i < navLink.length; i++) {
		navLink[i].addEventListener("click", closeMenu);
	}

	function mobileMenu() {
		clickCount++;
	    hamburger.classList.toggle("mobile-menu__hamburger-active");
	    navMenu.classList.toggle("active");
	    // add listener to disable scroll
		if (clickCount%2 == 0) {
			window.onscroll=function(){};
		}
		else{
			window.onscroll=function(){
				window.scrollTo(0, 0);
			};
		}
	}

	function closeMenu() {
		clickCount++;
		window.onscroll=function(){};
	    hamburger.classList.remove("mobile-menu__hamburger-active");
	    navMenu.classList.remove("active");
	}

}

/*
 * Initialisation code for the Data Table component
 */
"use strict";

( function( $ ) {
    if(!hamburger)
    {
        return;
    }
    // Execute code on document ready.
    $( document ).ready( function() {

        // Find the data tables and initialise them.
        $( ".data-table-component" ).each( function() {
            var table = $( this ).DataTable( {
                //responsive
                responsive: {
                    breakpoints: [
                        { name: 'desktop',  width: Infinity },
                        { name: 'tablet-l', width: 1200 },
                        { name: 'tablet-p', width: 992 },
                        { name: 'mobile-l', width: 576 },
                        { name: 'mobile-p', width: 320 }
                    ]
                },
               // position search bar and length.
                "dom": '<"pull-left top"f><"pull-right top"l>rt<"bottom"ip><"clear">',
                // Use the top header row for ordering.
                orderCellsTop: true,
                // Search icon and pagination.
                pagingType: 'input',
                language: {
                    search: "<i class='material-icons'>search</i>",
                    oPaginate: {
                        sNext: '<i class="material-icons">navigate_next</i>',
                        sPrevious: '<i class="material-icons">navigate_before</i>',
                        sFirst: '',
                        sLast: ''
                    }
                },
                // Adjust column specific settings.
                columnDefs: [
                    // Enable options for all columns.
                    {
                        targets: "_all", // Apply options to all columns.
                        type: "natural-nohtml", // Natural sorting without html.
                        render: {
                            "filter": function( data ) {
                                // Strip HTML tags from column items for searching / filtering only.
                                return data.replace(/(<([^>]+)>)/ig,"").trim();
                            }
                        }
                    }
                ],
                // Enable keyword highlighting.
                mark: true
            } );

            // Check to see if filtering is enabled.
            if ( $( this ).data( "enableFiltering" ) !== undefined ) {

                // Get a list of columns to disable if required.
                var noFilterList = $( this ).data( "disableFilterList" );
                if (noFilterList === undefined ) {
                    noFilterList = [];
                } else {
                    noFilterList = noFilterList.split( "," );
                }

                enableFiltering( table, noFilterList );

                table.on( "draw", function () {
                    enableFiltering( table, noFilterList );
                } );
            }

            // Check to see if initial column sorting has been specified.
            if ( $( this ).data("initSortColumn") !== undefined ) {
                // Get the name of the specified column.
                var initSortColumnName = $( this ).data( "initSortColumn" );
                initSortColumnName = initSortColumnName.trim().toLowerCase();

                var initSortColumnDir = $( this ).data( "initSortColumnDir" );

                if ( initSortColumnDir === undefined ) {
                    initSortColumnDir = "asc";
                } else {
                    initSortColumnDir = initSortColumnDir.trim().toLowerCase();
                }

                sortTable( table, initSortColumnName, initSortColumnDir );
            }
        } )
    } );

    // Add filtering capability to the table.
    // Based on example: http://live.datatables.net/gejojiqu/1/edit
    function enableFiltering( table, noFilterList ) {

        table.columns().every( function() {
            var column = table.column( this, { search: "applied" } );

            // Check to ensure column isn't in no filter list.
            if( noFilterList.includes( $(column.header()).text().trim().toLowerCase() ) === false ) {

                var select = $( '<select><option value=""></option></select>' )
                    .appendTo( $( table.table().header() ).find( "tr:eq(1) th" ).eq(column.index()).empty())
                    .on( "change", function() {
                        var val = $.fn.dataTable.util.escapeRegex( $( this ).val() );

                        column.search( val ? "^" + val + "$" : "", true, false )
                            .draw();
                    } );

                // Populate the dropdowns with a unique list of items from the column.
                // Use the data from the 'search' cache which is populated with the data for the 'filter' render.
                // AKA The trimmed cell value with HTML tags stripped.
                column.cache( "search" ).unique().sort().each( function( item ) {
                    select.append( '<option value="' + item + '">' + item + '</option>' );
                } );

                // The rebuild will clear the exisiting select, so it needs to be repopulated.
                var currSearch = column.search();
                if ( currSearch ) {
                    select.val( currSearch.substring(1, currSearch.length - 1 ) );
                }
            }
        } );
    }

    // Sort the table by a column specified by name.
    function sortTable( table, columnName, direction ) {
        // Get the list of columns and find the one that has been specified.
        table.columns().every( function() {
            // Match the column names.
            if ( columnName === $(this.header()).text().trim().toLowerCase() ) {
                // Set the sort order and redraw the table.
                this.order( direction );
                table.draw();
            }
        } );
    }

} )( jQuery );

/**
 * Sometimes for quick navigation, it can be useful to allow an end user to
 * enter which page they wish to jump to manually. This paging control uses a
 * text input box to accept new paging numbers (arrow keys are also allowed
 * for), and four standard navigation buttons are also presented to the end
 * user.
 *
 *  @name Navigation with text input
 *  @summary Shows an input element into which the user can type a page number
 *  @author [Allan Jardine](http://sprymedia.co.uk)
 *  @author [Gordey Doronin](http://github.com/GDoronin)
 *
 *  @example
 *    $(document).ready(function() {
 *        $('#example').dataTable( {
 *            "pagingType": "input"
 *        } );
 *    } );
 */

(function ($) {
    if(!hamburger)
    {
        return;
    }
    function calcDisableClasses(oSettings) {
        var start = oSettings._iDisplayStart;
        var length = oSettings._iDisplayLength;
        var visibleRecords = oSettings.fnRecordsDisplay();
        var all = length === -1;

        // Gordey Doronin: Re-used this code from main jQuery.dataTables source code. To be consistent.
        var page = all ? 0 : Math.ceil(start / length);
        var pages = all ? 1 : Math.ceil(visibleRecords / length);

        var disableFirstPrevClass = (page > 0 ? '' : oSettings.oClasses.sPageButtonDisabled);
        var disableNextLastClass = (page < pages - 1 ? '' : oSettings.oClasses.sPageButtonDisabled);

        return {
            'first': disableFirstPrevClass,
            'previous': disableFirstPrevClass,
            'next': disableNextLastClass,
            'last': disableNextLastClass
        };
    }

    function calcCurrentPage(oSettings) {
        return Math.ceil(oSettings._iDisplayStart / oSettings._iDisplayLength) + 1;
    }

    function calcPages(oSettings) {
        return Math.ceil(oSettings.fnRecordsDisplay() / oSettings._iDisplayLength);
    }

    var firstClassName = 'first';
    var previousClassName = 'previous';
    var nextClassName = 'next';
    var lastClassName = 'last';

    var paginateClassName = 'paginate';
    var paginatePageClassName = 'paginate_page';
    var paginateInputClassName = 'paginate_input';
    var paginateTotalClassName = 'paginate_total';

    $.fn.dataTableExt.oPagination.input = {
        'fnInit': function (oSettings, nPaging, fnCallbackDraw) {
            var nFirst = document.createElement('span');
            var nPrevious = document.createElement('span');
            var nNext = document.createElement('span');
            var nLast = document.createElement('span');
            var nInput = document.createElement('input');
            var nTotal = document.createElement('span');
            var nInfo = document.createElement('span');

            var language = oSettings.oLanguage.oPaginate;
            var classes = oSettings.oClasses;
            var info = language.info || 'Page _INPUT_ of _TOTAL_';

            nFirst.innerHTML = language.sFirst;
            nPrevious.innerHTML = language.sPrevious;
            nNext.innerHTML = language.sNext;
            nLast.innerHTML = language.sLast;

            nFirst.className = firstClassName + ' ' + classes.sPageButton;
            nPrevious.className = previousClassName + ' ' + classes.sPageButton;
            nNext.className = nextClassName + ' ' + classes.sPageButton;
            nLast.className = lastClassName + ' ' + classes.sPageButton;

            nInput.className = paginateInputClassName;
            nTotal.className = paginateTotalClassName;

            if (oSettings.sTableId !== '') {
                nPaging.setAttribute('id', oSettings.sTableId + '_' + paginateClassName);
                nFirst.setAttribute('id', oSettings.sTableId + '_' + firstClassName);
                nPrevious.setAttribute('id', oSettings.sTableId + '_' + previousClassName);
                nNext.setAttribute('id', oSettings.sTableId + '_' + nextClassName);
                nLast.setAttribute('id', oSettings.sTableId + '_' + lastClassName);
            }

            nInput.type = 'text';

            info = info.replace(/_INPUT_/g, '</span>' + nInput.outerHTML + '<span>');
            info = info.replace(/_TOTAL_/g, '</span>' + nTotal.outerHTML + '<span>');
            nInfo.innerHTML = '<span>' + info + '</span>';

            nPaging.appendChild(nFirst);
            nPaging.appendChild(nPrevious);
            $(nInfo).children().each(function (i, n) {
                nPaging.appendChild(n);
            });
            nPaging.appendChild(nNext);
            nPaging.appendChild(nLast);

            $(nFirst).click(function() {
                var iCurrentPage = calcCurrentPage(oSettings);
                if (iCurrentPage !== 1) {
                    oSettings.oApi._fnPageChange(oSettings, 'first');
                    fnCallbackDraw(oSettings);
                }
            });

            $(nPrevious).click(function() {
                var iCurrentPage = calcCurrentPage(oSettings);
                if (iCurrentPage !== 1) {
                    oSettings.oApi._fnPageChange(oSettings, 'previous');
                    fnCallbackDraw(oSettings);
                }
            });

            $(nNext).click(function() {
                var iCurrentPage = calcCurrentPage(oSettings);
                if (iCurrentPage !== calcPages(oSettings)) {
                    oSettings.oApi._fnPageChange(oSettings, 'next');
                    fnCallbackDraw(oSettings);
                }
            });

            $(nLast).click(function() {
                var iCurrentPage = calcCurrentPage(oSettings);
                if (iCurrentPage !== calcPages(oSettings)) {
                    oSettings.oApi._fnPageChange(oSettings, 'last');
                    fnCallbackDraw(oSettings);
                }
            });

            $(nPaging).find('.' + paginateInputClassName).keyup(function (e) {
                // 38 = up arrow, 39 = right arrow
                if (e.which === 38 || e.which === 39) {
                    this.value++;
                }
                // 37 = left arrow, 40 = down arrow
                else if ((e.which === 37 || e.which === 40) && this.value > 1) {
                    this.value--;
                }

                if (this.value === '' || this.value.match(/[^0-9]/)) {
                    /* Nothing entered or non-numeric character */
                    this.value = this.value.replace(/[^\d]/g, ''); // don't even allow anything but digits
                    return;
                }

                var iNewStart = oSettings._iDisplayLength * (this.value - 1);
                if (iNewStart < 0) {
                    iNewStart = 0;
                }
                if (iNewStart >= oSettings.fnRecordsDisplay()) {
                    iNewStart = (Math.ceil((oSettings.fnRecordsDisplay()) / oSettings._iDisplayLength) - 1) * oSettings._iDisplayLength;
                }

                oSettings._iDisplayStart = iNewStart;
                fnCallbackDraw(oSettings);
            });

            // Take the brutal approach to cancelling text selection.
            $('span', nPaging).bind('mousedown', function () { return false; });
            $('span', nPaging).bind('selectstart', function() { return false; });

            // If we can't page anyway, might as well not show it.
            var iPages = calcPages(oSettings);
            if (iPages <= 1) {
                $(nPaging).hide();
            }
        },

        'fnUpdate': function (oSettings) {
            if (!oSettings.aanFeatures.p) {
                return;
            }

            var iPages = calcPages(oSettings);
            var iCurrentPage = calcCurrentPage(oSettings);

            var an = oSettings.aanFeatures.p;
            if (iPages <= 1) // hide paging when we can't page
            {
                $(an).hide();
                return;
            }

            var disableClasses = calcDisableClasses(oSettings);

            $(an).show();

            // Enable/Disable `first` button.
            $(an).children('.' + firstClassName)
                .removeClass(oSettings.oClasses.sPageButtonDisabled)
                .addClass(disableClasses[firstClassName]);

            // Enable/Disable `prev` button.
            $(an).children('.' + previousClassName)
                .removeClass(oSettings.oClasses.sPageButtonDisabled)
                .addClass(disableClasses[previousClassName]);

            // Enable/Disable `next` button.
            $(an).children('.' + nextClassName)
                .removeClass(oSettings.oClasses.sPageButtonDisabled)
                .addClass(disableClasses[nextClassName]);

            // Enable/Disable `last` button.
            $(an).children('.' + lastClassName)
                .removeClass(oSettings.oClasses.sPageButtonDisabled)
                .addClass(disableClasses[lastClassName]);

            // Paginate of N pages text
            $(an).find('.' + paginateTotalClassName).html(iPages);

            // Current page number input value
            $(an).find('.' + paginateInputClassName).val(iCurrentPage);
        }
    };
})(jQuery);

$(document).ready(function(){

	function SetNavStickyness(Element, InPageNav, IsSticky, BoundingRect)
	{
		if(IsSticky) 
	    {
	    	Element.classList.add("static");
			Element.style.height = BoundingRect.height+'px';
			InPageNav.style.width = BoundingRect.width+'px';
	    }
	    else
	    {
	    	Element.classList.remove("static");
			Element.style.height = '';
			InPageNav.style.width = '';
	    }
	}
	

	function HasBeenScrolledPast (el, offset) {

	    var rect = el.getBoundingClientRect();
	    if(el.classList.contains("static"))
		{
			var rect = el.parentElement.getBoundingClientRect();
		}
	    return rect.top < offset;
	}


	function HasScrolledIntoView (el) {
		//TODO(Christof): should there be an epsilon here so that a single visible line of pixels is not enough?
	    var rect = el.getBoundingClientRect();
	    return rect.top < (window.innerHeight || document.documentElement.clientHeight);
	}


	function SetScrolledStatus(Link, ScrolledPast)
	{
		if(ScrolledPast)
		{
			Link.classList.add("scrolled_to");
		}
		else
		{
			Link.classList.remove("scrolled_to");
			Link.classList.remove("selected");
		}


		const ScrolledElements = Link.parentElement.parentElement.getElementsByClassName("scrolled_to");
		const SelectionElement = Link.parentElement.parentElement.getElementsByClassName("selection")[0].getElementsByClassName("link")[0];

		for(var ScrolledElementsIndex = 0; ScrolledElementsIndex < ScrolledElements.length; ScrolledElementsIndex++)
		{
			ScrolledElements[ScrolledElementsIndex].classList.remove("selected");
		}

		const SelectedElement = ScrolledElements[ScrolledElements.length -1];
		SelectedElement.classList.add("selected");

		SelectionElement.href = SelectedElement.href;
		SelectionElement.innerText = SelectedElement.innerText.replaceAll("\n", "");
	}

	function CreateStickyNav(InPageNav)
	{
		const MobileDefault = 70;
		const DesktopDefault = 64;
		const DesktopOffset = InPageNav.dataset.desktopOffset || DesktopDefault;
		const MobileOffset = InPageNav.dataset.mobileOffset|| MobileDefault;

		const DesktopHeight = InPageNav.dataset.desktopHeight || DesktopDefault;
		const MobileHeight = InPageNav.dataset.mobileHeight || MobileDefault;

		const ThisHash = InPageNav.id.replace("in_page_nav_","");
		var ThisStyling = document.getElementById("in_page_nav_style_"+ThisHash);
		if(!ThisStyling)
		{
			ThisStyling = document.createElement("style");
		}

		ThisStyling.innerHTML = "\n"+
"		#in_page_nav_"+ThisHash+"{\n"+
"				top: "+DesktopOffset+"px;\n"+
"				height: "+DesktopHeight+"px;\n"+
"			}\n"+
"\n"+
"			@media (max-width: 991px)\n"+
"			{\n"+
"				#in_page_nav_"+ThisHash+"{\n"+
"					top: "+MobileOffset+"px};\n"+
"					height: "+MobileHeight+"px};\n"+
"				}\n"+
"			}\n";

		ThisStyling.id="in_page_nav_style"+ThisHash;

		document.head.appendChild(ThisStyling);


		const DropDown = InPageNav.getElementsByClassName("selection")[0];

		function ClearDropDowns(event)
		{
			DropDown.parentElement.classList.remove("expanded");
			document.removeEventListener("click", ClearDropDowns);
		}

		
		DropDown.addEventListener("click", function(event){
			DropDown.parentElement.classList.toggle("expanded");
			if(DropDown.parentElement.classList.contains("expanded"))
			{
				setTimeout(function(){document.addEventListener("click", ClearDropDowns)}, 50);
			}
		});

		DropDown.getElementsByClassName("link")[0].onclick=function(event){return false;};
		
		var ElementsToWatch = [];
		const Links = InPageNav.getElementsByClassName("links")[0].getElementsByClassName("link");
		for(var LinkIndex = 0; LinkIndex < Links.length; LinkIndex++)
		{
			const Link = Links[LinkIndex];


			if(document.location.pathname ==  Link.pathname && Link.hash)
			{
				const SearchID = Link.hash.replace("#","");
				ElementsToWatch.push({Element:document.getElementById(SearchID), NavElement:Link});
			}
		}


		const MobileCheckOptions = {
			root:null,
			rootMargin: "-"+MobileOffset+"px 0px 0px 0px",
			threshold: 1.0,
		};


		const DesktopCheckOptions = {
			root:null,
			rootMargin: "-"+DesktopOffset+"px 0px 0px 0px",
			threshold: 1.0,
		};

		function InPageNavCheck(entries, offset)
		{
			entries.forEach(function (entry) {
			    var elem = entry.target;
			    const InPageNav = elem.getElementsByClassName("in_page_nav")[0];

			    SetNavStickyness(elem, InPageNav, !entry.isIntersecting && entry.boundingClientRect.top < offset, entry.boundingClientRect) 
			  });
		}

		function DektopInPageNavCheck(entries)
		{
			if(IsDesktop)
			{
				InPageNavCheck(entries, DesktopOffset);
			}
		}

		function MobileInPageNavCheck(entries)
		{
			if(!IsDesktop)
			{
				InPageNavCheck(entries, MobileOffset);
			}
		}


		const MobileNavObserver = new IntersectionObserver(MobileInPageNavCheck, MobileCheckOptions);
		const DesktopNavObserver = new IntersectionObserver(DektopInPageNavCheck, DesktopCheckOptions);

		MobileNavObserver.observe(InPageNav.parentElement);
		DesktopNavObserver.observe(InPageNav.parentElement);
		
		var LastScrollPosition = 0;

		addEventListener("scroll", function(event){
			const MAX_SCROLL_HEIGHT_BEFORE_CHECK = window.innerHeight;
			var ThisScrollPosition = window.scrollY;
			if(Math.abs(LastScrollPosition - ThisScrollPosition) > MAX_SCROLL_HEIGHT_BEFORE_CHECK)
			{
				for(var WatchIndex =0 ; WatchIndex < ElementsToWatch.length; WatchIndex++)
				{
					const thing = ElementsToWatch[WatchIndex];

					SetScrolledStatus(thing.NavElement, HasScrolledIntoView(thing.Element));
					
				}
				
				const elem = InPageNav.parentElement;
				const boundingRect = elem.getBoundingClientRect();
				if(!boundingRect.width)
				{
					boundingRect.width = boundingRect.right - boundingRect.left;
				}
				SetNavStickyness(elem, InPageNav, HasBeenScrolledPast(elem, IsDesktop ? DesktopOffset : MobileOffset), boundingRect);
				
			}
			LastScrollPosition = ThisScrollPosition;
		});


		const NavTargetOptionsMobile = {
			root:null,
			rootMargin: "-"+MobileOffset+"px 0px 0px 0px",
			threshold: 0.05,
		};

		const NavTargetOptionsDesktop = {
			root:null,
			rootMargin: "-"+DesktopOffset+"px 0px 0px 0px",
			threshold: 0.05,
		};

		function NavTargetCheck_(entries)
		{
			entries.forEach(function (entry) {
			    var elem = entry.target;
			    //TODO(Christof): should there be an epsilon here so that a single visible line of pixels is not enough?
			    const ScrolledIntoView = (entry.boundingClientRect.top < (window.innerHeight || document.documentElement.clientHeight));
			    SetScrolledStatus(elem.NavElement, ScrolledIntoView);
			});
			   
		}

		function MobileNavTargetCheck(entries)
		{
			if(!IsDesktop)
			{
				NavTargetCheck_(entries);
			}
		}

		function DesktopNavTargetCheck(entries)
		{
			if(IsDesktop)
			{
				NavTargetCheck_(entries);
			}
		}

		const MobileTargetObserver = new IntersectionObserver(MobileNavTargetCheck, NavTargetOptionsMobile);
		const DesktopTargetObserver = new IntersectionObserver(DesktopNavTargetCheck, NavTargetOptionsDesktop);

		for(var WatchIndex =0 ; WatchIndex < ElementsToWatch.length; WatchIndex++)
		{
			const thing = ElementsToWatch[WatchIndex];
			if(thing.Element.NavElement)
			{
				console.error("duplicate navigation links for target section:", thing.Element.NavElement, thing.NavElement, thing.Element);
			}
			thing.Element.NavElement= thing.NavElement;
			DesktopTargetObserver.observe(thing.Element);
			MobileTargetObserver.observe(thing.Element);
			
		}

		var IsDesktop = true;

		function DoResize(event){
			if(window.innerWidth > 991)
			{
				IsDesktop = true;
			}
			else
			{
				IsDesktop = false;
			}

			const PageWidth = window.innerWidth || document.documentElement.clientWidth;
		
			const elem = InPageNav.parentElement;
			const boundingRect = elem.getBoundingClientRect();
			if(!boundingRect.width)
			{
				boundingRect.width = boundingRect.right - boundingRect.left;
			}
			if(elem.classList.contains('static'))
			{
				elem.style.height = boundingRect.height+'px';
				InPageNav.style.width =  boundingRect.width+'px';
			}

			const WidthExtender = elem.getElementsByClassName("width_extension")[0];
			WidthExtender.style.left = -(PageWidth - boundingRect.width)/2+'px';

			const mobile_dropdown = InPageNav.getElementsByClassName("mobile_dropdown")[0].getElementsByClassName("options")[0];
			const links = InPageNav.getElementsByClassName("links")[0];

			if(IsDesktop)
			{
				const items = mobile_dropdown.getElementsByClassName("link");
				while(items.length >0 )
				{
					links.appendChild(items[0]);
				}
			}
			else
			{
				const items = links.getElementsByClassName("link");
				while(items.length >0 )
				{
					mobile_dropdown.appendChild(items[0]);
				}
			}

			for(var WatchIndex =0 ; WatchIndex < ElementsToWatch.length; WatchIndex++)
			{
				const thing = ElementsToWatch[WatchIndex];

				SetScrolledStatus(thing.NavElement, HasScrolledIntoView(thing.Element));
				
			}
			
		}

		DoResize();

		addEventListener("resize", DoResize);


	}


	const InPageNavs = document.getElementsByClassName("in_page_nav");

	
	for(var NavIndex = 0; NavIndex < InPageNavs.length; NavIndex++)
	{

		const InPageNav = InPageNavs[NavIndex];
		CreateStickyNav(InPageNav);
	
	}




	
	

})